import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  ENUM: { input: any; output: any; }
  GEOM: { input: any; output: any; }
  JSON: { input: any; output: any; }
  List: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export enum ActionName {
  Branch = 'BRANCH',
  BranchStatus = 'BRANCH_STATUS',
  BranchTiming = 'BRANCH_TIMING',
  DeliveryCancel = 'DELIVERY_CANCEL',
  DeliveryCreate = 'DELIVERY_CREATE',
  DeliveryStatus = 'DELIVERY_STATUS',
  Discount = 'DISCOUNT',
  Menu = 'MENU',
  MenuUpdate = 'MENU_UPDATE',
  Order = 'ORDER',
  OrderUpdate = 'ORDER_UPDATE',
  PaymentRefund = 'PAYMENT_REFUND',
  PaymentRequest = 'PAYMENT_REQUEST',
  PaymentStatus = 'PAYMENT_STATUS',
  PrimaryOrderUpdate = 'PRIMARY_ORDER_UPDATE',
  SecondaryOrderUpdate = 'SECONDARY_ORDER_UPDATE',
  StockStatusUpdate = 'STOCK_STATUS_UPDATE',
  StockUpdate = 'STOCK_UPDATE'
}

export enum ActionType {
  Pull = 'PULL',
  Push = 'PUSH'
}

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity: Scalars['String']['output'];
  collection: Scalars['String']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  item: Scalars['String']['output'];
  item_id: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


export type ActivityLogActivityArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogCollectionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ActivityLogIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogItemArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogItem_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ActivityLogUser_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ActivityLogUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogInput = {
  activity?: InputMaybe<Scalars['String']['input']>;
  collection?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  item_id?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type AddAddressInput = {
  address_line_one?: InputMaybe<Scalars['String']['input']>;
  area_code?: InputMaybe<Scalars['String']['input']>;
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  geom?: InputMaybe<GeomInput>;
  google_address?: InputMaybe<Scalars['String']['input']>;
  google_address_one?: InputMaybe<Scalars['String']['input']>;
  google_address_two?: InputMaybe<Scalars['String']['input']>;
  land_mark?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pin_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AddAddressResponse = {
  __typename?: 'AddAddressResponse';
  address_id?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
};

export enum AddCustomerType {
  End = 'END',
  None = 'NONE',
  Start = 'START'
}

export type Address = {
  __typename?: 'Address';
  address_line_one?: Maybe<Scalars['String']['output']>;
  address_line_two?: Maybe<Scalars['String']['output']>;
  area_code?: Maybe<Scalars['String']['output']>;
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  geom?: Maybe<Geom>;
  google_address?: Maybe<Scalars['String']['output']>;
  google_address_one?: Maybe<Scalars['String']['output']>;
  google_address_two?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  land_mark?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pin_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type AddressAddress_Line_OneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressAddress_Line_TwoArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressArea_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressBuildingArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressCityArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressCountryArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type AddressGoogle_AddressArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressGoogle_Address_OneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressGoogle_Address_TwoArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressLand_MarkArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressLocalityArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressPin_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressStateArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressStreetArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AddressUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AddressInput = {
  address_line_one?: InputMaybe<Scalars['String']['input']>;
  address_line_two?: InputMaybe<Scalars['String']['input']>;
  area_code?: InputMaybe<Scalars['String']['input']>;
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  geom?: InputMaybe<GeomInput>;
  google_address?: InputMaybe<Scalars['String']['input']>;
  google_address_one?: InputMaybe<Scalars['String']['input']>;
  google_address_two?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  land_mark?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pin_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AggFuncInput = {
  functions: Array<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type AggregatorIntegration = {
  __typename?: 'AggregatorIntegration';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AggregatorMis = {
  __typename?: 'AggregatorMIS';
  actual_no_of_bills: Scalars['Float']['output'];
  actual_sales: Scalars['Float']['output'];
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['Date']['output'];
  expected_no_of_bills: Scalars['Float']['output'];
  expected_sales: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  integration_code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type AggregatorMisActual_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type AggregatorMisActual_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type AggregatorMisBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AggregatorMisCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AggregatorMisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type AggregatorMisDateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type AggregatorMisExpected_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type AggregatorMisExpected_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type AggregatorMisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AggregatorMisIntegration_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AggregatorMisNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AggregatorMisSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AggregatorMisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AggregatorMisInput = {
  actual_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  actual_sales?: InputMaybe<Scalars['Float']['input']>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expected_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  expected_sales?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum ApplicationType {
  Admin = 'ADMIN',
  Billing = 'BILLING',
  CallCenter = 'CALL_CENTER',
  CustomerDisplay = 'CUSTOMER_DISPLAY',
  Kds = 'KDS',
  Link = 'LINK',
  OwnerApp = 'OWNER_APP',
  WebOrdering = 'WEB_ORDERING'
}

export type ApplyCouponResponse = {
  __typename?: 'ApplyCouponResponse';
  coupon_id?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Auth = {
  __typename?: 'Auth';
  active: Scalars['Boolean']['output'];
  app_version?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  jwt_invalidate?: Maybe<Scalars['Int']['output']>;
  last_app_open?: Maybe<Scalars['Datetime']['output']>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otp?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  profile_picture?: Maybe<Scalars['String']['output']>;
  profile_picture_encoding?: Maybe<Scalars['JSON']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type AuthActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AuthApp_VersionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type AuthEmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthJwt_InvalidateArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type AuthLast_App_OpenArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type AuthMobile_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthOtpArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthPasscodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthPasswordArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthProfile_PictureArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthTypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AuthData = {
  __typename?: 'AuthData';
  access_token: Scalars['String']['output'];
  id: Scalars['String']['output'];
  refresh_token: Scalars['String']['output'];
  user?: Maybe<Scalars['JSON']['output']>;
};

export type AuthInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  jwt_invalidate?: InputMaybe<Scalars['Int']['input']>;
  last_app_open?: InputMaybe<Scalars['Datetime']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profile_picture?: InputMaybe<Scalars['String']['input']>;
  profile_picture_encoding?: InputMaybe<Scalars['JSON']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Authorization = {
  __typename?: 'Authorization';
  action: Scalars['String']['output'];
  approval_reason?: Maybe<Scalars['String']['output']>;
  approved_by_id?: Maybe<Scalars['UUID']['output']>;
  approved_by_name?: Maybe<Scalars['String']['output']>;
  authorization_status: AuthorizationStatus;
  branch_id: Scalars['UUID']['output'];
  branch_name: Scalars['String']['output'];
  collection_name: Scalars['String']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  entity_id: Scalars['String']['output'];
  entity_name: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  mechanism: Mechanism;
  order_date: Scalars['Datetime']['output'];
  order_id: Scalars['UUID']['output'];
  order_total: Scalars['Float']['output'];
  permission_id?: Maybe<Scalars['UUID']['output']>;
  request_message?: Maybe<Scalars['String']['output']>;
  request_reason?: Maybe<Scalars['String']['output']>;
  requesting_user_id: Scalars['UUID']['output'];
  requesting_user_name: Scalars['String']['output'];
  role_id?: Maybe<Scalars['UUID']['output']>;
  update_uuid?: Maybe<Scalars['UUID']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type AuthorizationActionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationApproval_ReasonArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationApproved_By_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationApproved_By_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationAuthorization_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationBranch_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationCollection_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type AuthorizationEntity_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationEntity_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationMechanismArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationOrder_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type AuthorizationOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationOrder_TotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type AuthorizationPermission_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationRequest_MessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationRequest_ReasonArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationRequesting_User_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationRequesting_User_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationRole_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationUpdate_UuidArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AuthorizationInput = {
  action: Scalars['String']['input'];
  branch_id: Scalars['String']['input'];
  branch_name: Scalars['String']['input'];
  collection_name: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  entity_name: Scalars['String']['input'];
  invoice_number?: InputMaybe<Scalars['Int']['input']>;
  kot_number?: InputMaybe<Scalars['Int']['input']>;
  mechanism: Scalars['String']['input'];
  order_date: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
  order_total: Scalars['Float']['input'];
  request_message?: InputMaybe<Scalars['String']['input']>;
  request_reason?: InputMaybe<Scalars['String']['input']>;
  update_uuid: Scalars['String']['input'];
};

export enum AuthorizationStatus {
  Authorized = 'AUTHORIZED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  account_holder_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  bank_name: Scalars['String']['output'];
  branch_name: Scalars['String']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  ifsc_code: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type BankAccountAccount_Holder_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BankAccountAccount_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BankAccountBank_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BankAccountBranch_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BankAccountCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BankAccountIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BankAccountIfsc_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BankAccountUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BankAccountInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  branch_name?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  ifsc_code?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Banner = {
  __typename?: 'Banner';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  url: Scalars['String']['output'];
  website?: Maybe<Website>;
  website_id?: Maybe<Scalars['UUID']['output']>;
  website_instance?: Maybe<WebsiteInstance>;
  website_instance_id?: Maybe<Scalars['UUID']['output']>;
};


export type BannerCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BannerCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BannerDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BannerIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BannerNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BannerPriorityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BannerSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BannerUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BannerUrlArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BannerWebsite_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BannerWebsite_Instance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type BannerInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<WebsiteInput>;
  website_id?: InputMaybe<Scalars['UUID']['input']>;
  website_instance?: InputMaybe<WebsiteInstanceInput>;
  website_instance_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type BannerResponse = {
  __typename?: 'BannerResponse';
  descriptions: Array<Maybe<Scalars['String']['output']>>;
  domain?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  urls: Array<Maybe<Scalars['String']['output']>>;
};

export type Branch = {
  __typename?: 'Branch';
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['UUID']['output']>;
  bank_account?: Maybe<BankAccount>;
  bank_account_id?: Maybe<Scalars['UUID']['output']>;
  banners: Array<BranchBanner>;
  closing?: Maybe<Scalars['Time']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  contact_details_consumer_care?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  delivery_radius?: Maybe<Scalars['Int']['output']>;
  fssai_license_no: Scalars['String']['output'];
  gstin?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  images: Array<BranchImage>;
  instance?: Maybe<Instance>;
  instance_id: Scalars['UUID']['output'];
  invoice_number: Scalars['Int']['output'];
  invoice_prefix: Scalars['String']['output'];
  is_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_ondc_enabled?: Maybe<Scalars['Boolean']['output']>;
  kot_number: Scalars['Int']['output'];
  kot_prefix: Scalars['String']['output'];
  location: Scalars['String']['output'];
  long_desc?: Maybe<Scalars['String']['output']>;
  menus: Array<MenuBranch>;
  name?: Maybe<Scalars['String']['output']>;
  offline_invoice_number: Scalars['Int']['output'];
  offline_invoice_number_prefix: Scalars['String']['output'];
  offline_kot_number: Scalars['Int']['output'];
  offline_kot_number_prefix: Scalars['String']['output'];
  ondc_cod_available?: Maybe<Scalars['Boolean']['output']>;
  ondc_min_order_value?: Maybe<Scalars['Float']['output']>;
  ondc_storefront_id?: Maybe<Scalars['String']['output']>;
  opening?: Maybe<Scalars['Time']['output']>;
  pan?: Maybe<Scalars['String']['output']>;
  products: Array<BranchProduct>;
  schedule?: Maybe<Schedule>;
  schedule_id?: Maybe<Scalars['UUID']['output']>;
  sections: Array<Section>;
  shifts: Array<BranchShift>;
  short_desc?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  users: Array<User>;
};


export type BranchAddress_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchBank_Account_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchClosingArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type BranchCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchContact_Details_Consumer_CareArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchContact_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchContact_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchContact_PhoneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchDelivery_RadiusArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchFssai_License_NoArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchGstinArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchInvoice_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchInvoice_PrefixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIs_DisabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchIs_Ondc_EnabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchKot_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchKot_PrefixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchLocationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchLong_DescArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchOffline_Invoice_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchOffline_Invoice_Number_PrefixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchOffline_Kot_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchOffline_Kot_Number_PrefixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchOndc_Cod_AvailableArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchOndc_Min_Order_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchOndc_Storefront_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchOpeningArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type BranchPanArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSchedule_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShort_DescArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSymbolArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchAddOnResponse = {
  __typename?: 'BranchAddOnResponse';
  id: Scalars['String']['output'];
  is_enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type BranchBanner = {
  __typename?: 'BranchBanner';
  branch?: Maybe<Branch>;
  branch_banner_type: BranchBannerType;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  image_url: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type BranchBannerBranch_Banner_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchBannerBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchBannerCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchBannerCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchBannerIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchBannerImage_UrlArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchBannerSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchBannerUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchBannerInput = {
  branch?: InputMaybe<BranchInput>;
  branch_banner_type?: InputMaybe<BranchBannerType>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum BranchBannerType {
  FullScreen = 'FULL_SCREEN',
  HalfScreen = 'HALF_SCREEN'
}

export type BranchCategoryResponse = {
  __typename?: 'BranchCategoryResponse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BranchImage = {
  __typename?: 'BranchImage';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  image_type: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type BranchImageBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchImageCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchImageCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchImageIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchImageImageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchImageImage_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchImageSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchImageUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchImageInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_type?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchInput = {
  address?: InputMaybe<AddressInput>;
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  bank_account?: InputMaybe<BankAccountInput>;
  bank_account_id?: InputMaybe<Scalars['UUID']['input']>;
  banners?: InputMaybe<Array<InputMaybe<BranchBannerInput>>>;
  closing?: InputMaybe<Scalars['Time']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  contact_details_consumer_care?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  delivery_radius?: InputMaybe<Scalars['Int']['input']>;
  fssai_license_no?: InputMaybe<Scalars['String']['input']>;
  gstin?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  images?: InputMaybe<Array<InputMaybe<BranchImageInput>>>;
  instance?: InputMaybe<InstanceInput>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  invoice_number?: InputMaybe<Scalars['Int']['input']>;
  invoice_prefix?: InputMaybe<Scalars['String']['input']>;
  is_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_ondc_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  kot_number?: InputMaybe<Scalars['Int']['input']>;
  kot_prefix?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  long_desc?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<Array<InputMaybe<MenuBranchInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  offline_invoice_number?: InputMaybe<Scalars['Int']['input']>;
  offline_invoice_number_prefix?: InputMaybe<Scalars['String']['input']>;
  offline_kot_number?: InputMaybe<Scalars['Int']['input']>;
  offline_kot_number_prefix?: InputMaybe<Scalars['String']['input']>;
  ondc_cod_available?: InputMaybe<Scalars['Boolean']['input']>;
  ondc_min_order_value?: InputMaybe<Scalars['Float']['input']>;
  ondc_storefront_id?: InputMaybe<Scalars['String']['input']>;
  opening?: InputMaybe<Scalars['Time']['input']>;
  pan?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<BranchProductInput>>>;
  schedule?: InputMaybe<ScheduleInput>;
  schedule_id?: InputMaybe<Scalars['UUID']['input']>;
  sections?: InputMaybe<Array<InputMaybe<SectionInput>>>;
  shifts?: InputMaybe<Array<InputMaybe<BranchShiftInput>>>;
  short_desc?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  users?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

export type BranchIntegration = {
  __typename?: 'BranchIntegration';
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  integration_id: Scalars['UUID']['output'];
  integration_name: Scalars['String']['output'];
  is_online: Scalars['Boolean']['output'];
  is_successful: Scalars['Boolean']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type BranchIntegrationBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIntegrationCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIntegrationCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchIntegrationIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIntegrationIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIntegrationIntegration_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIntegrationIs_OnlineArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchIntegrationIs_SuccessfulArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchIntegrationSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchIntegrationUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchIntegrationInput = {
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  integration_name?: InputMaybe<Scalars['String']['input']>;
  is_online?: InputMaybe<Scalars['Boolean']['input']>;
  is_successful?: InputMaybe<Scalars['Boolean']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum BranchIntegrationStatus {
  InProgress = 'IN_PROGRESS',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type BranchProduct = {
  __typename?: 'BranchProduct';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_enabled: Scalars['Boolean']['output'];
  max_order_quantity: Scalars['Int']['output'];
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  quantity: Scalars['Int']['output'];
  status_logs: Array<ProductStatusLog>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type BranchProductBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProductCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProductCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchProductIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProductIs_EnabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchProductMax_Order_QuantityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchProductProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProductQuantityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchProductSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProductUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchProductInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  max_order_quantity?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  status_logs?: InputMaybe<Array<InputMaybe<ProductStatusLogInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchProductLogResponse = {
  __typename?: 'BranchProductLogResponse';
  integration_name: Scalars['String']['output'];
  is_successful: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_on: Scalars['String']['output'];
};

export type BranchProductResponse = {
  __typename?: 'BranchProductResponse';
  children?: Maybe<Array<Maybe<BranchProductResponse>>>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_enabled?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<ProductLogType>>>;
  name: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
};

export type BranchReportInput = {
  id: Scalars['String']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type BranchResponse = {
  __typename?: 'BranchResponse';
  id: Scalars['String']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BranchSetting = {
  __typename?: 'BranchSetting';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  setting?: Maybe<Setting>;
  setting_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  value: Scalars['JSON']['output'];
};


export type BranchSettingBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSettingCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSettingCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchSettingIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSettingSetting_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSettingSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchSettingUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchSettingInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  setting?: InputMaybe<SettingInput>;
  setting_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type BranchSettingResponse = {
  __typename?: 'BranchSettingResponse';
  branch_setting_id: Scalars['String']['output'];
  branch_setting_value: Scalars['String']['output'];
  setting_app_type: Scalars['String']['output'];
  setting_choices: Scalars['List']['output'];
  setting_column_type: Scalars['String']['output'];
  setting_description: Scalars['String']['output'];
  setting_id: Scalars['ID']['output'];
  setting_name: Scalars['String']['output'];
  setting_type: Scalars['String']['output'];
};

export type BranchShift = {
  __typename?: 'BranchShift';
  amount?: Maybe<Scalars['Float']['output']>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  branch_shift_type?: Maybe<BranchShiftType>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  parent_id?: Maybe<Scalars['UUID']['output']>;
  status: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


export type BranchShiftAmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type BranchShiftBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftBranch_Shift_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchShiftIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftParent_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftStatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchShiftUser_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchShiftUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type BranchShiftInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  branch_shift_type?: InputMaybe<BranchShiftType>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  parent_id?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export enum BranchShiftType {
  Day = 'DAY',
  Shift = 'SHIFT'
}

export type BranchStatusLog = {
  __typename?: 'BranchStatusLog';
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  integration_id: Scalars['UUID']['output'];
  integration_name: Scalars['String']['output'];
  is_successful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type BranchStatusLogBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type BranchStatusLogIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogIntegration_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogIs_SuccessfulArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchStatusLogMessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogStatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type BranchStatusLogUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchStatusLogInput = {
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  integration_name?: InputMaybe<Scalars['String']['input']>;
  is_successful?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BranchStatusResponse = {
  __typename?: 'BranchStatusResponse';
  branch_id: Scalars['String']['output'];
  branch_integration_id: Scalars['String']['output'];
  branch_name: Scalars['String']['output'];
  integration_id: Scalars['String']['output'];
  is_online: Scalars['Boolean']['output'];
  is_successful: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
};

export type BranchSyncResponse = {
  __typename?: 'BranchSyncResponse';
  closing?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  instance?: Maybe<InstanceResponse>;
  instance_id?: Maybe<Scalars['UUID']['output']>;
  last_shift?: Maybe<LastShiftResponse>;
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offline_invoice_number?: Maybe<Scalars['Int']['output']>;
  offline_invoice_number_prefix?: Maybe<Scalars['String']['output']>;
  offline_kot_number?: Maybe<Scalars['Int']['output']>;
  opening?: Maybe<Scalars['String']['output']>;
};

export enum BugType {
  Data = 'DATA',
  Integration = 'INTEGRATION',
  Report = 'REPORT'
}

export type Cart = {
  __typename?: 'Cart';
  address_id?: Maybe<Scalars['UUID']['output']>;
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['UUID']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  coupon?: Maybe<Scalars['String']['output']>;
  coupon_id?: Maybe<Scalars['UUID']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customer_id?: Maybe<Scalars['UUID']['output']>;
  delivery_charge: Scalars['Float']['output'];
  free_dish?: Maybe<FreeDish>;
  free_dish_id?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  inline_items: Array<InlineItem>;
  instance_id?: Maybe<Scalars['UUID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order_date?: Maybe<Scalars['Date']['output']>;
  order_time?: Maybe<Scalars['Time']['output']>;
  order_type: Scalars['String']['output'];
  packaging_charge: Scalars['Float']['output'];
  parent_cart?: Maybe<Cart>;
  parent_id?: Maybe<Scalars['UUID']['output']>;
  section_id?: Maybe<Scalars['UUID']['output']>;
  service_charge: Scalars['Float']['output'];
  session_id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  sub_carts: Array<Cart>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  sub_section_id?: Maybe<Scalars['UUID']['output']>;
  sub_total: Scalars['Float']['output'];
  taxes?: Maybe<Scalars['JSON']['output']>;
  total: Scalars['Float']['output'];
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_tax: Scalars['Float']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  web_app_coupon?: Maybe<WebAppCoupon>;
};


export type CartAddress_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartCouponArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartCoupon_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CartCustomer_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartDelivery_ChargeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CartFree_Dish_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartNoteArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartOrder_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type CartOrder_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CartOrder_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartPackaging_ChargeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CartParent_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartSection_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartService_ChargeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CartSession_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartStatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartSub_Section_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CartSub_TotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CartTotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CartTotal_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CartTotal_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CartUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CartInput = {
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  coupon_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customer_id?: InputMaybe<Scalars['UUID']['input']>;
  delivery_charge?: InputMaybe<Scalars['Float']['input']>;
  free_dish?: InputMaybe<FreeDishInput>;
  free_dish_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  inline_items?: InputMaybe<Array<InputMaybe<InlineItemInput>>>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_date?: InputMaybe<Scalars['Date']['input']>;
  order_time?: InputMaybe<Scalars['Time']['input']>;
  order_type?: InputMaybe<Scalars['String']['input']>;
  packaging_charge?: InputMaybe<Scalars['Float']['input']>;
  parent_cart?: InputMaybe<CartInput>;
  parent_id?: InputMaybe<Scalars['UUID']['input']>;
  section_id?: InputMaybe<Scalars['UUID']['input']>;
  service_charge?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_carts?: InputMaybe<Array<InputMaybe<CartInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_section_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_total?: InputMaybe<Scalars['Float']['input']>;
  taxes?: InputMaybe<Scalars['JSON']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  total_discount?: InputMaybe<Scalars['Float']['input']>;
  total_tax?: InputMaybe<Scalars['Float']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  web_app_coupon?: InputMaybe<WebAppCouponInput>;
};

export type CartItem = {
  __typename?: 'CartItem';
  child_items: Array<Maybe<CartItem>>;
  children: Array<Maybe<CartItem>>;
  group_id?: Maybe<Scalars['String']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  item_level_discount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order_level_discount: Scalars['Float']['output'];
  parent_id?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  product_id: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  tax?: Maybe<Scalars['JSON']['output']>;
  tax_name?: Maybe<Scalars['String']['output']>;
  tax_percentage?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  total_item_level_discount: Scalars['Float']['output'];
  total_order_level_discount: Scalars['Float']['output'];
  total_tax: Scalars['Float']['output'];
  variant_level_one_id?: Maybe<Scalars['String']['output']>;
  variant_level_one_name?: Maybe<Scalars['String']['output']>;
  variant_level_two_id?: Maybe<Scalars['String']['output']>;
  variant_level_two_name?: Maybe<Scalars['String']['output']>;
};

export type CartResponse = {
  __typename?: 'CartResponse';
  address_id?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<BranchResponse>;
  branch_id?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Scalars['String']['output']>;
  coupon_id?: Maybe<Scalars['String']['output']>;
  delivery_charge: Scalars['Float']['output'];
  free_dish?: Maybe<FreeDishes>;
  free_dish_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inline_items?: Maybe<Array<Maybe<CartItem>>>;
  instance_id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order_date?: Maybe<Scalars['String']['output']>;
  order_time?: Maybe<Scalars['String']['output']>;
  order_type: Scalars['String']['output'];
  packaging_charge: Scalars['Float']['output'];
  parent_id?: Maybe<Scalars['String']['output']>;
  section_id?: Maybe<Scalars['String']['output']>;
  service_charge: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  sub_carts: Array<CartResponse>;
  sub_total: Scalars['Float']['output'];
  taxes?: Maybe<Scalars['JSON']['output']>;
  total: Scalars['Float']['output'];
  total_discount: Scalars['Float']['output'];
  total_tax: Scalars['Float']['output'];
};

export type Category = {
  __typename?: 'Category';
  category_schedule?: Maybe<CategorySchedule>;
  category_schedule_id?: Maybe<Scalars['UUID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  is_disabled?: Maybe<Scalars['Boolean']['output']>;
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  menus: Array<MenuCategory>;
  name: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  subcategories: Array<SubCategory>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CategoryCategory_Schedule_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CategoryDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryImageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryIs_DisabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CategoryNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategorySub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CategoryEntry = {
  __typename?: 'CategoryEntry';
  amount: Scalars['Float']['output'];
  item_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CategoryInput = {
  category_schedule?: InputMaybe<CategoryScheduleInput>;
  category_schedule_id?: InputMaybe<Scalars['UUID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  is_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  menus?: InputMaybe<Array<InputMaybe<MenuCategoryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  subcategories?: InputMaybe<Array<InputMaybe<SubCategoryInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CategoryMis = {
  __typename?: 'CategoryMIS';
  actual_no_of_bills: Scalars['Float']['output'];
  actual_sales: Scalars['Float']['output'];
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['Date']['output'];
  expected_no_of_bills: Scalars['Float']['output'];
  expected_sales: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CategoryMisActual_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CategoryMisActual_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CategoryMisBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryMisCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryMisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CategoryMisDateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type CategoryMisExpected_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CategoryMisExpected_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CategoryMisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryMisNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryMisSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryMisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CategoryMisInput = {
  actual_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  actual_sales?: InputMaybe<Scalars['Float']['input']>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expected_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  expected_sales?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CategorySchedule = {
  __typename?: 'CategorySchedule';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  day_1: Scalars['Boolean']['output'];
  day_2: Scalars['Boolean']['output'];
  day_3: Scalars['Boolean']['output'];
  day_4: Scalars['Boolean']['output'];
  day_5: Scalars['Boolean']['output'];
  day_6: Scalars['Boolean']['output'];
  day_7: Scalars['Boolean']['output'];
  end_time_1: Scalars['Time']['output'];
  end_time_2?: Maybe<Scalars['Time']['output']>;
  end_time_3?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  start_time_1: Scalars['Time']['output'];
  start_time_2?: Maybe<Scalars['Time']['output']>;
  start_time_3?: Maybe<Scalars['Time']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CategoryScheduleCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryScheduleCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CategoryScheduleDay_1Args = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryScheduleDay_2Args = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryScheduleDay_3Args = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryScheduleDay_4Args = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryScheduleDay_5Args = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryScheduleDay_6Args = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryScheduleDay_7Args = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryScheduleEnd_Time_1Args = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CategoryScheduleEnd_Time_2Args = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CategoryScheduleEnd_Time_3Args = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CategoryScheduleIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryScheduleNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryScheduleStart_Time_1Args = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CategoryScheduleStart_Time_2Args = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CategoryScheduleStart_Time_3Args = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CategoryScheduleSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryScheduleUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CategoryScheduleInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  day_1?: InputMaybe<Scalars['Boolean']['input']>;
  day_2?: InputMaybe<Scalars['Boolean']['input']>;
  day_3?: InputMaybe<Scalars['Boolean']['input']>;
  day_4?: InputMaybe<Scalars['Boolean']['input']>;
  day_5?: InputMaybe<Scalars['Boolean']['input']>;
  day_6?: InputMaybe<Scalars['Boolean']['input']>;
  day_7?: InputMaybe<Scalars['Boolean']['input']>;
  end_time_1?: InputMaybe<Scalars['Time']['input']>;
  end_time_2?: InputMaybe<Scalars['Time']['input']>;
  end_time_3?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_time_1?: InputMaybe<Scalars['Time']['input']>;
  start_time_2?: InputMaybe<Scalars['Time']['input']>;
  start_time_3?: InputMaybe<Scalars['Time']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sub_categories?: Maybe<Array<Maybe<SubCategoryType>>>;
};

export type ChangeLog = {
  __typename?: 'ChangeLog';
  collection: Scalars['String']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  item: Scalars['String']['output'];
  item_id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  new_value: Scalars['String']['output'];
  old_value?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


export type ChangeLogCollectionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ChangeLogIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogItemArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogItem_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogKeyArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogNew_ValueArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogOld_ValueArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ChangeLogUser_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChangeLogUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeLogInput = {
  collection?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  item_id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  new_value?: InputMaybe<Scalars['String']['input']>;
  old_value?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type Charge = {
  __typename?: 'Charge';
  applicable_above_distance_in_km: Scalars['Float']['output'];
  applicable_above_order_value: Scalars['Float']['output'];
  applicable_below_distance_in_km: Scalars['Float']['output'];
  applicable_below_order_value: Scalars['Float']['output'];
  branches: Array<ChargeBranch>;
  charge_applicable_on_type: ChargeApplicableOnType;
  charge_type: ChargeType;
  charge_value_type: ChargeValueType;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  inter_state_tax?: Maybe<Tax>;
  inter_state_tax_id?: Maybe<Scalars['UUID']['output']>;
  intra_state_tax?: Maybe<Tax>;
  intra_state_tax_id?: Maybe<Scalars['UUID']['output']>;
  is_range_type?: Maybe<Scalars['Boolean']['output']>;
  multi_item?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order_type?: Maybe<OrderType>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  value: Scalars['Float']['output'];
  value_range: Scalars['JSON']['output'];
};


export type ChargeApplicable_Above_Distance_In_KmArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ChargeApplicable_Above_Order_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ChargeApplicable_Below_Distance_In_KmArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ChargeApplicable_Below_Order_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ChargeCharge_Applicable_On_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeCharge_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeCharge_Value_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ChargeDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeInter_State_Tax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeIntra_State_Tax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeIs_Range_TypeArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ChargeMulti_ItemArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ChargeNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeOrder_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ChargeValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export enum ChargeApplicableOnType {
  DeliveryDistance = 'DELIVERY_DISTANCE',
  Item = 'ITEM',
  OrderValue = 'ORDER_VALUE'
}

export type ChargeBranch = {
  __typename?: 'ChargeBranch';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  charge?: Maybe<Charge>;
  charge_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  section_type: SectionType;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ChargeBranchBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeBranchCharge_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeBranchCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeBranchCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ChargeBranchIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeBranchSection_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeBranchSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ChargeBranchUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ChargeBranchInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  charge?: InputMaybe<ChargeInput>;
  charge_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  section_type?: InputMaybe<SectionType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ChargeBranchSyncResponse = {
  __typename?: 'ChargeBranchSyncResponse';
  branch_id: Scalars['UUID']['output'];
  charge?: Maybe<ChargeSyncResponse>;
  charge_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  section_type?: Maybe<Scalars['String']['output']>;
};

export type ChargeInput = {
  applicable_above_distance_in_km?: InputMaybe<Scalars['Float']['input']>;
  applicable_above_order_value?: InputMaybe<Scalars['Float']['input']>;
  applicable_below_distance_in_km?: InputMaybe<Scalars['Float']['input']>;
  applicable_below_order_value?: InputMaybe<Scalars['Float']['input']>;
  branches?: InputMaybe<Array<InputMaybe<ChargeBranchInput>>>;
  charge_applicable_on_type?: InputMaybe<ChargeApplicableOnType>;
  charge_type?: InputMaybe<ChargeType>;
  charge_value_type?: InputMaybe<ChargeValueType>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  inter_state_tax?: InputMaybe<TaxInput>;
  inter_state_tax_id?: InputMaybe<Scalars['UUID']['input']>;
  intra_state_tax?: InputMaybe<TaxInput>;
  intra_state_tax_id?: InputMaybe<Scalars['UUID']['input']>;
  is_range_type?: InputMaybe<Scalars['Boolean']['input']>;
  multi_item?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_type?: InputMaybe<OrderType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_range?: InputMaybe<Scalars['JSON']['input']>;
};

export type ChargeSyncResponse = {
  __typename?: 'ChargeSyncResponse';
  applicable_above_distance_in_km?: Maybe<Scalars['Float']['output']>;
  applicable_above_order_value?: Maybe<Scalars['Float']['output']>;
  applicable_below_distance_in_km?: Maybe<Scalars['Float']['output']>;
  applicable_below_order_value?: Maybe<Scalars['Float']['output']>;
  charge_applicable_on_type?: Maybe<Scalars['String']['output']>;
  charge_type?: Maybe<Scalars['String']['output']>;
  charge_value_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  inter_state_tax_id?: Maybe<Scalars['String']['output']>;
  intra_state_tax_id?: Maybe<Scalars['String']['output']>;
  is_range_type?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_range?: Maybe<Scalars['JSON']['output']>;
};

export enum ChargeType {
  Delivery = 'DELIVERY',
  Other = 'OTHER',
  Packaging = 'PACKAGING',
  Service = 'SERVICE'
}

export enum ChargeValueType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type ChildItem = {
  __typename?: 'ChildItem';
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type Children = {
  __typename?: 'Children';
  children?: Maybe<Array<Maybe<Children>>>;
  customization_groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  food_type?: Maybe<Scalars['String']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  printer_type?: Maybe<Scalars['String']['output']>;
  product_type?: Maybe<Scalars['String']['output']>;
};

export type ClosingShiftSlipData = {
  __typename?: 'ClosingShiftSlipData';
  cancelled_orders?: Maybe<Scalars['Int']['output']>;
  closing_balance?: Maybe<Scalars['Float']['output']>;
  closing_time?: Maybe<Scalars['String']['output']>;
  closing_user_name?: Maybe<Scalars['String']['output']>;
  completed_orders?: Maybe<Scalars['Int']['output']>;
  opening_balance?: Maybe<Scalars['Float']['output']>;
  opening_time?: Maybe<Scalars['String']['output']>;
  opening_user_name?: Maybe<Scalars['String']['output']>;
  payment_modes?: Maybe<Array<ClosingShiftSlipPaymentMode>>;
  total_cash_sale?: Maybe<Scalars['Float']['output']>;
  total_sale?: Maybe<Scalars['Float']['output']>;
};

export type ClosingShiftSlipPaymentMode = {
  __typename?: 'ClosingShiftSlipPaymentMode';
  payment_type?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export enum Code {
  Accept = 'ACCEPT',
  Cancel = 'CANCEL',
  Deliver = 'DELIVER',
  Dispatch = 'DISPATCH',
  FoodReady = 'FOOD_READY',
  Receive = 'RECEIVE',
  RiderAssigned = 'RIDER_ASSIGNED',
  Settle = 'SETTLE'
}

export enum ColumnType {
  Array = 'ARRAY',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Enum = 'ENUM',
  Json = 'JSON',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export enum CommandType {
  Bill = 'BILL',
  Kot = 'KOT',
  Payment = 'PAYMENT',
  Save = 'SAVE',
  Settle = 'SETTLE'
}

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['UUID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CompanyAddress_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CompanyEmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyMobile_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CompanyInput = {
  address?: InputMaybe<AddressInput>;
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CompanyResponse = {
  __typename?: 'CompanyResponse';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum ComplaintStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Duplicate = 'DUPLICATE',
  Escalated = 'ESCALATED',
  InProgress = 'IN_PROGRESS',
  Raised = 'RAISED',
  Rejected = 'REJECTED',
  Resolved = 'RESOLVED',
  ReOpened = 'RE_OPENED',
  UnderReview = 'UNDER_REVIEW',
  Verified = 'VERIFIED'
}

export type ConsolidatedMonthlyGoalInsights = {
  __typename?: 'ConsolidatedMonthlyGoalInsights';
  instance_goals?: Maybe<Array<ExtendedInstanceGoal>>;
};

export type ConsolidatedPaymentModeInsights = {
  __typename?: 'ConsolidatedPaymentModeInsights';
  payment_mode_breakdown: Array<PaymentModeEntry>;
};

export type ConsolidatedSalesInsights = {
  __typename?: 'ConsolidatedSalesInsights';
  current_month: SalesInsights;
  current_week: SalesInsights;
  previous_month: SalesInsights;
  previous_week: SalesInsights;
  today: SalesInsights;
  yesterday: SalesInsights;
};

export type ConsolidatedSourceComparisonInsights = {
  __typename?: 'ConsolidatedSourceComparisonInsights';
  current_month: Array<SourceEntry>;
  previous_month: Array<SourceEntry>;
};

export type ConsolidatedSourceDistributionInsights = {
  __typename?: 'ConsolidatedSourceDistributionInsights';
  source_distribution: Array<SourceEntry>;
};

export type ConsolidatedTopCategoriesInsights = {
  __typename?: 'ConsolidatedTopCategoriesInsights';
  top_categories: Array<CategoryEntry>;
};

export type ConsolidatedTopProductsInsights = {
  __typename?: 'ConsolidatedTopProductsInsights';
  top_products: Array<ProductEntry>;
};

export type ConsolidatedWeeklySalesInsights = {
  __typename?: 'ConsolidatedWeeklySalesInsights';
  current_week: WeeklySalesInsights;
  previous_week: WeeklySalesInsights;
};

export type Coupon = {
  __typename?: 'Coupon';
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  discount?: Maybe<Discount>;
  discount_id?: Maybe<Scalars['UUID']['output']>;
  employee?: Maybe<Employee>;
  employee_id?: Maybe<Scalars['UUID']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  end_datetime?: Maybe<Scalars['Datetime']['output']>;
  end_time?: Maybe<Scalars['Time']['output']>;
  expired: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  max_usage?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new_customer_only: Scalars['Boolean']['output'];
  one_time_per_customer: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  staff?: Maybe<Staff>;
  staff_id?: Maybe<Scalars['UUID']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  start_time?: Maybe<Scalars['Time']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  usage_count?: Maybe<Scalars['Int']['output']>;
};


export type CouponCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CouponDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponEmployee_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponEnd_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type CouponEnd_DatetimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CouponEnd_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CouponExpiredArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CouponIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponMax_UsageArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CouponNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponNew_Customer_OnlyArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CouponOne_Time_Per_CustomerArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CouponPriorityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CouponStaff_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponStart_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type CouponStart_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type CouponSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CouponUsage_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type CouponBranch = {
  __typename?: 'CouponBranch';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  coupon?: Maybe<Coupon>;
  coupon_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  section_type: SectionType;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CouponBranchBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponBranchCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponBranchCoupon_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponBranchCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CouponBranchIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponBranchSection_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponBranchSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CouponBranchUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CouponBranchInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  coupon?: InputMaybe<CouponInput>;
  coupon_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  section_type?: InputMaybe<SectionType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CouponBranchResponse = {
  __typename?: 'CouponBranchResponse';
  branch_id: Scalars['UUID']['output'];
  coupon: CouponResponse;
  coupon_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  section_type?: Maybe<Scalars['String']['output']>;
};

export type CouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  discount?: InputMaybe<DiscountInput>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  employee?: InputMaybe<EmployeeInput>;
  employee_id?: InputMaybe<Scalars['UUID']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  end_datetime?: InputMaybe<Scalars['Datetime']['input']>;
  end_time?: InputMaybe<Scalars['Time']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  max_usage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new_customer_only?: InputMaybe<Scalars['Boolean']['input']>;
  one_time_per_customer?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  staff?: InputMaybe<StaffInput>;
  staff_id?: InputMaybe<Scalars['UUID']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  start_time?: InputMaybe<Scalars['Time']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  usage_count?: InputMaybe<Scalars['Int']['input']>;
};

export type CouponResponse = {
  __typename?: 'CouponResponse';
  discount?: Maybe<Scalars['JSON']['output']>;
  discount_id?: Maybe<Scalars['String']['output']>;
  end_dateTime?: Maybe<Scalars['Datetime']['output']>;
  max_usage?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new_customer_only?: Maybe<Scalars['Boolean']['output']>;
  one_time_per_customer?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  staff?: Maybe<Scalars['JSON']['output']>;
  staff_id?: Maybe<Scalars['String']['output']>;
};

export type CreditUser = {
  __typename?: 'CreditUser';
  customer_id: Scalars['ID']['output'];
  customer_name: Scalars['String']['output'];
  customer_number: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  total_amount: Scalars['Float']['output'];
  total_paid: Scalars['Float']['output'];
};

export type CustomProductType = {
  __typename?: 'CustomProductType';
  children?: Maybe<Array<Maybe<Children>>>;
  customization_groups?: Maybe<Array<Maybe<CustomizationGroups>>>;
  description?: Maybe<Scalars['String']['output']>;
  food_type?: Maybe<Scalars['String']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  is_disabled?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  printer_type?: Maybe<Scalars['String']['output']>;
  sub_category_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  active: Scalars['Boolean']['output'];
  addresses: Array<Address>;
  anniversary?: Maybe<Scalars['Date']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gstin?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  jwt_invalidate?: Maybe<Scalars['Int']['output']>;
  last_app_open?: Maybe<Scalars['Datetime']['output']>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  pan?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  profile_picture?: Maybe<Scalars['String']['output']>;
  profile_picture_encoding?: Maybe<Scalars['JSON']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  visit?: Maybe<Scalars['Int']['output']>;
};


export type CustomerActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CustomerAnniversaryArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type CustomerApp_VersionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomerDobArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type CustomerEmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerGenderArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerGstinArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerJwt_InvalidateArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CustomerLast_App_OpenArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomerMobile_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerNotesArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerOtpArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerPanArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerPasscodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerPasswordArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerProfile_PictureArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerTypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomerVisitArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  address_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customer_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CustomerAddressAddress_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerAddressCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomerAddressCustomer_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerAddressIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerAddressUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomerAddressInput = {
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customer_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  anniversary?: InputMaybe<Scalars['Date']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gstin?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  jwt_invalidate?: InputMaybe<Scalars['Int']['input']>;
  last_app_open?: InputMaybe<Scalars['Datetime']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  pan?: InputMaybe<Scalars['String']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profile_picture?: InputMaybe<Scalars['String']['input']>;
  profile_picture_encoding?: InputMaybe<Scalars['JSON']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  visit?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerRating = {
  __typename?: 'CustomerRating';
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customer_id?: Maybe<Scalars['UUID']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  order_id?: Maybe<Scalars['UUID']['output']>;
  rating: Scalars['Int']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CustomerRatingCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomerRatingCustomer_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerRatingFeedbackArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerRatingIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerRatingOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerRatingRatingArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CustomerRatingUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomerRatingInput = {
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customer_id?: InputMaybe<Scalars['UUID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomizationGroup = {
  __typename?: 'CustomizationGroup';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  inline_products: Array<Product>;
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  max_choices: Scalars['Int']['output'];
  menus: Array<MenuProduct>;
  min_choices: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent_products: Array<CustomizationGroupProduct>;
  products: Array<CustomizationGroupInline>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CustomizationGroupCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomizationGroupIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CustomizationGroupMax_ChoicesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CustomizationGroupMin_ChoicesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CustomizationGroupNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomizationGroupInline = {
  __typename?: 'CustomizationGroupInline';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customization_group?: Maybe<CustomizationGroup>;
  customization_group_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CustomizationGroupInlineCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupInlineCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomizationGroupInlineCustomization_Group_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupInlineIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupInlineIs_DefaultArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CustomizationGroupInlineListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CustomizationGroupInlineProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupInlineSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupInlineUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomizationGroupInlineInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customization_group?: InputMaybe<CustomizationGroupInput>;
  customization_group_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomizationGroupInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  inline_products?: InputMaybe<Array<InputMaybe<ProductInput>>>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  max_choices?: InputMaybe<Scalars['Int']['input']>;
  menus?: InputMaybe<Array<InputMaybe<MenuProductInput>>>;
  min_choices?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_products?: InputMaybe<Array<InputMaybe<CustomizationGroupProductInput>>>;
  products?: InputMaybe<Array<InputMaybe<CustomizationGroupInlineInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomizationGroupProduct = {
  __typename?: 'CustomizationGroupProduct';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customization_group?: Maybe<CustomizationGroup>;
  customization_group_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type CustomizationGroupProductCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupProductCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type CustomizationGroupProductCustomization_Group_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupProductIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupProductListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type CustomizationGroupProductProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupProductSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type CustomizationGroupProductUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomizationGroupProductInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customization_group?: InputMaybe<CustomizationGroupInput>;
  customization_group_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CustomizationGroups = {
  __typename?: 'CustomizationGroups';
  id?: Maybe<Scalars['String']['output']>;
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  max_choices?: Maybe<Scalars['Int']['output']>;
  min_choices?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<CustomProductType>>>;
};

export type DailyBillingInsights = {
  __typename?: 'DailyBillingInsights';
  avg_order: Scalars['Float']['output'];
  cancelled_bills: Scalars['Int']['output'];
  comp_amount: Scalars['Float']['output'];
  comp_orders: Scalars['Int']['output'];
  discount: Scalars['Float']['output'];
  settled_bills: Scalars['Int']['output'];
  settled_gross: Scalars['Float']['output'];
  settled_net: Scalars['Float']['output'];
  total_cover: Scalars['Float']['output'];
  total_orders: Scalars['Int']['output'];
  unsettled_amount: Scalars['Float']['output'];
  unsettled_bills: Scalars['Int']['output'];
};

export type DeliverySlot = {
  __typename?: 'DeliverySlot';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  end_time: Scalars['Time']['output'];
  id: Scalars['UUID']['output'];
  instance?: Maybe<Instance>;
  instance_id: Scalars['UUID']['output'];
  start_time: Scalars['Time']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type DeliverySlotCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DeliverySlotCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type DeliverySlotEnd_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type DeliverySlotIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DeliverySlotInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DeliverySlotStart_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type DeliverySlotSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DeliverySlotUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DeliverySlotInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  end_time?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instance?: InputMaybe<InstanceInput>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  start_time?: InputMaybe<Scalars['Time']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DeliverySlotResponse = {
  __typename?: 'DeliverySlotResponse';
  end_time: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  instance_id: Scalars['UUID']['output'];
  start_time: Scalars['String']['output'];
};

export enum DeliveryTime {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Midnight = 'MIDNIGHT',
  Morning = 'MORNING'
}

export type Discount = {
  __typename?: 'Discount';
  allow_discount_range: Scalars['Boolean']['output'];
  applicable_on_first_order: Scalars['Boolean']['output'];
  branches: Array<DiscountBranch>;
  categories: Array<DiscountCategory>;
  clubbed_with_other_discounts: Scalars['Boolean']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  discount_applicable_on_type: DiscountApplicableOnType;
  discount_offer_type: DiscountOfferType;
  discount_type: DiscountType;
  end_date: Scalars['Date']['output'];
  end_time?: Maybe<Scalars['Time']['output']>;
  food_type?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  is_customer_specific: Scalars['Boolean']['output'];
  is_menu_specific: Scalars['Boolean']['output'];
  max_discount: Scalars['Float']['output'];
  max_items?: Maybe<Scalars['Int']['output']>;
  min_order_value: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  products_x: Array<DiscountProductX>;
  products_y: Array<DiscountProductY>;
  role?: Maybe<Role>;
  role_id?: Maybe<Scalars['UUID']['output']>;
  start_date: Scalars['Date']['output'];
  start_time?: Maybe<Scalars['Time']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  value: Scalars['Float']['output'];
  value_max: Scalars['Float']['output'];
  value_min: Scalars['Float']['output'];
  weekdays?: Maybe<Scalars['JSON']['output']>;
};


export type DiscountAllow_Discount_RangeArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DiscountApplicable_On_First_OrderArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DiscountClubbed_With_Other_DiscountsArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DiscountCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type DiscountDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountDiscount_Applicable_On_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountDiscount_Offer_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountDiscount_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountEnd_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type DiscountEnd_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type DiscountIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountIs_Customer_SpecificArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DiscountIs_Menu_SpecificArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DiscountMax_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type DiscountMax_ItemsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type DiscountMin_Order_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type DiscountNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountRole_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountStart_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type DiscountStart_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type DiscountSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type DiscountValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type DiscountValue_MaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type DiscountValue_MinArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export enum DiscountApplicableOnType {
  All = 'ALL',
  Category = 'CATEGORY',
  Dish = 'DISH',
  FoodType = 'FOOD_TYPE'
}

export type DiscountBranch = {
  __typename?: 'DiscountBranch';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  discount?: Maybe<Discount>;
  discount_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  section_type: SectionType;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type DiscountBranchBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountBranchCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountBranchCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type DiscountBranchDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountBranchIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountBranchSection_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountBranchSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountBranchUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountBranchInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  discount?: InputMaybe<DiscountInput>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  section_type?: InputMaybe<SectionType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountBranchResponse = {
  __typename?: 'DiscountBranchResponse';
  branch_id: Scalars['UUID']['output'];
  discount: DiscountResponse;
  discount_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  section_type?: Maybe<Scalars['String']['output']>;
};

export type DiscountCategory = {
  __typename?: 'DiscountCategory';
  category?: Maybe<Category>;
  category_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  discount?: Maybe<Discount>;
  discount_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type DiscountCategoryCategory_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountCategoryCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountCategoryCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type DiscountCategoryDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountCategoryIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountCategorySub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountCategoryUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountCategoryInput = {
  category?: InputMaybe<CategoryInput>;
  category_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  discount?: InputMaybe<DiscountInput>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountInput = {
  allow_discount_range?: InputMaybe<Scalars['Boolean']['input']>;
  applicable_on_first_order?: InputMaybe<Scalars['Boolean']['input']>;
  branches?: InputMaybe<Array<InputMaybe<DiscountBranchInput>>>;
  categories?: InputMaybe<Array<InputMaybe<DiscountCategoryInput>>>;
  clubbed_with_other_discounts?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_applicable_on_type?: InputMaybe<DiscountApplicableOnType>;
  discount_offer_type?: InputMaybe<DiscountOfferType>;
  discount_type?: InputMaybe<DiscountType>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  end_time?: InputMaybe<Scalars['Time']['input']>;
  food_type?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_customer_specific?: InputMaybe<Scalars['Boolean']['input']>;
  is_menu_specific?: InputMaybe<Scalars['Boolean']['input']>;
  max_discount?: InputMaybe<Scalars['Float']['input']>;
  max_items?: InputMaybe<Scalars['Int']['input']>;
  min_order_value?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products_x?: InputMaybe<Array<InputMaybe<DiscountProductXInput>>>;
  products_y?: InputMaybe<Array<InputMaybe<DiscountProductYInput>>>;
  role?: InputMaybe<RoleInput>;
  role_id?: InputMaybe<Scalars['UUID']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  start_time?: InputMaybe<Scalars['Time']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_max?: InputMaybe<Scalars['Float']['input']>;
  value_min?: InputMaybe<Scalars['Float']['input']>;
  weekdays?: InputMaybe<Scalars['JSON']['input']>;
};

export enum DiscountOfferType {
  Bogo = 'BOGO',
  Bxgy = 'BXGY',
  Discount = 'DISCOUNT',
  Freebie = 'FREEBIE',
  LoyaltyPoints = 'LOYALTY_POINTS'
}

export type DiscountProductX = {
  __typename?: 'DiscountProductX';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  discount?: Maybe<Discount>;
  discount_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type DiscountProductXCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductXCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type DiscountProductXDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductXIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductXProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductXSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductXUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountProductXInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  discount?: InputMaybe<DiscountInput>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountProductY = {
  __typename?: 'DiscountProductY';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  discount?: Maybe<Discount>;
  discount_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type DiscountProductYCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductYCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type DiscountProductYDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductYIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductYProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductYSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type DiscountProductYUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountProductYInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  discount?: InputMaybe<DiscountInput>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DiscountResponse = {
  __typename?: 'DiscountResponse';
  allow_discount_range?: Maybe<Scalars['Boolean']['output']>;
  applicable_on_first_order?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Scalars['JSON']['output']>;
  clubbed_with_other_discounts?: Maybe<Scalars['Boolean']['output']>;
  created_on?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_applicable_on_type?: Maybe<Scalars['String']['output']>;
  discount_offer_type?: Maybe<Scalars['String']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  food_type?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  is_customer_specific?: Maybe<Scalars['Boolean']['output']>;
  is_menu_specific?: Maybe<Scalars['Boolean']['output']>;
  max_discount?: Maybe<Scalars['Float']['output']>;
  min_order_value?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  products_x?: Maybe<Scalars['JSON']['output']>;
  products_y?: Maybe<Scalars['JSON']['output']>;
  role_id?: Maybe<Scalars['UUID']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_max?: Maybe<Scalars['Float']['output']>;
  value_min?: Maybe<Scalars['Float']['output']>;
};

export enum DiscountType {
  DishFlatRate = 'DISH_FLAT_RATE',
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type Employee = {
  __typename?: 'Employee';
  code: Scalars['String']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  discount?: Maybe<Discount>;
  discount_id?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  is_active: Scalars['Boolean']['output'];
  max_coupon_per_month: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type EmployeeCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type EmployeeDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmployeeMax_Coupon_Per_MonthArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type EmployeeNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeePhoneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type EmployeeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  discount?: InputMaybe<DiscountInput>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  max_coupon_per_month?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ExtendedInstanceGoal = {
  __typename?: 'ExtendedInstanceGoal';
  goal: Scalars['Float']['output'];
  instance_goal_type: Scalars['String']['output'];
  instance_id: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  progress: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ExtendedMenuResponse = {
  __typename?: 'ExtendedMenuResponse';
  branch: WebsiteInstanceBrandType;
  branch_id?: Maybe<Scalars['String']['output']>;
  categories: Array<Maybe<Scalars['JSON']['output']>>;
  instance_id: Scalars['String']['output'];
  menu_id: Scalars['String']['output'];
  order_type?: Maybe<Scalars['String']['output']>;
  products: Array<Maybe<Scalars['JSON']['output']>>;
};

export enum FoodType {
  Egg = 'EGG',
  NonVeg = 'NON_VEG',
  Veg = 'VEG'
}

export type FoodTypeMis = {
  __typename?: 'FoodTypeMIS';
  actual_no_of_bills: Scalars['Float']['output'];
  actual_sales: Scalars['Float']['output'];
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['Date']['output'];
  expected_no_of_bills: Scalars['Float']['output'];
  expected_sales: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type FoodTypeMisActual_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type FoodTypeMisActual_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type FoodTypeMisBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FoodTypeMisCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FoodTypeMisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type FoodTypeMisDateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type FoodTypeMisExpected_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type FoodTypeMisExpected_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type FoodTypeMisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FoodTypeMisNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FoodTypeMisSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FoodTypeMisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type FoodTypeMisInput = {
  actual_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  actual_sales?: InputMaybe<Scalars['Float']['input']>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expected_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  expected_sales?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type FreeDish = {
  __typename?: 'FreeDish';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priority: Scalars['Int']['output'];
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['UUID']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  website_instance?: Maybe<WebsiteInstance>;
  website_instance_id: Scalars['UUID']['output'];
};


export type FreeDishCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FreeDishCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type FreeDishDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FreeDishIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FreeDishImageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FreeDishIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FreeDishNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FreeDishPriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type FreeDishPriorityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type FreeDishProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FreeDishSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type FreeDishUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type FreeDishWebsite_Instance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type FreeDishInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  website_instance?: InputMaybe<WebsiteInstanceInput>;
  website_instance_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type FreeDishes = {
  __typename?: 'FreeDishes';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
};

export type FutureOrderReport = {
  __typename?: 'FutureOrderReport';
  date: Scalars['String']['output'];
  invoice_number?: Maybe<Scalars['Int']['output']>;
  items: Array<Item>;
  time: Scalars['String']['output'];
};

export type Geom = {
  __typename?: 'Geom';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type GeomInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type GetKeysResponse = {
  __typename?: 'GetKeysResponse';
  fb_pixel?: Maybe<Scalars['String']['output']>;
  g_tag?: Maybe<Scalars['String']['output']>;
  map_key?: Maybe<Scalars['String']['output']>;
};

export enum GstClassification {
  Goods = 'GOODS',
  Services = 'SERVICES'
}

export type HourlyMis = {
  __typename?: 'HourlyMIS';
  actual_no_of_bills: Scalars['Float']['output'];
  actual_sales: Scalars['Float']['output'];
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['Date']['output'];
  expected_no_of_bills: Scalars['Float']['output'];
  expected_sales: Scalars['Float']['output'];
  hour: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type HourlyMisActual_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type HourlyMisActual_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type HourlyMisBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type HourlyMisCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type HourlyMisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type HourlyMisDateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type HourlyMisExpected_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type HourlyMisExpected_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type HourlyMisHourArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type HourlyMisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type HourlyMisNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type HourlyMisSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type HourlyMisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type HourlyMisInput = {
  actual_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  actual_sales?: InputMaybe<Scalars['Float']['input']>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expected_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  expected_sales?: InputMaybe<Scalars['Float']['input']>;
  hour?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum ImageType {
  CountryOrigin = 'COUNTRY_ORIGIN',
  CoverImageUrl = 'COVER_IMAGE_URL',
  Foodshot = 'FOODSHOT',
  FullBackCover = 'FULL_BACK_COVER',
  Ingredients = 'INGREDIENTS',
  Instructions = 'INSTRUCTIONS',
  LicenseNumber = 'LICENSE_NUMBER',
  Manufacturer = 'MANUFACTURER',
  NutritionalInfo = 'NUTRITIONAL_INFO',
  Quantity = 'QUANTITY'
}

export type InlineCharge = {
  __typename?: 'InlineCharge';
  amount: Scalars['Float']['output'];
  charge_id?: Maybe<Scalars['UUID']['output']>;
  charge_type: ChargeType;
  charge_value_type: Scalars['String']['output'];
  config?: Maybe<Scalars['JSON']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  order_id: Scalars['UUID']['output'];
  tax?: Maybe<Tax>;
  tax_id?: Maybe<Scalars['UUID']['output']>;
  tax_name?: Maybe<Scalars['String']['output']>;
  tax_percent: Scalars['Float']['output'];
  tax_responsible_type?: Maybe<Scalars['String']['output']>;
  taxes?: Maybe<Scalars['JSON']['output']>;
  total: Scalars['Float']['output'];
  total_tax: Scalars['Float']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type InlineChargeAmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineChargeCharge_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeCharge_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeCharge_Value_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type InlineChargeIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeTax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeTax_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeTax_PercentArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineChargeTax_Responsible_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineChargeTotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineChargeTotal_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineChargeUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type InlineChargeValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type InlineChargeInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  charge_id?: InputMaybe<Scalars['UUID']['input']>;
  charge_type?: InputMaybe<ChargeType>;
  charge_value_type?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  tax?: InputMaybe<TaxInput>;
  tax_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_name?: InputMaybe<Scalars['String']['input']>;
  tax_percent?: InputMaybe<Scalars['Float']['input']>;
  tax_responsible_type?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Scalars['JSON']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  total_tax?: InputMaybe<Scalars['Float']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type InlineItem = {
  __typename?: 'InlineItem';
  cart?: Maybe<Cart>;
  cart_id: Scalars['UUID']['output'];
  category_id?: Maybe<Scalars['UUID']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
  children: Array<InlineItem>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  food_type?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['UUID']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  item_discount_percentage?: Maybe<Scalars['Float']['output']>;
  item_level_discount?: Maybe<Scalars['Float']['output']>;
  merchant_item_tax?: Maybe<Scalars['Float']['output']>;
  merchant_item_tax_percent?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order_level_discount?: Maybe<Scalars['Float']['output']>;
  parent?: Maybe<InlineItem>;
  parent_id?: Maybe<Scalars['UUID']['output']>;
  price: Scalars['Float']['output'];
  product_id: Scalars['UUID']['output'];
  product_type?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  sub_category_id?: Maybe<Scalars['UUID']['output']>;
  sub_category_name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Tax>;
  tax_id?: Maybe<Scalars['UUID']['output']>;
  tax_name?: Maybe<Scalars['String']['output']>;
  tax_percent?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Scalars['JSON']['output']>;
  total: Scalars['Float']['output'];
  total_agg_tax?: Maybe<Scalars['Float']['output']>;
  total_agg_tax_percent?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_tax?: Maybe<Scalars['Float']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  variant_level_one_id?: Maybe<Scalars['UUID']['output']>;
  variant_level_one_name?: Maybe<Scalars['String']['output']>;
  variant_level_one_price?: Maybe<Scalars['Float']['output']>;
  variant_level_two_id?: Maybe<Scalars['UUID']['output']>;
  variant_level_two_name?: Maybe<Scalars['String']['output']>;
  variant_level_two_price?: Maybe<Scalars['Float']['output']>;
};


export type InlineItemCart_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemCategory_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemCategory_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type InlineItemFood_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemGroup_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemGroup_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemItem_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemItem_Discount_PercentageArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemItem_Level_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemMerchant_Item_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemMerchant_Item_Tax_PercentArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemNoteArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemOrder_Level_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemParent_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemPriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemProduct_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemQuantityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemSub_Category_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemSub_Category_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemSub_TotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemTax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemTax_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemTax_PercentArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemTotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemTotal_Agg_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemTotal_Agg_Tax_PercentArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemTotal_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemTotal_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type InlineItemVariant_Level_One_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemVariant_Level_One_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemVariant_Level_One_PriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InlineItemVariant_Level_Two_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemVariant_Level_Two_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InlineItemVariant_Level_Two_PriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type InlineItemInput = {
  cart?: InputMaybe<CartInput>;
  cart_id?: InputMaybe<Scalars['UUID']['input']>;
  category_id?: InputMaybe<Scalars['UUID']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<InputMaybe<InlineItemInput>>>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  food_type?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['UUID']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  item_discount_percentage?: InputMaybe<Scalars['Float']['input']>;
  item_level_discount?: InputMaybe<Scalars['Float']['input']>;
  merchant_item_tax?: InputMaybe<Scalars['Float']['input']>;
  merchant_item_tax_percent?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_level_discount?: InputMaybe<Scalars['Float']['input']>;
  parent?: InputMaybe<InlineItemInput>;
  parent_id?: InputMaybe<Scalars['UUID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sub_category_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_category_name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_total?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<TaxInput>;
  tax_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_name?: InputMaybe<Scalars['String']['input']>;
  tax_percent?: InputMaybe<Scalars['Float']['input']>;
  taxes?: InputMaybe<Scalars['JSON']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  total_agg_tax?: InputMaybe<Scalars['Float']['input']>;
  total_agg_tax_percent?: InputMaybe<Scalars['Float']['input']>;
  total_discount?: InputMaybe<Scalars['Float']['input']>;
  total_tax?: InputMaybe<Scalars['Float']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  variant_level_one_id?: InputMaybe<Scalars['UUID']['input']>;
  variant_level_one_name?: InputMaybe<Scalars['String']['input']>;
  variant_level_one_price?: InputMaybe<Scalars['Float']['input']>;
  variant_level_two_id?: InputMaybe<Scalars['UUID']['input']>;
  variant_level_two_name?: InputMaybe<Scalars['String']['input']>;
  variant_level_two_price?: InputMaybe<Scalars['Float']['input']>;
};

export type Instance = {
  __typename?: 'Instance';
  branches: Array<Branch>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  delivery_slots: Array<DeliverySlot>;
  description?: Maybe<Scalars['String']['output']>;
  goals: Array<InstanceGoal>;
  id: Scalars['UUID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type InstanceCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type InstanceDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InstanceNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type InstanceGoal = {
  __typename?: 'InstanceGoal';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  goal: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  instance?: Maybe<Instance>;
  instance_goal_type: InstanceGoalType;
  instance_id: Scalars['UUID']['output'];
  month: Scalars['Int']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  year: Scalars['Int']['output'];
};


export type InstanceGoalCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceGoalCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type InstanceGoalGoalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InstanceGoalIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceGoalInstance_Goal_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceGoalInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceGoalMonthArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type InstanceGoalSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceGoalUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type InstanceGoalYearArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type InstanceGoalInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  goal?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instance?: InputMaybe<InstanceInput>;
  instance_goal_type?: InputMaybe<InstanceGoalType>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum InstanceGoalType {
  Profit = 'PROFIT',
  Revenue = 'REVENUE'
}

export type InstanceInput = {
  branches?: InputMaybe<Array<InputMaybe<BranchInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  delivery_slots?: InputMaybe<Array<InputMaybe<DeliverySlotInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Array<InputMaybe<InstanceGoalInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type InstanceResponse = {
  __typename?: 'InstanceResponse';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type Integration = {
  __typename?: 'Integration';
  actions: Array<IntegrationAction>;
  authentication?: Maybe<Scalars['JSON']['output']>;
  base_path: Scalars['String']['output'];
  code: Scalars['String']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  integration_type: IntegrationType;
  menus: Array<MenuBranch>;
  name: Scalars['String']['output'];
  settings: Array<IntegrationSetting>;
  source: Scalars['String']['output'];
  sub_company_integrations: Array<SubCompanyIntegration>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type IntegrationBase_PathArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type IntegrationIconArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationIntegration_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationSourceArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type IntegrationAction = {
  __typename?: 'IntegrationAction';
  action_name?: Maybe<ActionName>;
  action_type?: Maybe<ActionType>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  function_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  integration?: Maybe<Integration>;
  integration_id: Scalars['UUID']['output'];
  is_self_delivery: Scalars['Boolean']['output'];
  order_type?: Maybe<OrderType>;
  path_value?: Maybe<Scalars['String']['output']>;
  status_code?: Maybe<StatusCode>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type IntegrationActionAction_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionAction_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type IntegrationActionFunction_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionIs_Self_DeliveryArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationActionOrder_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionPath_ValueArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionStatus_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationActionUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type IntegrationActionInput = {
  action_name?: InputMaybe<ActionName>;
  action_type?: InputMaybe<ActionType>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  function_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration?: InputMaybe<IntegrationInput>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  is_self_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  order_type?: InputMaybe<OrderType>;
  path_value?: InputMaybe<Scalars['String']['input']>;
  status_code?: InputMaybe<StatusCode>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type IntegrationInput = {
  actions?: InputMaybe<Array<InputMaybe<IntegrationActionInput>>>;
  authentication?: InputMaybe<Scalars['JSON']['input']>;
  base_path?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_type?: InputMaybe<IntegrationType>;
  menus?: InputMaybe<Array<InputMaybe<MenuBranchInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Array<InputMaybe<IntegrationSettingInput>>>;
  source?: InputMaybe<Scalars['String']['input']>;
  sub_company_integrations?: InputMaybe<Array<InputMaybe<SubCompanyIntegrationInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type IntegrationResponse = {
  __typename?: 'IntegrationResponse';
  base_path?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  integration_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IntegrationSetting = {
  __typename?: 'IntegrationSetting';
  allow_multi_choice?: Maybe<Scalars['Boolean']['output']>;
  choices?: Maybe<Scalars['JSON']['output']>;
  column_type: ColumnType;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  integration?: Maybe<Integration>;
  integration_id: Scalars['UUID']['output'];
  is_branch_level?: Maybe<Scalars['Boolean']['output']>;
  is_required?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type IntegrationSettingAllow_Multi_ChoiceArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationSettingColumn_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationSettingCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type IntegrationSettingIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationSettingIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationSettingIs_Branch_LevelArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationSettingIs_RequiredArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IntegrationSettingNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationSettingUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type IntegrationSettingInput = {
  allow_multi_choice?: InputMaybe<Scalars['Boolean']['input']>;
  choices?: InputMaybe<Scalars['JSON']['input']>;
  column_type?: InputMaybe<ColumnType>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration?: InputMaybe<IntegrationInput>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  is_branch_level?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum IntegrationType {
  Aggregator = 'AGGREGATOR',
  Custom = 'CUSTOM',
  Delivery = 'DELIVERY',
  DeliveryAggregator = 'DELIVERY_AGGREGATOR',
  GiftCard = 'GIFT_CARD',
  Loyalty = 'LOYALTY',
  PaymentGateway = 'PAYMENT_GATEWAY'
}

export type InvoiceResponse = {
  __typename?: 'InvoiceResponse';
  invoice_number: Scalars['Int']['output'];
  invoice_prefix: Scalars['String']['output'];
  kot_number?: Maybe<Scalars['Int']['output']>;
  kot_prefix?: Maybe<Scalars['String']['output']>;
  update_uuid: Scalars['String']['output'];
};

export type Item = {
  __typename?: 'Item';
  branch?: Maybe<Scalars['String']['output']>;
  childItems: Array<ChildItem>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  firstVariantName?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  itemName: Scalars['String']['output'];
  itemQuantity: Scalars['String']['output'];
  orderDate: Scalars['String']['output'];
  orderTime: Scalars['String']['output'];
  secondVariantName?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<Scalars['JSON']['output']>;
};

export enum Kitchen {
  Bakery = 'BAKERY',
  Bar = 'BAR',
  Beverage = 'BEVERAGE',
  Dessert = 'DESSERT',
  Food = 'FOOD',
  Liquor = 'LIQUOR',
  Merchandise = 'MERCHANDISE',
  NonFood = 'NON_FOOD',
  Tobacco = 'TOBACCO',
  Type_1 = 'TYPE_1',
  Type_2 = 'TYPE_2',
  Wine = 'WINE'
}

export enum Language {
  Arabic = 'Arabic',
  Devanagari = 'Devanagari',
  Kannada = 'Kannada',
  Tamil = 'Tamil',
  Telugu = 'Telugu'
}

export type LastShiftResponse = {
  __typename?: 'LastShiftResponse';
  amount?: Maybe<Scalars['Float']['output']>;
  created_on?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export enum Mechanism {
  App = 'APP',
  Link = 'LINK',
  Passcode = 'PASSCODE'
}

export type Menu = {
  __typename?: 'Menu';
  branches: Array<MenuBranch>;
  categories: Array<MenuCategory>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  products: Array<Product>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  tax_rates: Array<MenuTaxRate>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type MenuCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuVersionArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type MenuBranch = {
  __typename?: 'MenuBranch';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  integration?: Maybe<Integration>;
  integration_id?: Maybe<Scalars['UUID']['output']>;
  is_default: Scalars['Boolean']['output'];
  menu?: Maybe<Menu>;
  menu_id: Scalars['UUID']['output'];
  menu_sync_log_id?: Maybe<Scalars['UUID']['output']>;
  section?: Maybe<Section>;
  section_id?: Maybe<Scalars['UUID']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  sync_logs: Array<MenuSyncLog>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type MenuBranchBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuBranchIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchIs_DefaultArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuBranchMenu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchMenu_Sync_Log_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchSection_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuBranchUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MenuBranchInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration?: InputMaybe<IntegrationInput>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  menu?: InputMaybe<MenuInput>;
  menu_id?: InputMaybe<Scalars['UUID']['input']>;
  menu_sync_log_id?: InputMaybe<Scalars['UUID']['input']>;
  section?: InputMaybe<SectionInput>;
  section_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  sync_logs?: InputMaybe<Array<InputMaybe<MenuSyncLogInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MenuBranchResponse = {
  __typename?: 'MenuBranchResponse';
  branch_id: Scalars['String']['output'];
  branch_name: Scalars['String']['output'];
  integrations: Array<MenuIntegrationResponse>;
  location: Scalars['String']['output'];
  menu_id: Scalars['String']['output'];
  menu_name: Scalars['String']['output'];
};

export type MenuCategory = {
  __typename?: 'MenuCategory';
  category?: Maybe<Category>;
  category_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  menu?: Maybe<Menu>;
  menu_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type MenuCategoryCategory_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuCategoryIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryMenu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategorySub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MenuCategoryInput = {
  category?: InputMaybe<CategoryInput>;
  category_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  menu?: InputMaybe<MenuInput>;
  menu_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MenuCustomizationGroupProductType = {
  __typename?: 'MenuCustomizationGroupProductType';
  customization_group?: Maybe<CustomizationGroups>;
  customization_group_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_enabled: Scalars['Boolean']['output'];
  menu_id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  product?: Maybe<CustomProductType>;
  product_id: Scalars['String']['output'];
};

export type MenuInput = {
  branches?: InputMaybe<Array<InputMaybe<MenuBranchInput>>>;
  categories?: InputMaybe<Array<InputMaybe<MenuCategoryInput>>>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<ProductInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_rates?: InputMaybe<Array<InputMaybe<MenuTaxRateInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuIntegrationResponse = {
  __typename?: 'MenuIntegrationResponse';
  integration_id: Scalars['String']['output'];
  integration_name: Scalars['String']['output'];
  menu_id?: Maybe<Scalars['String']['output']>;
  menu_sync_message?: Maybe<Scalars['JSON']['output']>;
  menu_sync_status?: Maybe<Scalars['String']['output']>;
};

export type MenuProduct = {
  __typename?: 'MenuProduct';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customization_group?: Maybe<CustomizationGroup>;
  customization_group_id?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  is_enabled: Scalars['Boolean']['output'];
  menu?: Maybe<Menu>;
  menu_id: Scalars['UUID']['output'];
  packaging_charge?: Maybe<Charge>;
  packaging_charge_id?: Maybe<Scalars['UUID']['output']>;
  price: Scalars['Float']['output'];
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type MenuProductCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProductCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuProductCustomization_Group_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProductIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProductIs_EnabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuProductMenu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProductPackaging_Charge_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProductPriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type MenuProductProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProductSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProductUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MenuProductInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customization_group?: InputMaybe<CustomizationGroupInput>;
  customization_group_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  menu?: InputMaybe<MenuInput>;
  menu_id?: InputMaybe<Scalars['UUID']['input']>;
  packaging_charge?: InputMaybe<ChargeInput>;
  packaging_charge_id?: InputMaybe<Scalars['UUID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MenuResponse = {
  __typename?: 'MenuResponse';
  branch: WebsiteInstanceBrandType;
  branch_id?: Maybe<Scalars['String']['output']>;
  categories: Array<Maybe<Scalars['JSON']['output']>>;
  menu_id: Scalars['String']['output'];
  order_type?: Maybe<Scalars['String']['output']>;
  products: Array<Maybe<Scalars['JSON']['output']>>;
};

export type MenuSyncInput = {
  branch_id: Scalars['String']['input'];
  integration_id: Scalars['String']['input'];
  menu_id: Scalars['String']['input'];
};

export type MenuSyncLog = {
  __typename?: 'MenuSyncLog';
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  integration_name: Scalars['String']['output'];
  menu_id: Scalars['UUID']['output'];
  menu_sync_status: MenuSyncStatus;
  message?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};


export type MenuSyncLogBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuSyncLogExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogIntegration_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogMenu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogMenu_Sync_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogSourceArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSyncLogUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuSyncLogVersionArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type MenuSyncLogInput = {
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_name?: InputMaybe<Scalars['String']['input']>;
  menu_id?: InputMaybe<Scalars['UUID']['input']>;
  menu_sync_status?: InputMaybe<MenuSyncStatus>;
  message?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum MenuSyncStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type MenuTaxRate = {
  __typename?: 'MenuTaxRate';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  menu?: Maybe<Menu>;
  menu_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  tax_rate?: Maybe<TaxRate>;
  tax_rate_id: Scalars['UUID']['output'];
  tax_value: Scalars['Float']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type MenuTaxRateCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuTaxRateCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MenuTaxRateIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuTaxRateMenu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuTaxRateSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuTaxRateTax_Rate_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type MenuTaxRateTax_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type MenuTaxRateUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MenuTaxRateInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  menu?: InputMaybe<MenuInput>;
  menu_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_rate?: InputMaybe<TaxRateInput>;
  tax_rate_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_value?: InputMaybe<Scalars['Float']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MergeResponse = {
  __typename?: 'MergeResponse';
  from_order: Scalars['JSON']['output'];
  to_order: Scalars['JSON']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  add_all_orders_to_index: Scalars['JSON']['output'];
  add_category_to_menu: Scalars['Boolean']['output'];
  add_customer_address: AddAddressResponse;
  add_preparation_time: Scalars['JSON']['output'];
  add_product_to_menu_by_product_id: VariantType;
  add_reject_code: Scalars['JSON']['output'];
  apply_coupon: ApplyCouponResponse;
  bulk_import_menu?: Maybe<Scalars['JSON']['output']>;
  bulk_upload_category: Scalars['JSON']['output'];
  bulk_upload_coupon: Scalars['JSON']['output'];
  bulk_upload_product: Scalars['JSON']['output'];
  bulk_upload_sub_category: Scalars['JSON']['output'];
  close_branch_day: Scalars['JSON']['output'];
  close_branch_shift: Scalars['JSON']['output'];
  create_activity_log: ActivityLog;
  create_address: Address;
  create_aggregator_mis: AggregatorMis;
  create_auth: Auth;
  create_authorization: Authorization;
  create_bank_account: BankAccount;
  create_banner: Banner;
  create_branch: Branch;
  create_branch_banner: BranchBanner;
  create_branch_image: BranchImage;
  create_branch_integration: BranchIntegration;
  create_branch_product: BranchProduct;
  create_branch_setting: BranchSetting;
  create_branch_shift: BranchShift;
  create_branch_status_log: BranchStatusLog;
  create_cart: Cart;
  create_category: Category;
  create_category_mis: CategoryMis;
  create_category_schedule: CategorySchedule;
  create_change_log: ChangeLog;
  create_charge: Charge;
  create_charge_branch: ChargeBranch;
  create_company: Company;
  create_coupon: Coupon;
  create_coupon_branch: CouponBranch;
  create_customer: Customer;
  create_customer_address: CustomerAddress;
  create_customer_rating: CustomerRating;
  create_customization_group: CustomizationGroup;
  create_customization_group_inline: CustomizationGroupInline;
  create_customization_group_product: CustomizationGroupProduct;
  create_delivery_slot: DeliverySlot;
  create_discount: Discount;
  create_discount_branch: DiscountBranch;
  create_discount_category: DiscountCategory;
  create_discount_product_x: DiscountProductX;
  create_discount_product_y: DiscountProductY;
  create_employee: Employee;
  create_food_type_mis: FoodTypeMis;
  create_free_dish: FreeDish;
  create_hourly_mis: HourlyMis;
  create_inline_charge: InlineCharge;
  create_inline_item: InlineItem;
  create_instance: Instance;
  create_instance_goal: InstanceGoal;
  create_integration: Integration;
  create_integration_action: IntegrationAction;
  create_integration_setting: IntegrationSetting;
  create_menu: Menu;
  create_menu_branch: MenuBranch;
  create_menu_category: MenuCategory;
  create_menu_product: MenuProduct;
  create_menu_sync_log: MenuSyncLog;
  create_menu_tax_rate: MenuTaxRate;
  create_order: Order;
  create_order_comment: OrderComment;
  create_order_complaint: OrderComplaint;
  create_order_customer_detail: OrderCustomerDetail;
  create_order_discount: OrderDiscount;
  create_order_inline_item: OrderInlineItem;
  create_order_json: OrderResponse;
  create_order_operation_log: OrderOperationLog;
  create_order_payment: OrderPayment;
  create_order_rider: OrderRider;
  create_order_secondary_timeline: OrderSecondaryTimeline;
  create_order_tax: OrderTax;
  create_order_time_line: OrderTimeLine;
  create_outlet_mis: OutletMis;
  create_payment_mode: PaymentMode;
  create_permission: Permission;
  create_printer_config: PrinterConfig;
  create_printer_mapping: PrinterMapping;
  create_product: Product;
  create_product_image: ProductImage;
  create_product_mis: ProductMis;
  create_product_status_log: ProductStatusLog;
  create_product_translation: ProductTranslation;
  create_register: Register;
  create_register_shift: RegisterShift;
  create_report_template: ReportTemplate;
  create_role: Role;
  create_role_permission: RolePermission;
  create_schedule: Schedule;
  create_secondary_status: SecondaryStatus;
  create_section: Section;
  create_setting: Setting;
  create_staff: Staff;
  create_staff_company: StaffCompany;
  create_status: Status;
  create_sub_category: SubCategory;
  create_sub_category_mis: SubCategoryMis;
  create_sub_category_product: SubCategoryProduct;
  create_sub_company: SubCompany;
  create_sub_company_integration: SubCompanyIntegration;
  create_sub_company_integration_branch: SubCompanyIntegrationBranch;
  create_sub_section: SubSection;
  create_tag: Tag;
  create_tax: Tax;
  create_tax_rate: TaxRate;
  create_ticket: Ticket;
  create_ticket_analysis: TicketAnalysis;
  create_ticket_history: TicketHistory;
  create_time_slot: TimeSlot;
  create_user: User;
  create_user_branch: UserBranch;
  create_web_app_coupon: WebAppCoupon;
  create_website: Website;
  create_website_instance: WebsiteInstance;
  create_website_instance_brand: WebsiteInstanceBrand;
  creates_activity_log: Array<Maybe<ActivityLog>>;
  creates_address: Array<Maybe<Address>>;
  creates_aggregator_mis: Array<Maybe<AggregatorMis>>;
  creates_auth: Array<Maybe<Auth>>;
  creates_authorization: Array<Maybe<Authorization>>;
  creates_bank_account: Array<Maybe<BankAccount>>;
  creates_banner: Array<Maybe<Banner>>;
  creates_branch: Array<Maybe<Branch>>;
  creates_branch_banner: Array<Maybe<BranchBanner>>;
  creates_branch_image: Array<Maybe<BranchImage>>;
  creates_branch_integration: Array<Maybe<BranchIntegration>>;
  creates_branch_product: Array<Maybe<BranchProduct>>;
  creates_branch_setting: Array<Maybe<BranchSetting>>;
  creates_branch_shift: Array<Maybe<BranchShift>>;
  creates_branch_status_log: Array<Maybe<BranchStatusLog>>;
  creates_cart: Array<Maybe<Cart>>;
  creates_category: Array<Maybe<Category>>;
  creates_category_mis: Array<Maybe<CategoryMis>>;
  creates_category_schedule: Array<Maybe<CategorySchedule>>;
  creates_change_log: Array<Maybe<ChangeLog>>;
  creates_charge: Array<Maybe<Charge>>;
  creates_charge_branch: Array<Maybe<ChargeBranch>>;
  creates_company: Array<Maybe<Company>>;
  creates_coupon: Array<Maybe<Coupon>>;
  creates_coupon_branch: Array<Maybe<CouponBranch>>;
  creates_customer: Array<Maybe<Customer>>;
  creates_customer_address: Array<Maybe<CustomerAddress>>;
  creates_customer_rating: Array<Maybe<CustomerRating>>;
  creates_customization_group: Array<Maybe<CustomizationGroup>>;
  creates_customization_group_inline: Array<Maybe<CustomizationGroupInline>>;
  creates_customization_group_product: Array<Maybe<CustomizationGroupProduct>>;
  creates_delivery_slot: Array<Maybe<DeliverySlot>>;
  creates_discount: Array<Maybe<Discount>>;
  creates_discount_branch: Array<Maybe<DiscountBranch>>;
  creates_discount_category: Array<Maybe<DiscountCategory>>;
  creates_discount_product_x: Array<Maybe<DiscountProductX>>;
  creates_discount_product_y: Array<Maybe<DiscountProductY>>;
  creates_employee: Array<Maybe<Employee>>;
  creates_food_type_mis: Array<Maybe<FoodTypeMis>>;
  creates_free_dish: Array<Maybe<FreeDish>>;
  creates_hourly_mis: Array<Maybe<HourlyMis>>;
  creates_inline_charge: Array<Maybe<InlineCharge>>;
  creates_inline_item: Array<Maybe<InlineItem>>;
  creates_instance: Array<Maybe<Instance>>;
  creates_instance_goal: Array<Maybe<InstanceGoal>>;
  creates_integration: Array<Maybe<Integration>>;
  creates_integration_action: Array<Maybe<IntegrationAction>>;
  creates_integration_setting: Array<Maybe<IntegrationSetting>>;
  creates_menu: Array<Maybe<Menu>>;
  creates_menu_branch: Array<Maybe<MenuBranch>>;
  creates_menu_category: Array<Maybe<MenuCategory>>;
  creates_menu_product: Array<Maybe<MenuProduct>>;
  creates_menu_sync_log: Array<Maybe<MenuSyncLog>>;
  creates_menu_tax_rate: Array<Maybe<MenuTaxRate>>;
  creates_order: Array<Maybe<Order>>;
  creates_order_comment: Array<Maybe<OrderComment>>;
  creates_order_complaint: Array<Maybe<OrderComplaint>>;
  creates_order_customer_detail: Array<Maybe<OrderCustomerDetail>>;
  creates_order_discount: Array<Maybe<OrderDiscount>>;
  creates_order_inline_item: Array<Maybe<OrderInlineItem>>;
  creates_order_json: Array<OrderResponse>;
  creates_order_operation_log: Array<Maybe<OrderOperationLog>>;
  creates_order_payment: Array<Maybe<OrderPayment>>;
  creates_order_rider: Array<Maybe<OrderRider>>;
  creates_order_secondary_timeline: Array<Maybe<OrderSecondaryTimeline>>;
  creates_order_tax: Array<Maybe<OrderTax>>;
  creates_order_time_line: Array<Maybe<OrderTimeLine>>;
  creates_outlet_mis: Array<Maybe<OutletMis>>;
  creates_payment_mode: Array<Maybe<PaymentMode>>;
  creates_permission: Array<Maybe<Permission>>;
  creates_printer_config: Array<Maybe<PrinterConfig>>;
  creates_printer_mapping: Array<Maybe<PrinterMapping>>;
  creates_product: Array<Maybe<Product>>;
  creates_product_image: Array<Maybe<ProductImage>>;
  creates_product_mis: Array<Maybe<ProductMis>>;
  creates_product_status_log: Array<Maybe<ProductStatusLog>>;
  creates_product_translation: Array<Maybe<ProductTranslation>>;
  creates_register: Array<Maybe<Register>>;
  creates_register_shift: Array<Maybe<RegisterShift>>;
  creates_report_template: Array<Maybe<ReportTemplate>>;
  creates_role: Array<Maybe<Role>>;
  creates_role_permission: Array<Maybe<RolePermission>>;
  creates_schedule: Array<Maybe<Schedule>>;
  creates_secondary_status: Array<Maybe<SecondaryStatus>>;
  creates_section: Array<Maybe<Section>>;
  creates_setting: Array<Maybe<Setting>>;
  creates_staff: Array<Maybe<Staff>>;
  creates_staff_company: Array<Maybe<StaffCompany>>;
  creates_status: Array<Maybe<Status>>;
  creates_sub_category: Array<Maybe<SubCategory>>;
  creates_sub_category_mis: Array<Maybe<SubCategoryMis>>;
  creates_sub_category_product: Array<Maybe<SubCategoryProduct>>;
  creates_sub_company: Array<Maybe<SubCompany>>;
  creates_sub_company_integration: Array<Maybe<SubCompanyIntegration>>;
  creates_sub_company_integration_branch: Array<Maybe<SubCompanyIntegrationBranch>>;
  creates_sub_section: Array<Maybe<SubSection>>;
  creates_tag: Array<Maybe<Tag>>;
  creates_tax: Array<Maybe<Tax>>;
  creates_tax_rate: Array<Maybe<TaxRate>>;
  creates_ticket: Array<Maybe<Ticket>>;
  creates_ticket_analysis: Array<Maybe<TicketAnalysis>>;
  creates_ticket_history: Array<Maybe<TicketHistory>>;
  creates_time_slot: Array<Maybe<TimeSlot>>;
  creates_user: Array<Maybe<User>>;
  creates_user_branch: Array<Maybe<UserBranch>>;
  creates_web_app_coupon: Array<Maybe<WebAppCoupon>>;
  creates_website: Array<Maybe<Website>>;
  creates_website_instance: Array<Maybe<WebsiteInstance>>;
  creates_website_instance_brand: Array<Maybe<WebsiteInstanceBrand>>;
  customization_group_products_by_product_id: Array<Maybe<MenuCustomizationGroupProductType>>;
  delete_activity_log: ActivityLog;
  delete_address: Address;
  delete_aggregator_mis: AggregatorMis;
  delete_auth: Auth;
  delete_authorization: Authorization;
  delete_bank_account: BankAccount;
  delete_banner: Banner;
  delete_branch: Branch;
  delete_branch_banner: BranchBanner;
  delete_branch_image: BranchImage;
  delete_branch_integration: BranchIntegration;
  delete_branch_product: BranchProduct;
  delete_branch_setting: BranchSetting;
  delete_branch_shift: BranchShift;
  delete_branch_status_log: BranchStatusLog;
  delete_cart: Cart;
  delete_category: Category;
  delete_category_mis: CategoryMis;
  delete_category_schedule: CategorySchedule;
  delete_change_log: ChangeLog;
  delete_charge: Charge;
  delete_charge_branch: ChargeBranch;
  delete_company: Company;
  delete_coupon: Coupon;
  delete_coupon_branch: CouponBranch;
  delete_customer: Customer;
  delete_customer_address: CustomerAddress;
  delete_customer_rating: CustomerRating;
  delete_customization_group: CustomizationGroup;
  delete_customization_group_inline: CustomizationGroupInline;
  delete_customization_group_product: CustomizationGroupProduct;
  delete_delivery_slot: DeliverySlot;
  delete_discount: Discount;
  delete_discount_branch: DiscountBranch;
  delete_discount_category: DiscountCategory;
  delete_discount_product_x: DiscountProductX;
  delete_discount_product_y: DiscountProductY;
  delete_employee: Employee;
  delete_food_type_mis: FoodTypeMis;
  delete_free_dish: FreeDish;
  delete_hourly_mis: HourlyMis;
  delete_inline_charge: InlineCharge;
  delete_inline_item: InlineItem;
  delete_instance: Instance;
  delete_instance_goal: InstanceGoal;
  delete_integration: Integration;
  delete_integration_action: IntegrationAction;
  delete_integration_setting: IntegrationSetting;
  delete_menu: Menu;
  delete_menu_branch: MenuBranch;
  delete_menu_category: MenuCategory;
  delete_menu_product: MenuProduct;
  delete_menu_sync_log: MenuSyncLog;
  delete_menu_tax_rate: MenuTaxRate;
  delete_order: Order;
  delete_order_comment: OrderComment;
  delete_order_complaint: OrderComplaint;
  delete_order_customer_detail: OrderCustomerDetail;
  delete_order_discount: OrderDiscount;
  delete_order_inline_item: OrderInlineItem;
  delete_order_operation_log: OrderOperationLog;
  delete_order_payment: OrderPayment;
  delete_order_rider: OrderRider;
  delete_order_secondary_timeline: OrderSecondaryTimeline;
  delete_order_tax: OrderTax;
  delete_order_time_line: OrderTimeLine;
  delete_outlet_mis: OutletMis;
  delete_payment_mode: PaymentMode;
  delete_permission: Permission;
  delete_printer_config: PrinterConfig;
  delete_printer_mapping: PrinterMapping;
  delete_product: Product;
  delete_product_image: ProductImage;
  delete_product_mis: ProductMis;
  delete_product_status_log: ProductStatusLog;
  delete_product_translation: ProductTranslation;
  delete_register: Register;
  delete_register_shift: RegisterShift;
  delete_report_template: ReportTemplate;
  delete_role: Role;
  delete_role_permission: RolePermission;
  delete_schedule: Schedule;
  delete_secondary_status: SecondaryStatus;
  delete_section: Section;
  delete_setting: Setting;
  delete_staff: Staff;
  delete_staff_company: StaffCompany;
  delete_status: Status;
  delete_sub_category: SubCategory;
  delete_sub_category_mis: SubCategoryMis;
  delete_sub_category_product: SubCategoryProduct;
  delete_sub_company: SubCompany;
  delete_sub_company_integration: SubCompanyIntegration;
  delete_sub_company_integration_branch: SubCompanyIntegrationBranch;
  delete_sub_section: SubSection;
  delete_tag: Tag;
  delete_tax: Tax;
  delete_tax_rate: TaxRate;
  delete_ticket: Ticket;
  delete_ticket_analysis: TicketAnalysis;
  delete_ticket_history: TicketHistory;
  delete_time_slot: TimeSlot;
  delete_user: User;
  delete_user_branch: UserBranch;
  delete_web_app_coupon: WebAppCoupon;
  delete_website: Website;
  delete_website_instance: WebsiteInstance;
  delete_website_instance_brand: WebsiteInstanceBrand;
  edit_customer_address: Scalars['Boolean']['output'];
  generate_employee_coupons: Scalars['JSON']['output'];
  generate_invoice_number: InvoiceResponse;
  generate_new_authorization_code: Scalars['JSON']['output'];
  kot_number: Scalars['Int']['output'];
  mark_ticket_closed?: Maybe<Scalars['JSON']['output']>;
  mark_ticket_deployed?: Maybe<Scalars['JSON']['output']>;
  mark_ticket_in_progress?: Maybe<Scalars['JSON']['output']>;
  mark_ticket_in_testing?: Maybe<Scalars['JSON']['output']>;
  mark_ticket_test_failed?: Maybe<Scalars['JSON']['output']>;
  mark_ticket_test_passed?: Maybe<Scalars['JSON']['output']>;
  merge_multiple_kot_into_single_order: OrderResponse;
  merge_table: MergeResponse;
  onboard_client: Scalars['JSON']['output'];
  open_branch_day: Scalars['JSON']['output'];
  open_branch_shift: Scalars['JSON']['output'];
  ping: Ping;
  product_status: Scalars['JSON']['output'];
  publish_menu: Scalars['JSON']['output'];
  remove_category_from_menu: Scalars['Boolean']['output'];
  remove_customer_address: Scalars['Boolean']['output'];
  status_update: Scalars['JSON']['output'];
  sync_cash_drawer_logs: Scalars['JSON']['output'];
  sync_orders: Scalars['JSON']['output'];
  sync_redis_order_to_db: Scalars['JSON']['output'];
  update_activity_log: ActivityLog;
  update_address: Address;
  update_aggregator_mis: AggregatorMis;
  update_auth: Auth;
  update_authorization: Authorization;
  update_bank_account: BankAccount;
  update_banner: Banner;
  update_branch: Branch;
  update_branch_banner: BranchBanner;
  update_branch_image: BranchImage;
  update_branch_integration: BranchIntegration;
  update_branch_product: BranchProduct;
  update_branch_setting: BranchSetting;
  update_branch_shift: BranchShift;
  update_branch_status_log: BranchStatusLog;
  update_cart: Cart;
  update_category: Category;
  update_category_mis: CategoryMis;
  update_category_schedule: CategorySchedule;
  update_change_log: ChangeLog;
  update_charge: Charge;
  update_charge_branch: ChargeBranch;
  update_company: Company;
  update_coupon: Coupon;
  update_coupon_branch: CouponBranch;
  update_customer: Customer;
  update_customer_address: CustomerAddress;
  update_customer_rating: CustomerRating;
  update_customization_group: CustomizationGroup;
  update_customization_group_inline: CustomizationGroupInline;
  update_customization_group_product: CustomizationGroupProduct;
  update_delivery_slot: DeliverySlot;
  update_discount: Discount;
  update_discount_branch: DiscountBranch;
  update_discount_category: DiscountCategory;
  update_discount_product_x: DiscountProductX;
  update_discount_product_y: DiscountProductY;
  update_employee: Employee;
  update_food_type_mis: FoodTypeMis;
  update_free_dish: FreeDish;
  update_hourly_mis: HourlyMis;
  update_inline_charge: InlineCharge;
  update_inline_item: InlineItem;
  update_instance: Instance;
  update_instance_goal: InstanceGoal;
  update_integration: Integration;
  update_integration_action: IntegrationAction;
  update_integration_setting: IntegrationSetting;
  update_menu: Menu;
  update_menu_branch: MenuBranch;
  update_menu_category: MenuCategory;
  update_menu_product: MenuProduct;
  update_menu_sync_log: MenuSyncLog;
  update_menu_tax_rate: MenuTaxRate;
  update_order: Order;
  update_order_comment: OrderComment;
  update_order_complaint: OrderComplaint;
  update_order_customer_detail: OrderCustomerDetail;
  update_order_discount: OrderDiscount;
  update_order_inline_item: OrderInlineItem;
  update_order_json: OrderResponse;
  update_order_operation_log: OrderOperationLog;
  update_order_payment: Scalars['JSON']['output'];
  update_order_rider: OrderRider;
  update_order_secondary_timeline: OrderSecondaryTimeline;
  update_order_status: OrderStatusResponse;
  update_order_tax: OrderTax;
  update_order_time_line: OrderTimeLine;
  update_outlet_mis: OutletMis;
  update_payment_mode: PaymentMode;
  update_payment_mode_and_settle: Scalars['JSON']['output'];
  update_permission: Permission;
  update_printer_config: PrinterConfig;
  update_printer_mapping: PrinterMapping;
  update_product: Product;
  update_product_image: ProductImage;
  update_product_mis: ProductMis;
  update_product_status_log: ProductStatusLog;
  update_product_translation: ProductTranslation;
  update_register: Register;
  update_register_shift: RegisterShift;
  update_report_template: ReportTemplate;
  update_role: Role;
  update_role_permission: RolePermission;
  update_schedule: Schedule;
  update_secondary_order_status: Scalars['JSON']['output'];
  update_secondary_status: SecondaryStatus;
  update_section: Section;
  update_setting: Setting;
  update_staff: Staff;
  update_staff_company: StaffCompany;
  update_status: Status;
  update_sub_category: SubCategory;
  update_sub_category_mis: SubCategoryMis;
  update_sub_category_product: SubCategoryProduct;
  update_sub_company: SubCompany;
  update_sub_company_integration: SubCompanyIntegration;
  update_sub_company_integration_branch: SubCompanyIntegrationBranch;
  update_sub_section: SubSection;
  update_tag: Tag;
  update_tax: Tax;
  update_tax_rate: TaxRate;
  update_ticket: Ticket;
  update_ticket_analysis: TicketAnalysis;
  update_ticket_history: TicketHistory;
  update_time_slot: TimeSlot;
  update_user: User;
  update_user_branch: UserBranch;
  update_web_app_coupon: WebAppCoupon;
  update_website: Website;
  update_website_instance: WebsiteInstance;
  update_website_instance_brand: WebsiteInstanceBrand;
  updates_activity_log: Array<Maybe<ActivityLog>>;
  updates_address: Array<Maybe<Address>>;
  updates_aggregator_mis: Array<Maybe<AggregatorMis>>;
  updates_auth: Array<Maybe<Auth>>;
  updates_authorization: Array<Maybe<Authorization>>;
  updates_bank_account: Array<Maybe<BankAccount>>;
  updates_banner: Array<Maybe<Banner>>;
  updates_branch: Array<Maybe<Branch>>;
  updates_branch_banner: Array<Maybe<BranchBanner>>;
  updates_branch_image: Array<Maybe<BranchImage>>;
  updates_branch_integration: Array<Maybe<BranchIntegration>>;
  updates_branch_product: Array<Maybe<BranchProduct>>;
  updates_branch_setting: Array<Maybe<BranchSetting>>;
  updates_branch_shift: Array<Maybe<BranchShift>>;
  updates_branch_status_log: Array<Maybe<BranchStatusLog>>;
  updates_cart: Array<Maybe<Cart>>;
  updates_category: Array<Maybe<Category>>;
  updates_category_mis: Array<Maybe<CategoryMis>>;
  updates_category_schedule: Array<Maybe<CategorySchedule>>;
  updates_change_log: Array<Maybe<ChangeLog>>;
  updates_charge: Array<Maybe<Charge>>;
  updates_charge_branch: Array<Maybe<ChargeBranch>>;
  updates_company: Array<Maybe<Company>>;
  updates_coupon: Array<Maybe<Coupon>>;
  updates_coupon_branch: Array<Maybe<CouponBranch>>;
  updates_customer: Array<Maybe<Customer>>;
  updates_customer_address: Array<Maybe<CustomerAddress>>;
  updates_customer_rating: Array<Maybe<CustomerRating>>;
  updates_customization_group: Array<Maybe<CustomizationGroup>>;
  updates_customization_group_inline: Array<Maybe<CustomizationGroupInline>>;
  updates_customization_group_product: Array<Maybe<CustomizationGroupProduct>>;
  updates_delivery_slot: Array<Maybe<DeliverySlot>>;
  updates_discount: Array<Maybe<Discount>>;
  updates_discount_branch: Array<Maybe<DiscountBranch>>;
  updates_discount_category: Array<Maybe<DiscountCategory>>;
  updates_discount_product_x: Array<Maybe<DiscountProductX>>;
  updates_discount_product_y: Array<Maybe<DiscountProductY>>;
  updates_employee: Array<Maybe<Employee>>;
  updates_food_type_mis: Array<Maybe<FoodTypeMis>>;
  updates_free_dish: Array<Maybe<FreeDish>>;
  updates_hourly_mis: Array<Maybe<HourlyMis>>;
  updates_inline_charge: Array<Maybe<InlineCharge>>;
  updates_inline_item: Array<Maybe<InlineItem>>;
  updates_instance: Array<Maybe<Instance>>;
  updates_instance_goal: Array<Maybe<InstanceGoal>>;
  updates_integration: Array<Maybe<Integration>>;
  updates_integration_action: Array<Maybe<IntegrationAction>>;
  updates_integration_setting: Array<Maybe<IntegrationSetting>>;
  updates_menu: Array<Maybe<Menu>>;
  updates_menu_branch: Array<Maybe<MenuBranch>>;
  updates_menu_category: Array<Maybe<MenuCategory>>;
  updates_menu_product: Array<Maybe<MenuProduct>>;
  updates_menu_sync_log: Array<Maybe<MenuSyncLog>>;
  updates_menu_tax_rate: Array<Maybe<MenuTaxRate>>;
  updates_order: Array<Maybe<Order>>;
  updates_order_comment: Array<Maybe<OrderComment>>;
  updates_order_complaint: Array<Maybe<OrderComplaint>>;
  updates_order_customer_detail: Array<Maybe<OrderCustomerDetail>>;
  updates_order_discount: Array<Maybe<OrderDiscount>>;
  updates_order_inline_item: Array<Maybe<OrderInlineItem>>;
  updates_order_json: Array<OrderResponse>;
  updates_order_operation_log: Array<Maybe<OrderOperationLog>>;
  updates_order_payment: Array<Maybe<OrderPayment>>;
  updates_order_rider: Array<Maybe<OrderRider>>;
  updates_order_secondary_timeline: Array<Maybe<OrderSecondaryTimeline>>;
  updates_order_tax: Array<Maybe<OrderTax>>;
  updates_order_time_line: Array<Maybe<OrderTimeLine>>;
  updates_outlet_mis: Array<Maybe<OutletMis>>;
  updates_payment_mode: Array<Maybe<PaymentMode>>;
  updates_permission: Array<Maybe<Permission>>;
  updates_printer_config: Array<Maybe<PrinterConfig>>;
  updates_printer_mapping: Array<Maybe<PrinterMapping>>;
  updates_product: Array<Maybe<Product>>;
  updates_product_image: Array<Maybe<ProductImage>>;
  updates_product_mis: Array<Maybe<ProductMis>>;
  updates_product_status_log: Array<Maybe<ProductStatusLog>>;
  updates_product_translation: Array<Maybe<ProductTranslation>>;
  updates_register: Array<Maybe<Register>>;
  updates_register_shift: Array<Maybe<RegisterShift>>;
  updates_report_template: Array<Maybe<ReportTemplate>>;
  updates_role: Array<Maybe<Role>>;
  updates_role_permission: Array<Maybe<RolePermission>>;
  updates_schedule: Array<Maybe<Schedule>>;
  updates_secondary_status: Array<Maybe<SecondaryStatus>>;
  updates_section: Array<Maybe<Section>>;
  updates_setting: Array<Maybe<Setting>>;
  updates_staff: Array<Maybe<Staff>>;
  updates_staff_company: Array<Maybe<StaffCompany>>;
  updates_status: Array<Maybe<Status>>;
  updates_sub_category: Array<Maybe<SubCategory>>;
  updates_sub_category_mis: Array<Maybe<SubCategoryMis>>;
  updates_sub_category_product: Array<Maybe<SubCategoryProduct>>;
  updates_sub_company: Array<Maybe<SubCompany>>;
  updates_sub_company_integration: Array<Maybe<SubCompanyIntegration>>;
  updates_sub_company_integration_branch: Array<Maybe<SubCompanyIntegrationBranch>>;
  updates_sub_section: Array<Maybe<SubSection>>;
  updates_tag: Array<Maybe<Tag>>;
  updates_tax: Array<Maybe<Tax>>;
  updates_tax_rate: Array<Maybe<TaxRate>>;
  updates_ticket: Array<Maybe<Ticket>>;
  updates_ticket_analysis: Array<Maybe<TicketAnalysis>>;
  updates_ticket_history: Array<Maybe<TicketHistory>>;
  updates_time_slot: Array<Maybe<TimeSlot>>;
  updates_user: Array<Maybe<User>>;
  updates_user_branch: Array<Maybe<UserBranch>>;
  updates_web_app_coupon: Array<Maybe<WebAppCoupon>>;
  updates_website: Array<Maybe<Website>>;
  updates_website_instance: Array<Maybe<WebsiteInstance>>;
  updates_website_instance_brand: Array<Maybe<WebsiteInstanceBrand>>;
  variants_by_product_id: Array<Maybe<VariantType>>;
};


export type MutationAdd_All_Orders_To_IndexArgs = {
  branch_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdd_Category_To_MenuArgs = {
  category_id: Scalars['String']['input'];
  menu_id: Scalars['String']['input'];
};


export type MutationAdd_Customer_AddressArgs = {
  address: AddAddressInput;
  customer_id: Scalars['String']['input'];
};


export type MutationAdd_Preparation_TimeArgs = {
  order_id: Scalars['String']['input'];
  prep_time: Scalars['Int']['input'];
  update_uuid: Scalars['String']['input'];
};


export type MutationAdd_Product_To_Menu_By_Product_IdArgs = {
  menu_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
};


export type MutationAdd_Reject_CodeArgs = {
  order_id: Scalars['String']['input'];
  reject_code: Scalars['Int']['input'];
  update_uuid: Scalars['String']['input'];
};


export type MutationApply_CouponArgs = {
  coupon_code: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
};


export type MutationBulk_Import_MenuArgs = {
  data: Array<Scalars['JSON']['input']>;
};


export type MutationBulk_Upload_CategoryArgs = {
  data: Array<Scalars['JSON']['input']>;
};


export type MutationBulk_Upload_CouponArgs = {
  data: Array<Scalars['JSON']['input']>;
};


export type MutationBulk_Upload_ProductArgs = {
  data: Array<Scalars['JSON']['input']>;
};


export type MutationBulk_Upload_Sub_CategoryArgs = {
  data: Array<Scalars['JSON']['input']>;
};


export type MutationClose_Branch_DayArgs = {
  amount: Scalars['Float']['input'];
  branch_id: Scalars['String']['input'];
  parent_id: Scalars['String']['input'];
  shit_user?: InputMaybe<ShiftUserInput>;
};


export type MutationClose_Branch_ShiftArgs = {
  amount: Scalars['Float']['input'];
  branch_id: Scalars['String']['input'];
  parent_id: Scalars['String']['input'];
  shift_user?: InputMaybe<ShiftUserInput>;
};


export type MutationCreate_Activity_LogArgs = {
  row: ActivityLogInput;
};


export type MutationCreate_AddressArgs = {
  row: AddressInput;
};


export type MutationCreate_Aggregator_MisArgs = {
  row: AggregatorMisInput;
};


export type MutationCreate_AuthArgs = {
  row: AuthInput;
};


export type MutationCreate_AuthorizationArgs = {
  row: AuthorizationInput;
};


export type MutationCreate_Bank_AccountArgs = {
  row: BankAccountInput;
};


export type MutationCreate_BannerArgs = {
  row: BannerInput;
};


export type MutationCreate_BranchArgs = {
  row: BranchInput;
};


export type MutationCreate_Branch_BannerArgs = {
  row: BranchBannerInput;
};


export type MutationCreate_Branch_ImageArgs = {
  row: BranchImageInput;
};


export type MutationCreate_Branch_IntegrationArgs = {
  row: BranchIntegrationInput;
};


export type MutationCreate_Branch_ProductArgs = {
  row: BranchProductInput;
};


export type MutationCreate_Branch_SettingArgs = {
  row: BranchSettingInput;
};


export type MutationCreate_Branch_ShiftArgs = {
  row: BranchShiftInput;
};


export type MutationCreate_Branch_Status_LogArgs = {
  row: BranchStatusLogInput;
};


export type MutationCreate_CartArgs = {
  row: CartInput;
};


export type MutationCreate_CategoryArgs = {
  row: CategoryInput;
};


export type MutationCreate_Category_MisArgs = {
  row: CategoryMisInput;
};


export type MutationCreate_Category_ScheduleArgs = {
  row: CategoryScheduleInput;
};


export type MutationCreate_Change_LogArgs = {
  row: ChangeLogInput;
};


export type MutationCreate_ChargeArgs = {
  row: ChargeInput;
};


export type MutationCreate_Charge_BranchArgs = {
  row: ChargeBranchInput;
};


export type MutationCreate_CompanyArgs = {
  row: CompanyInput;
};


export type MutationCreate_CouponArgs = {
  row: CouponInput;
};


export type MutationCreate_Coupon_BranchArgs = {
  row: CouponBranchInput;
};


export type MutationCreate_CustomerArgs = {
  row: CustomerInput;
};


export type MutationCreate_Customer_AddressArgs = {
  row: CustomerAddressInput;
};


export type MutationCreate_Customer_RatingArgs = {
  row: CustomerRatingInput;
};


export type MutationCreate_Customization_GroupArgs = {
  row: CustomizationGroupInput;
};


export type MutationCreate_Customization_Group_InlineArgs = {
  row: CustomizationGroupInlineInput;
};


export type MutationCreate_Customization_Group_ProductArgs = {
  row: CustomizationGroupProductInput;
};


export type MutationCreate_Delivery_SlotArgs = {
  row: DeliverySlotInput;
};


export type MutationCreate_DiscountArgs = {
  row: DiscountInput;
};


export type MutationCreate_Discount_BranchArgs = {
  row: DiscountBranchInput;
};


export type MutationCreate_Discount_CategoryArgs = {
  row: DiscountCategoryInput;
};


export type MutationCreate_Discount_Product_XArgs = {
  row: DiscountProductXInput;
};


export type MutationCreate_Discount_Product_YArgs = {
  row: DiscountProductYInput;
};


export type MutationCreate_EmployeeArgs = {
  row: EmployeeInput;
};


export type MutationCreate_Food_Type_MisArgs = {
  row: FoodTypeMisInput;
};


export type MutationCreate_Free_DishArgs = {
  row: FreeDishInput;
};


export type MutationCreate_Hourly_MisArgs = {
  row: HourlyMisInput;
};


export type MutationCreate_Inline_ChargeArgs = {
  row: InlineChargeInput;
};


export type MutationCreate_Inline_ItemArgs = {
  row: InlineItemInput;
};


export type MutationCreate_InstanceArgs = {
  row: InstanceInput;
};


export type MutationCreate_Instance_GoalArgs = {
  row: InstanceGoalInput;
};


export type MutationCreate_IntegrationArgs = {
  row: IntegrationInput;
};


export type MutationCreate_Integration_ActionArgs = {
  row: IntegrationActionInput;
};


export type MutationCreate_Integration_SettingArgs = {
  row: IntegrationSettingInput;
};


export type MutationCreate_MenuArgs = {
  row: MenuInput;
};


export type MutationCreate_Menu_BranchArgs = {
  row: MenuBranchInput;
};


export type MutationCreate_Menu_CategoryArgs = {
  row: MenuCategoryInput;
};


export type MutationCreate_Menu_ProductArgs = {
  row: MenuProductInput;
};


export type MutationCreate_Menu_Sync_LogArgs = {
  row: MenuSyncLogInput;
};


export type MutationCreate_Menu_Tax_RateArgs = {
  row: MenuTaxRateInput;
};


export type MutationCreate_OrderArgs = {
  row: OrderInput;
};


export type MutationCreate_Order_CommentArgs = {
  row: OrderCommentInput;
};


export type MutationCreate_Order_ComplaintArgs = {
  row: OrderComplaintInput;
};


export type MutationCreate_Order_Customer_DetailArgs = {
  row: OrderCustomerDetailInput;
};


export type MutationCreate_Order_DiscountArgs = {
  row: OrderDiscountInput;
};


export type MutationCreate_Order_Inline_ItemArgs = {
  row: OrderInlineItemInput;
};


export type MutationCreate_Order_JsonArgs = {
  row: Scalars['JSON']['input'];
};


export type MutationCreate_Order_Operation_LogArgs = {
  row: OrderOperationLogInput;
};


export type MutationCreate_Order_PaymentArgs = {
  row: OrderPaymentInput;
};


export type MutationCreate_Order_RiderArgs = {
  row: OrderRiderInput;
};


export type MutationCreate_Order_Secondary_TimelineArgs = {
  row: OrderSecondaryTimelineInput;
};


export type MutationCreate_Order_TaxArgs = {
  row: OrderTaxInput;
};


export type MutationCreate_Order_Time_LineArgs = {
  row: OrderTimeLineInput;
};


export type MutationCreate_Outlet_MisArgs = {
  row: OutletMisInput;
};


export type MutationCreate_Payment_ModeArgs = {
  row: PaymentModeInput;
};


export type MutationCreate_PermissionArgs = {
  row: PermissionInput;
};


export type MutationCreate_Printer_ConfigArgs = {
  row: PrinterConfigInput;
};


export type MutationCreate_Printer_MappingArgs = {
  row: PrinterMappingInput;
};


export type MutationCreate_ProductArgs = {
  row: ProductInput;
};


export type MutationCreate_Product_ImageArgs = {
  row: ProductImageInput;
};


export type MutationCreate_Product_MisArgs = {
  row: ProductMisInput;
};


export type MutationCreate_Product_Status_LogArgs = {
  row: ProductStatusLogInput;
};


export type MutationCreate_Product_TranslationArgs = {
  row: ProductTranslationInput;
};


export type MutationCreate_RegisterArgs = {
  row: RegisterInput;
};


export type MutationCreate_Register_ShiftArgs = {
  row: RegisterShiftInput;
};


export type MutationCreate_Report_TemplateArgs = {
  row: ReportTemplateInput;
};


export type MutationCreate_RoleArgs = {
  row: RoleInput;
};


export type MutationCreate_Role_PermissionArgs = {
  row: RolePermissionInput;
};


export type MutationCreate_ScheduleArgs = {
  row: ScheduleInput;
};


export type MutationCreate_Secondary_StatusArgs = {
  row: SecondaryStatusInput;
};


export type MutationCreate_SectionArgs = {
  row: SectionInput;
};


export type MutationCreate_SettingArgs = {
  row: SettingInput;
};


export type MutationCreate_StaffArgs = {
  row: StaffInput;
};


export type MutationCreate_Staff_CompanyArgs = {
  row: StaffCompanyInput;
};


export type MutationCreate_StatusArgs = {
  row: StatusInput;
};


export type MutationCreate_Sub_CategoryArgs = {
  row: SubCategoryInput;
};


export type MutationCreate_Sub_Category_MisArgs = {
  row: SubCategoryMisInput;
};


export type MutationCreate_Sub_Category_ProductArgs = {
  row: SubCategoryProductInput;
};


export type MutationCreate_Sub_CompanyArgs = {
  row: SubCompanyInput;
};


export type MutationCreate_Sub_Company_IntegrationArgs = {
  row: SubCompanyIntegrationInput;
};


export type MutationCreate_Sub_Company_Integration_BranchArgs = {
  row: SubCompanyIntegrationBranchInput;
};


export type MutationCreate_Sub_SectionArgs = {
  row: SubSectionInput;
};


export type MutationCreate_TagArgs = {
  row: TagInput;
};


export type MutationCreate_TaxArgs = {
  row: TaxInput;
};


export type MutationCreate_Tax_RateArgs = {
  row: TaxRateInput;
};


export type MutationCreate_TicketArgs = {
  row: TicketInput;
};


export type MutationCreate_Ticket_AnalysisArgs = {
  row: TicketAnalysisInput;
};


export type MutationCreate_Ticket_HistoryArgs = {
  row: TicketHistoryInput;
};


export type MutationCreate_Time_SlotArgs = {
  row: TimeSlotInput;
};


export type MutationCreate_UserArgs = {
  row: UserInput;
};


export type MutationCreate_User_BranchArgs = {
  row: UserBranchInput;
};


export type MutationCreate_Web_App_CouponArgs = {
  row: WebAppCouponInput;
};


export type MutationCreate_WebsiteArgs = {
  row: WebsiteInput;
};


export type MutationCreate_Website_InstanceArgs = {
  row: WebsiteInstanceInput;
};


export type MutationCreate_Website_Instance_BrandArgs = {
  row: WebsiteInstanceBrandInput;
};


export type MutationCreates_Activity_LogArgs = {
  rows: Array<ActivityLogInput>;
};


export type MutationCreates_AddressArgs = {
  rows: Array<AddressInput>;
};


export type MutationCreates_Aggregator_MisArgs = {
  rows: Array<AggregatorMisInput>;
};


export type MutationCreates_AuthArgs = {
  rows: Array<AuthInput>;
};


export type MutationCreates_AuthorizationArgs = {
  rows: Array<AuthorizationInput>;
};


export type MutationCreates_Bank_AccountArgs = {
  rows: Array<BankAccountInput>;
};


export type MutationCreates_BannerArgs = {
  rows: Array<BannerInput>;
};


export type MutationCreates_BranchArgs = {
  rows: Array<BranchInput>;
};


export type MutationCreates_Branch_BannerArgs = {
  rows: Array<BranchBannerInput>;
};


export type MutationCreates_Branch_ImageArgs = {
  rows: Array<BranchImageInput>;
};


export type MutationCreates_Branch_IntegrationArgs = {
  rows: Array<BranchIntegrationInput>;
};


export type MutationCreates_Branch_ProductArgs = {
  rows: Array<BranchProductInput>;
};


export type MutationCreates_Branch_SettingArgs = {
  rows: Array<BranchSettingInput>;
};


export type MutationCreates_Branch_ShiftArgs = {
  rows: Array<BranchShiftInput>;
};


export type MutationCreates_Branch_Status_LogArgs = {
  rows: Array<BranchStatusLogInput>;
};


export type MutationCreates_CartArgs = {
  rows: Array<CartInput>;
};


export type MutationCreates_CategoryArgs = {
  rows: Array<CategoryInput>;
};


export type MutationCreates_Category_MisArgs = {
  rows: Array<CategoryMisInput>;
};


export type MutationCreates_Category_ScheduleArgs = {
  rows: Array<CategoryScheduleInput>;
};


export type MutationCreates_Change_LogArgs = {
  rows: Array<ChangeLogInput>;
};


export type MutationCreates_ChargeArgs = {
  rows: Array<ChargeInput>;
};


export type MutationCreates_Charge_BranchArgs = {
  rows: Array<ChargeBranchInput>;
};


export type MutationCreates_CompanyArgs = {
  rows: Array<CompanyInput>;
};


export type MutationCreates_CouponArgs = {
  rows: Array<CouponInput>;
};


export type MutationCreates_Coupon_BranchArgs = {
  rows: Array<CouponBranchInput>;
};


export type MutationCreates_CustomerArgs = {
  rows: Array<CustomerInput>;
};


export type MutationCreates_Customer_AddressArgs = {
  rows: Array<CustomerAddressInput>;
};


export type MutationCreates_Customer_RatingArgs = {
  rows: Array<CustomerRatingInput>;
};


export type MutationCreates_Customization_GroupArgs = {
  rows: Array<CustomizationGroupInput>;
};


export type MutationCreates_Customization_Group_InlineArgs = {
  rows: Array<CustomizationGroupInlineInput>;
};


export type MutationCreates_Customization_Group_ProductArgs = {
  rows: Array<CustomizationGroupProductInput>;
};


export type MutationCreates_Delivery_SlotArgs = {
  rows: Array<DeliverySlotInput>;
};


export type MutationCreates_DiscountArgs = {
  rows: Array<DiscountInput>;
};


export type MutationCreates_Discount_BranchArgs = {
  rows: Array<DiscountBranchInput>;
};


export type MutationCreates_Discount_CategoryArgs = {
  rows: Array<DiscountCategoryInput>;
};


export type MutationCreates_Discount_Product_XArgs = {
  rows: Array<DiscountProductXInput>;
};


export type MutationCreates_Discount_Product_YArgs = {
  rows: Array<DiscountProductYInput>;
};


export type MutationCreates_EmployeeArgs = {
  rows: Array<EmployeeInput>;
};


export type MutationCreates_Food_Type_MisArgs = {
  rows: Array<FoodTypeMisInput>;
};


export type MutationCreates_Free_DishArgs = {
  rows: Array<FreeDishInput>;
};


export type MutationCreates_Hourly_MisArgs = {
  rows: Array<HourlyMisInput>;
};


export type MutationCreates_Inline_ChargeArgs = {
  rows: Array<InlineChargeInput>;
};


export type MutationCreates_Inline_ItemArgs = {
  rows: Array<InlineItemInput>;
};


export type MutationCreates_InstanceArgs = {
  rows: Array<InstanceInput>;
};


export type MutationCreates_Instance_GoalArgs = {
  rows: Array<InstanceGoalInput>;
};


export type MutationCreates_IntegrationArgs = {
  rows: Array<IntegrationInput>;
};


export type MutationCreates_Integration_ActionArgs = {
  rows: Array<IntegrationActionInput>;
};


export type MutationCreates_Integration_SettingArgs = {
  rows: Array<IntegrationSettingInput>;
};


export type MutationCreates_MenuArgs = {
  rows: Array<MenuInput>;
};


export type MutationCreates_Menu_BranchArgs = {
  rows: Array<MenuBranchInput>;
};


export type MutationCreates_Menu_CategoryArgs = {
  rows: Array<MenuCategoryInput>;
};


export type MutationCreates_Menu_ProductArgs = {
  rows: Array<MenuProductInput>;
};


export type MutationCreates_Menu_Sync_LogArgs = {
  rows: Array<MenuSyncLogInput>;
};


export type MutationCreates_Menu_Tax_RateArgs = {
  rows: Array<MenuTaxRateInput>;
};


export type MutationCreates_OrderArgs = {
  rows: Array<OrderInput>;
};


export type MutationCreates_Order_CommentArgs = {
  rows: Array<OrderCommentInput>;
};


export type MutationCreates_Order_ComplaintArgs = {
  rows: Array<OrderComplaintInput>;
};


export type MutationCreates_Order_Customer_DetailArgs = {
  rows: Array<OrderCustomerDetailInput>;
};


export type MutationCreates_Order_DiscountArgs = {
  rows: Array<OrderDiscountInput>;
};


export type MutationCreates_Order_Inline_ItemArgs = {
  rows: Array<OrderInlineItemInput>;
};


export type MutationCreates_Order_JsonArgs = {
  rows: Array<Scalars['JSON']['input']>;
};


export type MutationCreates_Order_Operation_LogArgs = {
  rows: Array<OrderOperationLogInput>;
};


export type MutationCreates_Order_PaymentArgs = {
  rows: Array<OrderPaymentInput>;
};


export type MutationCreates_Order_RiderArgs = {
  rows: Array<OrderRiderInput>;
};


export type MutationCreates_Order_Secondary_TimelineArgs = {
  rows: Array<OrderSecondaryTimelineInput>;
};


export type MutationCreates_Order_TaxArgs = {
  rows: Array<OrderTaxInput>;
};


export type MutationCreates_Order_Time_LineArgs = {
  rows: Array<OrderTimeLineInput>;
};


export type MutationCreates_Outlet_MisArgs = {
  rows: Array<OutletMisInput>;
};


export type MutationCreates_Payment_ModeArgs = {
  rows: Array<PaymentModeInput>;
};


export type MutationCreates_PermissionArgs = {
  rows: Array<PermissionInput>;
};


export type MutationCreates_Printer_ConfigArgs = {
  rows: Array<PrinterConfigInput>;
};


export type MutationCreates_Printer_MappingArgs = {
  rows: Array<PrinterMappingInput>;
};


export type MutationCreates_ProductArgs = {
  rows: Array<ProductInput>;
};


export type MutationCreates_Product_ImageArgs = {
  rows: Array<ProductImageInput>;
};


export type MutationCreates_Product_MisArgs = {
  rows: Array<ProductMisInput>;
};


export type MutationCreates_Product_Status_LogArgs = {
  rows: Array<ProductStatusLogInput>;
};


export type MutationCreates_Product_TranslationArgs = {
  rows: Array<ProductTranslationInput>;
};


export type MutationCreates_RegisterArgs = {
  rows: Array<RegisterInput>;
};


export type MutationCreates_Register_ShiftArgs = {
  rows: Array<RegisterShiftInput>;
};


export type MutationCreates_Report_TemplateArgs = {
  rows: Array<ReportTemplateInput>;
};


export type MutationCreates_RoleArgs = {
  rows: Array<RoleInput>;
};


export type MutationCreates_Role_PermissionArgs = {
  rows: Array<RolePermissionInput>;
};


export type MutationCreates_ScheduleArgs = {
  rows: Array<ScheduleInput>;
};


export type MutationCreates_Secondary_StatusArgs = {
  rows: Array<SecondaryStatusInput>;
};


export type MutationCreates_SectionArgs = {
  rows: Array<SectionInput>;
};


export type MutationCreates_SettingArgs = {
  rows: Array<SettingInput>;
};


export type MutationCreates_StaffArgs = {
  rows: Array<StaffInput>;
};


export type MutationCreates_Staff_CompanyArgs = {
  rows: Array<StaffCompanyInput>;
};


export type MutationCreates_StatusArgs = {
  rows: Array<StatusInput>;
};


export type MutationCreates_Sub_CategoryArgs = {
  rows: Array<SubCategoryInput>;
};


export type MutationCreates_Sub_Category_MisArgs = {
  rows: Array<SubCategoryMisInput>;
};


export type MutationCreates_Sub_Category_ProductArgs = {
  rows: Array<SubCategoryProductInput>;
};


export type MutationCreates_Sub_CompanyArgs = {
  rows: Array<SubCompanyInput>;
};


export type MutationCreates_Sub_Company_IntegrationArgs = {
  rows: Array<SubCompanyIntegrationInput>;
};


export type MutationCreates_Sub_Company_Integration_BranchArgs = {
  rows: Array<SubCompanyIntegrationBranchInput>;
};


export type MutationCreates_Sub_SectionArgs = {
  rows: Array<SubSectionInput>;
};


export type MutationCreates_TagArgs = {
  rows: Array<TagInput>;
};


export type MutationCreates_TaxArgs = {
  rows: Array<TaxInput>;
};


export type MutationCreates_Tax_RateArgs = {
  rows: Array<TaxRateInput>;
};


export type MutationCreates_TicketArgs = {
  rows: Array<TicketInput>;
};


export type MutationCreates_Ticket_AnalysisArgs = {
  rows: Array<TicketAnalysisInput>;
};


export type MutationCreates_Ticket_HistoryArgs = {
  rows: Array<TicketHistoryInput>;
};


export type MutationCreates_Time_SlotArgs = {
  rows: Array<TimeSlotInput>;
};


export type MutationCreates_UserArgs = {
  rows: Array<UserInput>;
};


export type MutationCreates_User_BranchArgs = {
  rows: Array<UserBranchInput>;
};


export type MutationCreates_Web_App_CouponArgs = {
  rows: Array<WebAppCouponInput>;
};


export type MutationCreates_WebsiteArgs = {
  rows: Array<WebsiteInput>;
};


export type MutationCreates_Website_InstanceArgs = {
  rows: Array<WebsiteInstanceInput>;
};


export type MutationCreates_Website_Instance_BrandArgs = {
  rows: Array<WebsiteInstanceBrandInput>;
};


export type MutationCustomization_Group_Products_By_Product_IdArgs = {
  menu_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
};


export type MutationDelete_Activity_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_AddressArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Aggregator_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_AuthArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_AuthorizationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Bank_AccountArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_BannerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Branch_BannerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Branch_ImageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Branch_IntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Branch_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Branch_SettingArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Branch_ShiftArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Branch_Status_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_CartArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Category_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Category_ScheduleArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Change_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_ChargeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Charge_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_CompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_CouponArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Coupon_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_CustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Customer_AddressArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Customer_RatingArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Customization_GroupArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Customization_Group_InlineArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Customization_Group_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Delivery_SlotArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_DiscountArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Discount_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Discount_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Discount_Product_XArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Discount_Product_YArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_EmployeeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Food_Type_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Free_DishArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Hourly_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Inline_ChargeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Inline_ItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_InstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Instance_GoalArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_IntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Integration_ActionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Integration_SettingArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_MenuArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Menu_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Menu_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Menu_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Menu_Sync_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Menu_Tax_RateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_OrderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_CommentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_ComplaintArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_Customer_DetailArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_DiscountArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_Inline_ItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_Operation_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_PaymentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_RiderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_Secondary_TimelineArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_TaxArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Order_Time_LineArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Outlet_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Payment_ModeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_PermissionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Printer_ConfigArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Printer_MappingArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Product_ImageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Product_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Product_Status_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Product_TranslationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_RegisterArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Register_ShiftArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Report_TemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_RoleArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Role_PermissionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_ScheduleArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Secondary_StatusArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_SectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_SettingArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_StaffArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Staff_CompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_StatusArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Sub_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Sub_Category_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Sub_Category_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Sub_CompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Sub_Company_IntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Sub_Company_Integration_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Sub_SectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_TagArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_TaxArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Tax_RateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_TicketArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Ticket_AnalysisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Ticket_HistoryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Time_SlotArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_UserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_User_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Web_App_CouponArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_WebsiteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Website_InstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDelete_Website_Instance_BrandArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationEdit_Customer_AddressArgs = {
  address: AddAddressInput;
  address_id: Scalars['String']['input'];
  customer_id: Scalars['String']['input'];
};


export type MutationGenerate_Invoice_NumberArgs = {
  order_id: Scalars['String']['input'];
  update_uuid: Scalars['String']['input'];
};


export type MutationGenerate_New_Authorization_CodeArgs = {
  authorization_data: AuthorizationInput;
};


export type MutationKot_NumberArgs = {
  branch_id: Scalars['String']['input'];
};


export type MutationMark_Ticket_ClosedArgs = {
  client_feedback?: InputMaybe<Scalars['String']['input']>;
  client_rating?: InputMaybe<Scalars['Int']['input']>;
  is_repeat_bug?: InputMaybe<Scalars['Boolean']['input']>;
  ticket_id: Scalars['ID']['input'];
};


export type MutationMark_Ticket_DeployedArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type MutationMark_Ticket_In_ProgressArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type MutationMark_Ticket_In_TestingArgs = {
  resolution?: InputMaybe<Scalars['String']['input']>;
  root_cause?: InputMaybe<Scalars['String']['input']>;
  ticket_id: Scalars['ID']['input'];
};


export type MutationMark_Ticket_Test_FailedArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type MutationMark_Ticket_Test_PassedArgs = {
  ticket_id: Scalars['ID']['input'];
};


export type MutationMerge_Multiple_Kot_Into_Single_OrderArgs = {
  new_order: Scalars['JSON']['input'];
  old_orders: Array<Scalars['JSON']['input']>;
};


export type MutationMerge_TableArgs = {
  from_order: Scalars['JSON']['input'];
  to_order: Scalars['JSON']['input'];
};


export type MutationOnboard_ClientArgs = {
  input: OnboardClientInput;
};


export type MutationOpen_Branch_DayArgs = {
  amount: Scalars['Float']['input'];
  branch_id: Scalars['String']['input'];
  shift_user?: InputMaybe<ShiftUserInput>;
};


export type MutationOpen_Branch_ShiftArgs = {
  amount: Scalars['Float']['input'];
  branch_id: Scalars['String']['input'];
  parent_id: Scalars['String']['input'];
  shift_user?: InputMaybe<ShiftUserInput>;
};


export type MutationProduct_StatusArgs = {
  branch_id: Scalars['String']['input'];
  is_enabled: Scalars['Boolean']['input'];
  product_id: Scalars['String']['input'];
  until?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublish_MenuArgs = {
  menu_id: Scalars['String']['input'];
};


export type MutationRemove_Category_From_MenuArgs = {
  category_id: Scalars['String']['input'];
  menu_id: Scalars['String']['input'];
};


export type MutationRemove_Customer_AddressArgs = {
  address_id: Scalars['String']['input'];
  customer_id: Scalars['String']['input'];
};


export type MutationStatus_UpdateArgs = {
  branch_id: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  is_self_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['JSON']['input']>;
  order_id: Scalars['String']['input'];
  order_type?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  status_code: Scalars['String']['input'];
};


export type MutationSync_Cash_Drawer_LogsArgs = {
  rows: Array<Scalars['JSON']['input']>;
};


export type MutationSync_OrdersArgs = {
  rows: Array<Scalars['JSON']['input']>;
};


export type MutationSync_Redis_Order_To_DbArgs = {
  order_id: Scalars['String']['input'];
  update?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdate_Activity_LogArgs = {
  change: ActivityLogInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_AddressArgs = {
  change: AddressInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Aggregator_MisArgs = {
  change: AggregatorMisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_AuthArgs = {
  change: AuthInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_AuthorizationArgs = {
  change: AuthorizationInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Bank_AccountArgs = {
  change: BankAccountInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_BannerArgs = {
  change: BannerInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_BranchArgs = {
  change: BranchInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Branch_BannerArgs = {
  change: BranchBannerInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Branch_ImageArgs = {
  change: BranchImageInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Branch_IntegrationArgs = {
  change: BranchIntegrationInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Branch_ProductArgs = {
  change: BranchProductInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Branch_SettingArgs = {
  change: BranchSettingInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Branch_ShiftArgs = {
  change: BranchShiftInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Branch_Status_LogArgs = {
  change: BranchStatusLogInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_CartArgs = {
  change: CartInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_CategoryArgs = {
  change: CategoryInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Category_MisArgs = {
  change: CategoryMisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Category_ScheduleArgs = {
  change: CategoryScheduleInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Change_LogArgs = {
  change: ChangeLogInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_ChargeArgs = {
  change: ChargeInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Charge_BranchArgs = {
  change: ChargeBranchInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_CompanyArgs = {
  change: CompanyInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_CouponArgs = {
  change: CouponInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Coupon_BranchArgs = {
  change: CouponBranchInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_CustomerArgs = {
  change: CustomerInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Customer_AddressArgs = {
  change: CustomerAddressInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Customer_RatingArgs = {
  change: CustomerRatingInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Customization_GroupArgs = {
  change: CustomizationGroupInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Customization_Group_InlineArgs = {
  change: CustomizationGroupInlineInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Customization_Group_ProductArgs = {
  change: CustomizationGroupProductInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Delivery_SlotArgs = {
  change: DeliverySlotInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_DiscountArgs = {
  change: DiscountInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Discount_BranchArgs = {
  change: DiscountBranchInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Discount_CategoryArgs = {
  change: DiscountCategoryInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Discount_Product_XArgs = {
  change: DiscountProductXInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Discount_Product_YArgs = {
  change: DiscountProductYInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_EmployeeArgs = {
  change: EmployeeInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Food_Type_MisArgs = {
  change: FoodTypeMisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Free_DishArgs = {
  change: FreeDishInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Hourly_MisArgs = {
  change: HourlyMisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Inline_ChargeArgs = {
  change: InlineChargeInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Inline_ItemArgs = {
  change: InlineItemInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_InstanceArgs = {
  change: InstanceInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Instance_GoalArgs = {
  change: InstanceGoalInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_IntegrationArgs = {
  change: IntegrationInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Integration_ActionArgs = {
  change: IntegrationActionInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Integration_SettingArgs = {
  change: IntegrationSettingInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_MenuArgs = {
  change: MenuInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Menu_BranchArgs = {
  change: MenuBranchInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Menu_CategoryArgs = {
  change: MenuCategoryInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Menu_ProductArgs = {
  change: MenuProductInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Menu_Sync_LogArgs = {
  change: MenuSyncLogInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Menu_Tax_RateArgs = {
  change: MenuTaxRateInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_OrderArgs = {
  change: OrderInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_CommentArgs = {
  change: OrderCommentInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_ComplaintArgs = {
  change: OrderComplaintInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_Customer_DetailArgs = {
  change: OrderCustomerDetailInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_DiscountArgs = {
  change: OrderDiscountInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_Inline_ItemArgs = {
  change: OrderInlineItemInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_JsonArgs = {
  change: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdate_Order_Operation_LogArgs = {
  change: OrderOperationLogInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_PaymentArgs = {
  order_ids: Array<Scalars['String']['input']>;
  payment_type: PaymentType;
};


export type MutationUpdate_Order_RiderArgs = {
  change: OrderRiderInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_Secondary_TimelineArgs = {
  change: OrderSecondaryTimelineInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_StatusArgs = {
  order_id: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdate_Order_TaxArgs = {
  change: OrderTaxInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Order_Time_LineArgs = {
  change: OrderTimeLineInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Outlet_MisArgs = {
  change: OutletMisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Payment_ModeArgs = {
  change: PaymentModeInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Payment_Mode_And_SettleArgs = {
  branch_id: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  is_self_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['JSON']['input']>;
  order_id: Scalars['String']['input'];
  order_type?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  status_code: Scalars['String']['input'];
};


export type MutationUpdate_PermissionArgs = {
  change: PermissionInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Printer_ConfigArgs = {
  change: PrinterConfigInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Printer_MappingArgs = {
  change: PrinterMappingInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_ProductArgs = {
  change: ProductInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Product_ImageArgs = {
  change: ProductImageInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Product_MisArgs = {
  change: ProductMisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Product_Status_LogArgs = {
  change: ProductStatusLogInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Product_TranslationArgs = {
  change: ProductTranslationInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_RegisterArgs = {
  change: RegisterInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Register_ShiftArgs = {
  change: RegisterShiftInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Report_TemplateArgs = {
  change: ReportTemplateInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_RoleArgs = {
  change: RoleInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Role_PermissionArgs = {
  change: RolePermissionInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_ScheduleArgs = {
  change: ScheduleInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Secondary_Order_StatusArgs = {
  order_id: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdate_Secondary_StatusArgs = {
  change: SecondaryStatusInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_SectionArgs = {
  change: SectionInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_SettingArgs = {
  change: SettingInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_StaffArgs = {
  change: StaffInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Staff_CompanyArgs = {
  change: StaffCompanyInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_StatusArgs = {
  change: StatusInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Sub_CategoryArgs = {
  change: SubCategoryInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Sub_Category_MisArgs = {
  change: SubCategoryMisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Sub_Category_ProductArgs = {
  change: SubCategoryProductInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Sub_CompanyArgs = {
  change: SubCompanyInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Sub_Company_IntegrationArgs = {
  change: SubCompanyIntegrationInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Sub_Company_Integration_BranchArgs = {
  change: SubCompanyIntegrationBranchInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Sub_SectionArgs = {
  change: SubSectionInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_TagArgs = {
  change: TagInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_TaxArgs = {
  change: TaxInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Tax_RateArgs = {
  change: TaxRateInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_TicketArgs = {
  change: TicketInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Ticket_AnalysisArgs = {
  change: TicketAnalysisInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Ticket_HistoryArgs = {
  change: TicketHistoryInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Time_SlotArgs = {
  change: TimeSlotInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_UserArgs = {
  change: UserInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_User_BranchArgs = {
  change: UserBranchInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Web_App_CouponArgs = {
  change: WebAppCouponInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_WebsiteArgs = {
  change: WebsiteInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Website_InstanceArgs = {
  change: WebsiteInstanceInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdate_Website_Instance_BrandArgs = {
  change: WebsiteInstanceBrandInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdates_Activity_LogArgs = {
  rows: Array<ActivityLogInput>;
};


export type MutationUpdates_AddressArgs = {
  rows: Array<AddressInput>;
};


export type MutationUpdates_Aggregator_MisArgs = {
  rows: Array<AggregatorMisInput>;
};


export type MutationUpdates_AuthArgs = {
  rows: Array<AuthInput>;
};


export type MutationUpdates_AuthorizationArgs = {
  rows: Array<AuthorizationInput>;
};


export type MutationUpdates_Bank_AccountArgs = {
  rows: Array<BankAccountInput>;
};


export type MutationUpdates_BannerArgs = {
  rows: Array<BannerInput>;
};


export type MutationUpdates_BranchArgs = {
  rows: Array<BranchInput>;
};


export type MutationUpdates_Branch_BannerArgs = {
  rows: Array<BranchBannerInput>;
};


export type MutationUpdates_Branch_ImageArgs = {
  rows: Array<BranchImageInput>;
};


export type MutationUpdates_Branch_IntegrationArgs = {
  rows: Array<BranchIntegrationInput>;
};


export type MutationUpdates_Branch_ProductArgs = {
  rows: Array<BranchProductInput>;
};


export type MutationUpdates_Branch_SettingArgs = {
  rows: Array<BranchSettingInput>;
};


export type MutationUpdates_Branch_ShiftArgs = {
  rows: Array<BranchShiftInput>;
};


export type MutationUpdates_Branch_Status_LogArgs = {
  rows: Array<BranchStatusLogInput>;
};


export type MutationUpdates_CartArgs = {
  rows: Array<CartInput>;
};


export type MutationUpdates_CategoryArgs = {
  rows: Array<CategoryInput>;
};


export type MutationUpdates_Category_MisArgs = {
  rows: Array<CategoryMisInput>;
};


export type MutationUpdates_Category_ScheduleArgs = {
  rows: Array<CategoryScheduleInput>;
};


export type MutationUpdates_Change_LogArgs = {
  rows: Array<ChangeLogInput>;
};


export type MutationUpdates_ChargeArgs = {
  rows: Array<ChargeInput>;
};


export type MutationUpdates_Charge_BranchArgs = {
  rows: Array<ChargeBranchInput>;
};


export type MutationUpdates_CompanyArgs = {
  rows: Array<CompanyInput>;
};


export type MutationUpdates_CouponArgs = {
  rows: Array<CouponInput>;
};


export type MutationUpdates_Coupon_BranchArgs = {
  rows: Array<CouponBranchInput>;
};


export type MutationUpdates_CustomerArgs = {
  rows: Array<CustomerInput>;
};


export type MutationUpdates_Customer_AddressArgs = {
  rows: Array<CustomerAddressInput>;
};


export type MutationUpdates_Customer_RatingArgs = {
  rows: Array<CustomerRatingInput>;
};


export type MutationUpdates_Customization_GroupArgs = {
  rows: Array<CustomizationGroupInput>;
};


export type MutationUpdates_Customization_Group_InlineArgs = {
  rows: Array<CustomizationGroupInlineInput>;
};


export type MutationUpdates_Customization_Group_ProductArgs = {
  rows: Array<CustomizationGroupProductInput>;
};


export type MutationUpdates_Delivery_SlotArgs = {
  rows: Array<DeliverySlotInput>;
};


export type MutationUpdates_DiscountArgs = {
  rows: Array<DiscountInput>;
};


export type MutationUpdates_Discount_BranchArgs = {
  rows: Array<DiscountBranchInput>;
};


export type MutationUpdates_Discount_CategoryArgs = {
  rows: Array<DiscountCategoryInput>;
};


export type MutationUpdates_Discount_Product_XArgs = {
  rows: Array<DiscountProductXInput>;
};


export type MutationUpdates_Discount_Product_YArgs = {
  rows: Array<DiscountProductYInput>;
};


export type MutationUpdates_EmployeeArgs = {
  rows: Array<EmployeeInput>;
};


export type MutationUpdates_Food_Type_MisArgs = {
  rows: Array<FoodTypeMisInput>;
};


export type MutationUpdates_Free_DishArgs = {
  rows: Array<FreeDishInput>;
};


export type MutationUpdates_Hourly_MisArgs = {
  rows: Array<HourlyMisInput>;
};


export type MutationUpdates_Inline_ChargeArgs = {
  rows: Array<InlineChargeInput>;
};


export type MutationUpdates_Inline_ItemArgs = {
  rows: Array<InlineItemInput>;
};


export type MutationUpdates_InstanceArgs = {
  rows: Array<InstanceInput>;
};


export type MutationUpdates_Instance_GoalArgs = {
  rows: Array<InstanceGoalInput>;
};


export type MutationUpdates_IntegrationArgs = {
  rows: Array<IntegrationInput>;
};


export type MutationUpdates_Integration_ActionArgs = {
  rows: Array<IntegrationActionInput>;
};


export type MutationUpdates_Integration_SettingArgs = {
  rows: Array<IntegrationSettingInput>;
};


export type MutationUpdates_MenuArgs = {
  rows: Array<MenuInput>;
};


export type MutationUpdates_Menu_BranchArgs = {
  rows: Array<MenuBranchInput>;
};


export type MutationUpdates_Menu_CategoryArgs = {
  rows: Array<MenuCategoryInput>;
};


export type MutationUpdates_Menu_ProductArgs = {
  rows: Array<MenuProductInput>;
};


export type MutationUpdates_Menu_Sync_LogArgs = {
  rows: Array<MenuSyncLogInput>;
};


export type MutationUpdates_Menu_Tax_RateArgs = {
  rows: Array<MenuTaxRateInput>;
};


export type MutationUpdates_OrderArgs = {
  rows: Array<OrderInput>;
};


export type MutationUpdates_Order_CommentArgs = {
  rows: Array<OrderCommentInput>;
};


export type MutationUpdates_Order_ComplaintArgs = {
  rows: Array<OrderComplaintInput>;
};


export type MutationUpdates_Order_Customer_DetailArgs = {
  rows: Array<OrderCustomerDetailInput>;
};


export type MutationUpdates_Order_DiscountArgs = {
  rows: Array<OrderDiscountInput>;
};


export type MutationUpdates_Order_Inline_ItemArgs = {
  rows: Array<OrderInlineItemInput>;
};


export type MutationUpdates_Order_JsonArgs = {
  rows: Array<Scalars['JSON']['input']>;
};


export type MutationUpdates_Order_Operation_LogArgs = {
  rows: Array<OrderOperationLogInput>;
};


export type MutationUpdates_Order_PaymentArgs = {
  rows: Array<OrderPaymentInput>;
};


export type MutationUpdates_Order_RiderArgs = {
  rows: Array<OrderRiderInput>;
};


export type MutationUpdates_Order_Secondary_TimelineArgs = {
  rows: Array<OrderSecondaryTimelineInput>;
};


export type MutationUpdates_Order_TaxArgs = {
  rows: Array<OrderTaxInput>;
};


export type MutationUpdates_Order_Time_LineArgs = {
  rows: Array<OrderTimeLineInput>;
};


export type MutationUpdates_Outlet_MisArgs = {
  rows: Array<OutletMisInput>;
};


export type MutationUpdates_Payment_ModeArgs = {
  rows: Array<PaymentModeInput>;
};


export type MutationUpdates_PermissionArgs = {
  rows: Array<PermissionInput>;
};


export type MutationUpdates_Printer_ConfigArgs = {
  rows: Array<PrinterConfigInput>;
};


export type MutationUpdates_Printer_MappingArgs = {
  rows: Array<PrinterMappingInput>;
};


export type MutationUpdates_ProductArgs = {
  rows: Array<ProductInput>;
};


export type MutationUpdates_Product_ImageArgs = {
  rows: Array<ProductImageInput>;
};


export type MutationUpdates_Product_MisArgs = {
  rows: Array<ProductMisInput>;
};


export type MutationUpdates_Product_Status_LogArgs = {
  rows: Array<ProductStatusLogInput>;
};


export type MutationUpdates_Product_TranslationArgs = {
  rows: Array<ProductTranslationInput>;
};


export type MutationUpdates_RegisterArgs = {
  rows: Array<RegisterInput>;
};


export type MutationUpdates_Register_ShiftArgs = {
  rows: Array<RegisterShiftInput>;
};


export type MutationUpdates_Report_TemplateArgs = {
  rows: Array<ReportTemplateInput>;
};


export type MutationUpdates_RoleArgs = {
  rows: Array<RoleInput>;
};


export type MutationUpdates_Role_PermissionArgs = {
  rows: Array<RolePermissionInput>;
};


export type MutationUpdates_ScheduleArgs = {
  rows: Array<ScheduleInput>;
};


export type MutationUpdates_Secondary_StatusArgs = {
  rows: Array<SecondaryStatusInput>;
};


export type MutationUpdates_SectionArgs = {
  rows: Array<SectionInput>;
};


export type MutationUpdates_SettingArgs = {
  rows: Array<SettingInput>;
};


export type MutationUpdates_StaffArgs = {
  rows: Array<StaffInput>;
};


export type MutationUpdates_Staff_CompanyArgs = {
  rows: Array<StaffCompanyInput>;
};


export type MutationUpdates_StatusArgs = {
  rows: Array<StatusInput>;
};


export type MutationUpdates_Sub_CategoryArgs = {
  rows: Array<SubCategoryInput>;
};


export type MutationUpdates_Sub_Category_MisArgs = {
  rows: Array<SubCategoryMisInput>;
};


export type MutationUpdates_Sub_Category_ProductArgs = {
  rows: Array<SubCategoryProductInput>;
};


export type MutationUpdates_Sub_CompanyArgs = {
  rows: Array<SubCompanyInput>;
};


export type MutationUpdates_Sub_Company_IntegrationArgs = {
  rows: Array<SubCompanyIntegrationInput>;
};


export type MutationUpdates_Sub_Company_Integration_BranchArgs = {
  rows: Array<SubCompanyIntegrationBranchInput>;
};


export type MutationUpdates_Sub_SectionArgs = {
  rows: Array<SubSectionInput>;
};


export type MutationUpdates_TagArgs = {
  rows: Array<TagInput>;
};


export type MutationUpdates_TaxArgs = {
  rows: Array<TaxInput>;
};


export type MutationUpdates_Tax_RateArgs = {
  rows: Array<TaxRateInput>;
};


export type MutationUpdates_TicketArgs = {
  rows: Array<TicketInput>;
};


export type MutationUpdates_Ticket_AnalysisArgs = {
  rows: Array<TicketAnalysisInput>;
};


export type MutationUpdates_Ticket_HistoryArgs = {
  rows: Array<TicketHistoryInput>;
};


export type MutationUpdates_Time_SlotArgs = {
  rows: Array<TimeSlotInput>;
};


export type MutationUpdates_UserArgs = {
  rows: Array<UserInput>;
};


export type MutationUpdates_User_BranchArgs = {
  rows: Array<UserBranchInput>;
};


export type MutationUpdates_Web_App_CouponArgs = {
  rows: Array<WebAppCouponInput>;
};


export type MutationUpdates_WebsiteArgs = {
  rows: Array<WebsiteInput>;
};


export type MutationUpdates_Website_InstanceArgs = {
  rows: Array<WebsiteInstanceInput>;
};


export type MutationUpdates_Website_Instance_BrandArgs = {
  rows: Array<WebsiteInstanceBrandInput>;
};


export type MutationVariants_By_Product_IdArgs = {
  menu_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
};

export enum NutritionInfoUnit {
  Grams = 'GRAMS',
  Mg = 'MG'
}

export type OnboardAddressInput = {
  address_line_1: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pincode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type OnboardBranchInput = {
  fssai_license_no: Scalars['String']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OnboardClientConfigInput = {
  create_new_company: Scalars['Boolean']['input'];
  existing_company_id?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardClientInput = {
  address: OnboardAddressInput;
  branch: OnboardBranchInput;
  company_name: Scalars['String']['input'];
  config: OnboardClientConfigInput;
  instance: OnboardInstanceInput;
  role: OnboardRoleInput;
  sub_company: OnboardSubCompanyInput;
  user: OnboardUserInput;
};

export type OnboardInstanceInput = {
  name: Scalars['String']['input'];
};

export type OnboardRoleInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OnboardSubCompanyInput = {
  currency: Scalars['String']['input'];
  phone_code: Scalars['String']['input'];
  sub_company_name: Scalars['String']['input'];
  time_zone_string: Scalars['String']['input'];
};

export type OnboardUserInput = {
  email: Scalars['String']['input'];
  mobile_number: Scalars['String']['input'];
  name: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Order = {
  __typename?: 'Order';
  accepted_at?: Maybe<Scalars['Datetime']['output']>;
  aggregator_order_id?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  branch_location: Scalars['String']['output'];
  branch_name: Scalars['String']['output'];
  business_date?: Maybe<Scalars['Date']['output']>;
  cancelled_at?: Maybe<Scalars['Datetime']['output']>;
  charges: Array<InlineCharge>;
  comments: Array<OrderComment>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  complimentary_amount?: Maybe<Scalars['Float']['output']>;
  cover?: Maybe<Scalars['Int']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customer?: Maybe<OrderCustomerDetail>;
  customer_id?: Maybe<Scalars['UUID']['output']>;
  delivery_charge_amount?: Maybe<Scalars['Float']['output']>;
  delivery_charge_tax_amount?: Maybe<Scalars['Float']['output']>;
  delivery_charge_tax_value?: Maybe<Scalars['Float']['output']>;
  delivery_start_date?: Maybe<Scalars['Date']['output']>;
  delivery_start_time?: Maybe<Scalars['Time']['output']>;
  delivery_time?: Maybe<Scalars['Int']['output']>;
  discounts: Array<OrderDiscount>;
  dispatched_at?: Maybe<Scalars['Datetime']['output']>;
  es_synced_on?: Maybe<Scalars['Datetime']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  instance?: Maybe<Instance>;
  instance_id: Scalars['UUID']['output'];
  instance_name: Scalars['String']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  invoice_number?: Maybe<Scalars['Int']['output']>;
  invoice_prefix?: Maybe<Scalars['String']['output']>;
  invoice_suffix?: Maybe<Scalars['String']['output']>;
  invoice_time?: Maybe<Scalars['Datetime']['output']>;
  is_advance_order?: Maybe<Scalars['Boolean']['output']>;
  is_bulk_order?: Maybe<Scalars['Boolean']['output']>;
  is_credit_order?: Maybe<Scalars['Boolean']['output']>;
  is_dispatched?: Maybe<Scalars['Boolean']['output']>;
  is_food_prepared?: Maybe<Scalars['Boolean']['output']>;
  is_pos_order?: Maybe<Scalars['Boolean']['output']>;
  is_self_delivery?: Maybe<Scalars['Boolean']['output']>;
  items: Array<OrderInlineItem>;
  json_meta_field_1?: Maybe<Scalars['JSON']['output']>;
  json_meta_field_2?: Maybe<Scalars['JSON']['output']>;
  json_meta_field_3?: Maybe<Scalars['JSON']['output']>;
  kot_number: Scalars['Int']['output'];
  kot_prefix: Scalars['String']['output'];
  last_bill_printed_at?: Maybe<Scalars['Datetime']['output']>;
  last_kot_printed_at?: Maybe<Scalars['Datetime']['output']>;
  loyalty_points?: Maybe<Scalars['Int']['output']>;
  masked_number?: Maybe<Scalars['String']['output']>;
  number_meta_field_1?: Maybe<Scalars['Float']['output']>;
  number_meta_field_2?: Maybe<Scalars['Float']['output']>;
  number_meta_field_3?: Maybe<Scalars['Float']['output']>;
  online_order_status?: Maybe<Status>;
  order_date?: Maybe<Scalars['Date']['output']>;
  order_settled_by_user_id?: Maybe<Scalars['UUID']['output']>;
  order_settled_by_user_name?: Maybe<Scalars['String']['output']>;
  order_status: OrderStatus;
  order_time?: Maybe<Scalars['Time']['output']>;
  order_type?: Maybe<OrderType>;
  ordering_slot?: Maybe<OrderingSlot>;
  other_charge_amount?: Maybe<Scalars['Float']['output']>;
  other_charge_tax_amount?: Maybe<Scalars['Float']['output']>;
  other_charge_tax_value?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  otp_message?: Maybe<Scalars['String']['output']>;
  packaging_charge_amount?: Maybe<Scalars['Float']['output']>;
  packaging_charge_tax_amount?: Maybe<Scalars['Float']['output']>;
  packaging_charge_tax_value?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['UUID']['output']>;
  parent_order?: Maybe<Order>;
  payments: Array<OrderPayment>;
  prep_time?: Maybe<Scalars['Int']['output']>;
  prepared_at?: Maybe<Scalars['Datetime']['output']>;
  processing_timestamp?: Maybe<Scalars['Datetime']['output']>;
  referral_code?: Maybe<Scalars['String']['output']>;
  reject_code?: Maybe<Scalars['String']['output']>;
  reject_reason?: Maybe<Scalars['String']['output']>;
  rider?: Maybe<OrderRider>;
  rider_name?: Maybe<Scalars['String']['output']>;
  rider_phone?: Maybe<Scalars['String']['output']>;
  round_off?: Maybe<Scalars['Float']['output']>;
  secondary_timeline: Array<OrderSecondaryTimeline>;
  section_id?: Maybe<Scalars['UUID']['output']>;
  section_name?: Maybe<Scalars['String']['output']>;
  sequence_id: Scalars['Int']['output'];
  service_charge_amount?: Maybe<Scalars['Float']['output']>;
  service_charge_tax_amount?: Maybe<Scalars['Float']['output']>;
  service_charge_tax_value?: Maybe<Scalars['Float']['output']>;
  settled_at?: Maybe<Scalars['Datetime']['output']>;
  source: Scalars['String']['output'];
  status_code?: Maybe<StatusCode>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  sub_orders: Array<Order>;
  sub_section_id?: Maybe<Scalars['UUID']['output']>;
  sub_section_name?: Maybe<Scalars['String']['output']>;
  sub_total: Scalars['Float']['output'];
  taxes?: Maybe<Scalars['JSON']['output']>;
  text_meta_field_1?: Maybe<Scalars['String']['output']>;
  text_meta_field_2?: Maybe<Scalars['String']['output']>;
  text_meta_field_3?: Maybe<Scalars['String']['output']>;
  timeline: Array<OrderTimeLine>;
  total: Scalars['Float']['output'];
  total_aggregator_charge_taxes: Scalars['Float']['output'];
  total_aggregator_item_taxes: Scalars['Float']['output'];
  total_aggregator_taxes: Scalars['Float']['output'];
  total_charges: Scalars['Float']['output'];
  total_charges_tax: Scalars['Float']['output'];
  total_discount: Scalars['Float']['output'];
  total_discount_percentage: Scalars['Float']['output'];
  total_item_discount?: Maybe<Scalars['Float']['output']>;
  total_item_packaging_charge_amount?: Maybe<Scalars['Float']['output']>;
  total_item_packaging_charge_tax_amount?: Maybe<Scalars['Float']['output']>;
  total_item_tax: Scalars['Float']['output'];
  total_merchant_charge_taxes: Scalars['Float']['output'];
  total_merchant_item_taxes: Scalars['Float']['output'];
  total_merchant_taxes: Scalars['Float']['output'];
  total_tax: Scalars['Float']['output'];
  unix_timestamp: Scalars['Int']['output'];
  unix_timestamp_updated: Scalars['Int']['output'];
  update_uuid: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  waiter_id?: Maybe<Scalars['UUID']['output']>;
  waiter_name?: Maybe<Scalars['String']['output']>;
  waiter_phone?: Maybe<Scalars['String']['output']>;
  website_cart_id?: Maybe<Scalars['UUID']['output']>;
};


export type OrderAccepted_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderAggregator_Order_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderBranch_LocationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderBranch_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderBusiness_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderCancelled_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplimentary_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderCoverArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderCustomer_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDelivery_Charge_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDelivery_Charge_Tax_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDelivery_Charge_Tax_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDelivery_Start_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderDelivery_Start_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type OrderDelivery_TimeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDispatched_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderEs_Synced_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInstance_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInstructionsArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInvoice_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInvoice_PrefixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInvoice_SuffixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInvoice_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderIs_Advance_OrderArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderIs_Bulk_OrderArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderIs_Credit_OrderArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderIs_DispatchedArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderIs_Food_PreparedArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderIs_Pos_OrderArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderIs_Self_DeliveryArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderKot_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderKot_PrefixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderLast_Bill_Printed_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderLast_Kot_Printed_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderLoyalty_PointsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderMasked_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderNumber_Meta_Field_1Args = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderNumber_Meta_Field_2Args = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderNumber_Meta_Field_3Args = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderOrder_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderOrder_Settled_By_User_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOrder_Settled_By_User_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOrder_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOrder_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type OrderOrder_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOrdering_SlotArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOther_Charge_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderOther_Charge_Tax_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderOther_Charge_Tax_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderOtpArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOtp_MessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderPackaging_Charge_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderPackaging_Charge_Tax_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderPackaging_Charge_Tax_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderParent_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderPrep_TimeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderPrepared_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderProcessing_TimestampArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderReferral_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderReject_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderReject_ReasonArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRider_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRider_PhoneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRound_OffArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderSection_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSection_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSequence_IdArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderService_Charge_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderService_Charge_Tax_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderService_Charge_Tax_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderSettled_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderSourceArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderStatus_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSub_Section_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSub_Section_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSub_TotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderText_Meta_Field_1Args = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderText_Meta_Field_2Args = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderText_Meta_Field_3Args = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Aggregator_Charge_TaxesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Aggregator_Item_TaxesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Aggregator_TaxesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_ChargesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Charges_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Discount_PercentageArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Item_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Item_Packaging_Charge_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Item_Packaging_Charge_Tax_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Item_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Merchant_Charge_TaxesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Merchant_Item_TaxesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_Merchant_TaxesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTotal_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderUnix_TimestampArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderUnix_Timestamp_UpdatedArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderUpdate_UuidArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderUser_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderWaiter_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderWaiter_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderWaiter_PhoneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderWebsite_Cart_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderComment = {
  __typename?: 'OrderComment';
  comment_timestamp?: Maybe<Scalars['Datetime']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  item?: Maybe<OrderInlineItem>;
  item_id?: Maybe<Scalars['UUID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  order_id?: Maybe<Scalars['UUID']['output']>;
  tags?: Maybe<Scalars['JSON']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type OrderCommentComment_TimestampArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderCommentCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderCommentIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCommentItem_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCommentKeyArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCommentOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCommentUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderCommentUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCommentUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCommentValueArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCommentInput = {
  comment_timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  item?: InputMaybe<OrderInlineItemInput>;
  item_id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OrderComplaint = {
  __typename?: 'OrderComplaint';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  complaint_status: ComplaintStatus;
  complaint_type: Scalars['String']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  order?: Maybe<Order>;
  order_id: Scalars['UUID']['output'];
  resolution_details?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


export type OrderComplaintCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintComplaint_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintComplaint_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderComplaintDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintResolution_DetailsArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderComplaintUser_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderComplaintUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderComplaintInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  complaint_status?: InputMaybe<ComplaintStatus>;
  complaint_type?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  order?: InputMaybe<OrderInput>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  resolution_details?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCustomerDetail = {
  __typename?: 'OrderCustomerDetail';
  address?: Maybe<Scalars['String']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_customer_anniversary?: Maybe<Scalars['Date']['output']>;
  billing_customer_dob?: Maybe<Scalars['Date']['output']>;
  billing_customer_email?: Maybe<Scalars['String']['output']>;
  billing_customer_gender?: Maybe<Scalars['String']['output']>;
  billing_customer_gst?: Maybe<Scalars['String']['output']>;
  billing_customer_name?: Maybe<Scalars['String']['output']>;
  billing_customer_number?: Maybe<Scalars['String']['output']>;
  billing_geom?: Maybe<Geom>;
  billing_landmark?: Maybe<Scalars['String']['output']>;
  billing_pincode?: Maybe<Scalars['String']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customer_anniversary?: Maybe<Scalars['Date']['output']>;
  customer_dob?: Maybe<Scalars['Date']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_gender?: Maybe<Scalars['String']['output']>;
  customer_gst?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['UUID']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_number?: Maybe<Scalars['String']['output']>;
  external_customer_id?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Geom>;
  id: Scalars['UUID']['output'];
  landmark?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  pincode?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type OrderCustomerDetailAddressArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_AddressArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_Customer_AnniversaryArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderCustomerDetailBilling_Customer_DobArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderCustomerDetailBilling_Customer_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_Customer_GenderArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_Customer_GstArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_Customer_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_Customer_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_LandmarkArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailBilling_PincodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderCustomerDetailCustomer_AnniversaryArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderCustomerDetailCustomer_DobArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderCustomerDetailCustomer_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailCustomer_GenderArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailCustomer_GstArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailCustomer_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailCustomer_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailCustomer_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailExternal_Customer_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailLandmarkArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailPincodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderCustomerDetailUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderCustomerDetailInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  billing_address?: InputMaybe<Scalars['String']['input']>;
  billing_customer_anniversary?: InputMaybe<Scalars['Date']['input']>;
  billing_customer_dob?: InputMaybe<Scalars['Date']['input']>;
  billing_customer_email?: InputMaybe<Scalars['String']['input']>;
  billing_customer_gender?: InputMaybe<Scalars['String']['input']>;
  billing_customer_gst?: InputMaybe<Scalars['String']['input']>;
  billing_customer_name?: InputMaybe<Scalars['String']['input']>;
  billing_customer_number?: InputMaybe<Scalars['String']['input']>;
  billing_geom?: InputMaybe<GeomInput>;
  billing_landmark?: InputMaybe<Scalars['String']['input']>;
  billing_pincode?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customer_anniversary?: InputMaybe<Scalars['Date']['input']>;
  customer_dob?: InputMaybe<Scalars['Date']['input']>;
  customer_email?: InputMaybe<Scalars['String']['input']>;
  customer_gender?: InputMaybe<Scalars['String']['input']>;
  customer_gst?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['UUID']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_number?: InputMaybe<Scalars['String']['input']>;
  external_customer_id?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<GeomInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderDiscount = {
  __typename?: 'OrderDiscount';
  clubbed_with_other_discounts: Scalars['Boolean']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  discount_amount: Scalars['Float']['output'];
  discount_applicable_on_type: Scalars['String']['output'];
  discount_id?: Maybe<Scalars['UUID']['output']>;
  discount_name: Scalars['String']['output'];
  discount_offer_type: Scalars['String']['output'];
  discount_responsible_type: Scalars['String']['output'];
  discount_sequence: Scalars['Int']['output'];
  discount_type: Scalars['String']['output'];
  discount_value: Scalars['Float']['output'];
  discountable_subtotal: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  max_discount: Scalars['Float']['output'];
  min_order_value: Scalars['Float']['output'];
  order?: Maybe<Order>;
  order_id: Scalars['UUID']['output'];
  redeemed_coupon_id?: Maybe<Scalars['String']['output']>;
  redeemed_points?: Maybe<Scalars['Float']['output']>;
  reedemed_coupon_code?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type OrderDiscountClubbed_With_Other_DiscountsArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderDiscountCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderDiscountDiscount_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDiscountDiscount_Applicable_On_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountDiscount_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountDiscount_Offer_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountDiscount_Responsible_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountDiscount_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDiscountDiscount_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountDiscount_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDiscountDiscountable_SubtotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDiscountIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountMax_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDiscountMin_Order_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDiscountOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountRedeemed_Coupon_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountRedeemed_PointsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderDiscountReedemed_Coupon_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderDiscountUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderDiscountInput = {
  clubbed_with_other_discounts?: InputMaybe<Scalars['Boolean']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  discount_amount?: InputMaybe<Scalars['Float']['input']>;
  discount_applicable_on_type?: InputMaybe<Scalars['String']['input']>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  discount_name?: InputMaybe<Scalars['String']['input']>;
  discount_offer_type?: InputMaybe<Scalars['String']['input']>;
  discount_responsible_type?: InputMaybe<Scalars['String']['input']>;
  discount_sequence?: InputMaybe<Scalars['Int']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  discountable_subtotal?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  max_discount?: InputMaybe<Scalars['Float']['input']>;
  min_order_value?: InputMaybe<Scalars['Float']['input']>;
  order?: InputMaybe<OrderInput>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  redeemed_coupon_id?: InputMaybe<Scalars['String']['input']>;
  redeemed_points?: InputMaybe<Scalars['Float']['input']>;
  reedemed_coupon_code?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderInlineItem = {
  __typename?: 'OrderInlineItem';
  branch_id?: Maybe<Scalars['UUID']['output']>;
  branch_location?: Maybe<Scalars['String']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  business_date?: Maybe<Scalars['Date']['output']>;
  category_id?: Maybe<Scalars['UUID']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
  children: Array<OrderInlineItem>;
  comments: Array<OrderComment>;
  complimentary_message?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customer_id?: Maybe<Scalars['UUID']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_number?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  es_synced_on?: Maybe<Scalars['Datetime']['output']>;
  final_price: Scalars['Float']['output'];
  first_variant_id?: Maybe<Scalars['UUID']['output']>;
  first_variant_name?: Maybe<Scalars['String']['output']>;
  first_variant_price?: Maybe<Scalars['Float']['output']>;
  food_type?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['UUID']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  instance_id?: Maybe<Scalars['UUID']['output']>;
  instance_name?: Maybe<Scalars['String']['output']>;
  invoice_number?: Maybe<Scalars['Int']['output']>;
  invoice_prefix?: Maybe<Scalars['String']['output']>;
  invoice_suffix?: Maybe<Scalars['String']['output']>;
  is_complimentary: Scalars['Boolean']['output'];
  is_discount_exempt?: Maybe<Scalars['Boolean']['output']>;
  is_order_dispatched?: Maybe<Scalars['Boolean']['output']>;
  is_transferred?: Maybe<Scalars['Boolean']['output']>;
  is_void: Scalars['Boolean']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  item_discount_percentage?: Maybe<Scalars['Float']['output']>;
  item_name: Scalars['String']['output'];
  item_price: Scalars['Float']['output'];
  item_quantity: Scalars['Float']['output'];
  item_reporting_quantity?: Maybe<Scalars['Float']['output']>;
  item_sub_total: Scalars['Float']['output'];
  item_tax_name?: Maybe<Scalars['String']['output']>;
  item_tax_percent: Scalars['Float']['output'];
  item_total: Scalars['Float']['output'];
  item_total_discount: Scalars['Float']['output'];
  item_total_tax: Scalars['Float']['output'];
  item_type?: Maybe<Scalars['String']['output']>;
  json_meta_field_1?: Maybe<Scalars['JSON']['output']>;
  json_meta_field_2?: Maybe<Scalars['JSON']['output']>;
  json_meta_field_3?: Maybe<Scalars['JSON']['output']>;
  kitchen?: Maybe<Scalars['String']['output']>;
  kot_number?: Maybe<Scalars['Int']['output']>;
  merchant_item_tax?: Maybe<Scalars['Float']['output']>;
  merchant_item_tax_percent?: Maybe<Scalars['Float']['output']>;
  number_meta_field_1?: Maybe<Scalars['Float']['output']>;
  number_meta_field_2?: Maybe<Scalars['Float']['output']>;
  number_meta_field_3?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Order>;
  order_date?: Maybe<Scalars['Date']['output']>;
  order_external_id?: Maybe<Scalars['String']['output']>;
  order_id: Scalars['UUID']['output'];
  order_placed_by?: Maybe<Scalars['String']['output']>;
  order_settled_by?: Maybe<Scalars['String']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  order_time?: Maybe<Scalars['Time']['output']>;
  packaging_charge_amount?: Maybe<Scalars['Float']['output']>;
  packaging_charge_tax_amount?: Maybe<Scalars['Float']['output']>;
  packaging_charge_tax_value?: Maybe<Scalars['Float']['output']>;
  packaging_charge_taxes?: Maybe<Scalars['JSON']['output']>;
  parent?: Maybe<OrderInlineItem>;
  parent_id?: Maybe<Scalars['UUID']['output']>;
  pos_id?: Maybe<Scalars['UUID']['output']>;
  prepared_at?: Maybe<Scalars['Datetime']['output']>;
  prepared_in_min?: Maybe<Scalars['Int']['output']>;
  printer_type?: Maybe<Scalars['String']['output']>;
  product_classification?: Maybe<Scalars['String']['output']>;
  product_cost_price?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['UUID']['output']>;
  product_type?: Maybe<Scalars['String']['output']>;
  product_weight?: Maybe<Scalars['Float']['output']>;
  profit?: Maybe<Scalars['Float']['output']>;
  second_variant_id?: Maybe<Scalars['UUID']['output']>;
  second_variant_name?: Maybe<Scalars['String']['output']>;
  second_variant_price?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sub_category_id?: Maybe<Scalars['UUID']['output']>;
  sub_category_name?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['JSON']['output']>;
  tax_id?: Maybe<Scalars['UUID']['output']>;
  taxes?: Maybe<Scalars['JSON']['output']>;
  text_meta_field_1?: Maybe<Scalars['String']['output']>;
  text_meta_field_2?: Maybe<Scalars['String']['output']>;
  text_meta_field_3?: Maybe<Scalars['String']['output']>;
  total_agg_tax?: Maybe<Scalars['Float']['output']>;
  total_agg_tax_percent?: Maybe<Scalars['Float']['output']>;
  transfer_message?: Maybe<Scalars['String']['output']>;
  transferred_from_order_id?: Maybe<Scalars['UUID']['output']>;
  translations?: Maybe<Scalars['JSON']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  void_message?: Maybe<Scalars['String']['output']>;
};


export type OrderInlineItemBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemBranch_LocationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemBranch_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemBusiness_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderInlineItemCategory_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemCategory_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemComplimentary_MessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemCostArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderInlineItemCustomer_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemCustomer_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemCustomer_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemDepartmentArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemEs_Synced_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderInlineItemFinal_PriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemFirst_Variant_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemFirst_Variant_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemFirst_Variant_PriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemFood_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemGroup_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemGroup_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemInstance_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemInvoice_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemInvoice_PrefixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemInvoice_SuffixArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemIs_ComplimentaryArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderInlineItemIs_Discount_ExemptArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderInlineItemIs_Order_DispatchedArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderInlineItemIs_TransferredArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderInlineItemIs_VoidArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderInlineItemItem_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemItem_Discount_PercentageArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemItem_PriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_QuantityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_Reporting_QuantityArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_Sub_TotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_Tax_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemItem_Tax_PercentArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_TotalArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_Total_DiscountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_Total_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemItem_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemKitchenArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemKot_NumberArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemMerchant_Item_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemMerchant_Item_Tax_PercentArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemNumber_Meta_Field_1Args = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemNumber_Meta_Field_2Args = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemNumber_Meta_Field_3Args = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemOrder_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OrderInlineItemOrder_External_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemOrder_Placed_ByArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemOrder_Settled_ByArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemOrder_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemOrder_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type OrderInlineItemPackaging_Charge_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemPackaging_Charge_Tax_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemPackaging_Charge_Tax_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemParent_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemPos_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemPrepared_AtArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderInlineItemPrepared_In_MinArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemPrinter_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemProduct_ClassificationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemProduct_Cost_PriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemProduct_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemProduct_WeightArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemProfitArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemSecond_Variant_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemSecond_Variant_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemSecond_Variant_PriceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemSourceArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemSub_Category_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemSub_Category_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemTax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemText_Meta_Field_1Args = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemText_Meta_Field_2Args = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemText_Meta_Field_3Args = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemTotal_Agg_TaxArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemTotal_Agg_Tax_PercentArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderInlineItemTransfer_MessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemTransferred_From_Order_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderInlineItemUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderInlineItemVoid_MessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderInlineItemInput = {
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  branch_location?: InputMaybe<Scalars['String']['input']>;
  branch_name?: InputMaybe<Scalars['String']['input']>;
  business_date?: InputMaybe<Scalars['Date']['input']>;
  category_id?: InputMaybe<Scalars['UUID']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<InputMaybe<OrderInlineItemInput>>>;
  comments?: InputMaybe<Array<InputMaybe<OrderCommentInput>>>;
  complimentary_message?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customer_id?: InputMaybe<Scalars['UUID']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_number?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  es_synced_on?: InputMaybe<Scalars['Datetime']['input']>;
  final_price?: InputMaybe<Scalars['Float']['input']>;
  first_variant_id?: InputMaybe<Scalars['UUID']['input']>;
  first_variant_name?: InputMaybe<Scalars['String']['input']>;
  first_variant_price?: InputMaybe<Scalars['Float']['input']>;
  food_type?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['UUID']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  instance_name?: InputMaybe<Scalars['String']['input']>;
  invoice_number?: InputMaybe<Scalars['Int']['input']>;
  invoice_prefix?: InputMaybe<Scalars['String']['input']>;
  invoice_suffix?: InputMaybe<Scalars['String']['input']>;
  is_complimentary?: InputMaybe<Scalars['Boolean']['input']>;
  is_discount_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  is_order_dispatched?: InputMaybe<Scalars['Boolean']['input']>;
  is_transferred?: InputMaybe<Scalars['Boolean']['input']>;
  is_void?: InputMaybe<Scalars['Boolean']['input']>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  item_discount_percentage?: InputMaybe<Scalars['Float']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_price?: InputMaybe<Scalars['Float']['input']>;
  item_quantity?: InputMaybe<Scalars['Float']['input']>;
  item_reporting_quantity?: InputMaybe<Scalars['Float']['input']>;
  item_sub_total?: InputMaybe<Scalars['Float']['input']>;
  item_tax_name?: InputMaybe<Scalars['String']['input']>;
  item_tax_percent?: InputMaybe<Scalars['Float']['input']>;
  item_total?: InputMaybe<Scalars['Float']['input']>;
  item_total_discount?: InputMaybe<Scalars['Float']['input']>;
  item_total_tax?: InputMaybe<Scalars['Float']['input']>;
  item_type?: InputMaybe<Scalars['String']['input']>;
  json_meta_field_1?: InputMaybe<Scalars['JSON']['input']>;
  json_meta_field_2?: InputMaybe<Scalars['JSON']['input']>;
  json_meta_field_3?: InputMaybe<Scalars['JSON']['input']>;
  kitchen?: InputMaybe<Scalars['String']['input']>;
  kot_number?: InputMaybe<Scalars['Int']['input']>;
  merchant_item_tax?: InputMaybe<Scalars['Float']['input']>;
  merchant_item_tax_percent?: InputMaybe<Scalars['Float']['input']>;
  number_meta_field_1?: InputMaybe<Scalars['Float']['input']>;
  number_meta_field_2?: InputMaybe<Scalars['Float']['input']>;
  number_meta_field_3?: InputMaybe<Scalars['Float']['input']>;
  order?: InputMaybe<OrderInput>;
  order_date?: InputMaybe<Scalars['Date']['input']>;
  order_external_id?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  order_placed_by?: InputMaybe<Scalars['String']['input']>;
  order_settled_by?: InputMaybe<Scalars['String']['input']>;
  order_status?: InputMaybe<Scalars['String']['input']>;
  order_time?: InputMaybe<Scalars['Time']['input']>;
  packaging_charge_amount?: InputMaybe<Scalars['Float']['input']>;
  packaging_charge_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  packaging_charge_tax_value?: InputMaybe<Scalars['Float']['input']>;
  packaging_charge_taxes?: InputMaybe<Scalars['JSON']['input']>;
  parent?: InputMaybe<OrderInlineItemInput>;
  parent_id?: InputMaybe<Scalars['UUID']['input']>;
  pos_id?: InputMaybe<Scalars['UUID']['input']>;
  prepared_at?: InputMaybe<Scalars['Datetime']['input']>;
  prepared_in_min?: InputMaybe<Scalars['Int']['input']>;
  printer_type?: InputMaybe<Scalars['String']['input']>;
  product_classification?: InputMaybe<Scalars['String']['input']>;
  product_cost_price?: InputMaybe<Scalars['Float']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  product_weight?: InputMaybe<Scalars['Float']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  second_variant_id?: InputMaybe<Scalars['UUID']['input']>;
  second_variant_name?: InputMaybe<Scalars['String']['input']>;
  second_variant_price?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sub_category_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_category_name?: InputMaybe<Scalars['String']['input']>;
  tax?: InputMaybe<Scalars['JSON']['input']>;
  tax_id?: InputMaybe<Scalars['UUID']['input']>;
  taxes?: InputMaybe<Scalars['JSON']['input']>;
  text_meta_field_1?: InputMaybe<Scalars['String']['input']>;
  text_meta_field_2?: InputMaybe<Scalars['String']['input']>;
  text_meta_field_3?: InputMaybe<Scalars['String']['input']>;
  total_agg_tax?: InputMaybe<Scalars['Float']['input']>;
  total_agg_tax_percent?: InputMaybe<Scalars['Float']['input']>;
  transfer_message?: InputMaybe<Scalars['String']['input']>;
  transferred_from_order_id?: InputMaybe<Scalars['UUID']['input']>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  void_message?: InputMaybe<Scalars['String']['input']>;
};

export type OrderInput = {
  accepted_at?: InputMaybe<Scalars['Datetime']['input']>;
  aggregator_order_id?: InputMaybe<Scalars['String']['input']>;
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  branch_location?: InputMaybe<Scalars['String']['input']>;
  branch_name?: InputMaybe<Scalars['String']['input']>;
  business_date?: InputMaybe<Scalars['Date']['input']>;
  cancelled_at?: InputMaybe<Scalars['Datetime']['input']>;
  charges?: InputMaybe<Array<InputMaybe<InlineChargeInput>>>;
  comments?: InputMaybe<Array<InputMaybe<OrderCommentInput>>>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  complimentary_amount?: InputMaybe<Scalars['Float']['input']>;
  cover?: InputMaybe<Scalars['Int']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customer?: InputMaybe<OrderCustomerDetailInput>;
  customer_id?: InputMaybe<Scalars['UUID']['input']>;
  delivery_charge_amount?: InputMaybe<Scalars['Float']['input']>;
  delivery_charge_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  delivery_charge_tax_value?: InputMaybe<Scalars['Float']['input']>;
  delivery_start_date?: InputMaybe<Scalars['Date']['input']>;
  delivery_start_time?: InputMaybe<Scalars['Time']['input']>;
  delivery_time?: InputMaybe<Scalars['Int']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<OrderDiscountInput>>>;
  dispatched_at?: InputMaybe<Scalars['Datetime']['input']>;
  es_synced_on?: InputMaybe<Scalars['Datetime']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instance?: InputMaybe<InstanceInput>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  instance_name?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  invoice_number?: InputMaybe<Scalars['Int']['input']>;
  invoice_prefix?: InputMaybe<Scalars['String']['input']>;
  invoice_suffix?: InputMaybe<Scalars['String']['input']>;
  invoice_time?: InputMaybe<Scalars['Datetime']['input']>;
  is_advance_order?: InputMaybe<Scalars['Boolean']['input']>;
  is_bulk_order?: InputMaybe<Scalars['Boolean']['input']>;
  is_credit_order?: InputMaybe<Scalars['Boolean']['input']>;
  is_dispatched?: InputMaybe<Scalars['Boolean']['input']>;
  is_food_prepared?: InputMaybe<Scalars['Boolean']['input']>;
  is_pos_order?: InputMaybe<Scalars['Boolean']['input']>;
  is_self_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<OrderInlineItemInput>>>;
  json_meta_field_1?: InputMaybe<Scalars['JSON']['input']>;
  json_meta_field_2?: InputMaybe<Scalars['JSON']['input']>;
  json_meta_field_3?: InputMaybe<Scalars['JSON']['input']>;
  kot_number?: InputMaybe<Scalars['Int']['input']>;
  kot_prefix?: InputMaybe<Scalars['String']['input']>;
  last_bill_printed_at?: InputMaybe<Scalars['Datetime']['input']>;
  last_kot_printed_at?: InputMaybe<Scalars['Datetime']['input']>;
  loyalty_points?: InputMaybe<Scalars['Int']['input']>;
  masked_number?: InputMaybe<Scalars['String']['input']>;
  number_meta_field_1?: InputMaybe<Scalars['Float']['input']>;
  number_meta_field_2?: InputMaybe<Scalars['Float']['input']>;
  number_meta_field_3?: InputMaybe<Scalars['Float']['input']>;
  online_order_status?: InputMaybe<StatusInput>;
  order_date?: InputMaybe<Scalars['Date']['input']>;
  order_settled_by_user_id?: InputMaybe<Scalars['UUID']['input']>;
  order_settled_by_user_name?: InputMaybe<Scalars['String']['input']>;
  order_status?: InputMaybe<OrderStatus>;
  order_time?: InputMaybe<Scalars['Time']['input']>;
  order_type?: InputMaybe<OrderType>;
  ordering_slot?: InputMaybe<OrderingSlot>;
  other_charge_amount?: InputMaybe<Scalars['Float']['input']>;
  other_charge_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  other_charge_tax_value?: InputMaybe<Scalars['Float']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otp_message?: InputMaybe<Scalars['String']['input']>;
  packaging_charge_amount?: InputMaybe<Scalars['Float']['input']>;
  packaging_charge_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  packaging_charge_tax_value?: InputMaybe<Scalars['Float']['input']>;
  parent_id?: InputMaybe<Scalars['UUID']['input']>;
  parent_order?: InputMaybe<OrderInput>;
  payments?: InputMaybe<Array<InputMaybe<OrderPaymentInput>>>;
  prep_time?: InputMaybe<Scalars['Int']['input']>;
  prepared_at?: InputMaybe<Scalars['Datetime']['input']>;
  processing_timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  reject_code?: InputMaybe<Scalars['String']['input']>;
  reject_reason?: InputMaybe<Scalars['String']['input']>;
  rider?: InputMaybe<OrderRiderInput>;
  rider_name?: InputMaybe<Scalars['String']['input']>;
  rider_phone?: InputMaybe<Scalars['String']['input']>;
  round_off?: InputMaybe<Scalars['Float']['input']>;
  secondary_timeline?: InputMaybe<Array<InputMaybe<OrderSecondaryTimelineInput>>>;
  section_id?: InputMaybe<Scalars['UUID']['input']>;
  section_name?: InputMaybe<Scalars['String']['input']>;
  sequence_id?: InputMaybe<Scalars['Int']['input']>;
  service_charge_amount?: InputMaybe<Scalars['Float']['input']>;
  service_charge_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  service_charge_tax_value?: InputMaybe<Scalars['Float']['input']>;
  settled_at?: InputMaybe<Scalars['Datetime']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status_code?: InputMaybe<StatusCode>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  sub_section_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_section_name?: InputMaybe<Scalars['String']['input']>;
  sub_total?: InputMaybe<Scalars['Float']['input']>;
  taxes?: InputMaybe<Scalars['JSON']['input']>;
  text_meta_field_1?: InputMaybe<Scalars['String']['input']>;
  text_meta_field_2?: InputMaybe<Scalars['String']['input']>;
  text_meta_field_3?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Array<InputMaybe<OrderTimeLineInput>>>;
  total?: InputMaybe<Scalars['Float']['input']>;
  total_aggregator_charge_taxes?: InputMaybe<Scalars['Float']['input']>;
  total_aggregator_item_taxes?: InputMaybe<Scalars['Float']['input']>;
  total_aggregator_taxes?: InputMaybe<Scalars['Float']['input']>;
  total_charges?: InputMaybe<Scalars['Float']['input']>;
  total_charges_tax?: InputMaybe<Scalars['Float']['input']>;
  total_discount?: InputMaybe<Scalars['Float']['input']>;
  total_discount_percentage?: InputMaybe<Scalars['Float']['input']>;
  total_item_discount?: InputMaybe<Scalars['Float']['input']>;
  total_item_packaging_charge_amount?: InputMaybe<Scalars['Float']['input']>;
  total_item_packaging_charge_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  total_item_tax?: InputMaybe<Scalars['Float']['input']>;
  total_merchant_charge_taxes?: InputMaybe<Scalars['Float']['input']>;
  total_merchant_item_taxes?: InputMaybe<Scalars['Float']['input']>;
  total_merchant_taxes?: InputMaybe<Scalars['Float']['input']>;
  total_tax?: InputMaybe<Scalars['Float']['input']>;
  unix_timestamp?: InputMaybe<Scalars['Int']['input']>;
  unix_timestamp_updated?: InputMaybe<Scalars['Int']['input']>;
  update_uuid?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  waiter_id?: InputMaybe<Scalars['UUID']['input']>;
  waiter_name?: InputMaybe<Scalars['String']['input']>;
  waiter_phone?: InputMaybe<Scalars['String']['input']>;
  website_cart_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrderOperationLog = {
  __typename?: 'OrderOperationLog';
  collection?: Maybe<Scalars['String']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  log_timestamp: Scalars['Datetime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  new_value: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  order?: Maybe<Order>;
  order_id: Scalars['UUID']['output'];
  params?: Maybe<Scalars['JSON']['output']>;
  previous_value: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


export type OrderOperationLogCollectionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderOperationLogEntity_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogEntity_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogKeyArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogLog_TimestampArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderOperationLogMessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogNew_ValueArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogOperationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogPrevious_ValueArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderOperationLogUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderOperationLogUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderOperationLogInput = {
  collection?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  entity_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  log_timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  new_value?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  previous_value?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  amount: Scalars['Float']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_success: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  order_id: Scalars['UUID']['output'];
  payment_type: PaymentType;
  transaction_id?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  utr?: Maybe<Scalars['String']['output']>;
};


export type OrderPaymentAmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderPaymentCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderPaymentIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderPaymentIs_SuccessArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderPaymentNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderPaymentOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderPaymentPayment_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderPaymentTransaction_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderPaymentUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderPaymentUtrArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderPaymentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_success?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  payment_type?: InputMaybe<PaymentType>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  utr?: InputMaybe<Scalars['String']['input']>;
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoice_number?: Maybe<Scalars['Int']['output']>;
  invoice_prefix?: Maybe<Scalars['String']['output']>;
  kot_number?: Maybe<Scalars['Int']['output']>;
  kot_prefix?: Maybe<Scalars['String']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  update_uuid?: Maybe<Scalars['String']['output']>;
};

export type OrderRider = {
  __typename?: 'OrderRider';
  cost?: Maybe<Scalars['Float']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  delivery_eta?: Maybe<Scalars['Int']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_order_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  integration_id?: Maybe<Scalars['UUID']['output']>;
  integration_name?: Maybe<Scalars['String']['output']>;
  last_geom?: Maybe<Geom>;
  logs?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  order_id: Scalars['UUID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pick_up_eta?: Maybe<Scalars['Int']['output']>;
  secondary_status_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SecondaryStatus>;
  track_url?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type OrderRiderCostArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderRiderCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderRiderDelivery_EtaArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderRiderExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderExternal_Order_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderIntegration_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderPhoneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderPick_Up_EtaArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderRiderSecondary_Status_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderTrack_UrlArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderRiderUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderRiderInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  delivery_eta?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_order_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  integration_name?: InputMaybe<Scalars['String']['input']>;
  last_geom?: InputMaybe<GeomInput>;
  logs?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pick_up_eta?: InputMaybe<Scalars['Int']['input']>;
  secondary_status_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SecondaryStatusInput>;
  track_url?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderSecondaryTimeline = {
  __typename?: 'OrderSecondaryTimeline';
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  integration_status?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  order_id: Scalars['UUID']['output'];
  retry_count?: Maybe<Scalars['Int']['output']>;
  status_code: Scalars['String']['output'];
  status_name?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


export type OrderSecondaryTimelineCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderSecondaryTimelineIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineIntegration_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineMessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineRetry_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderSecondaryTimelineStatus_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineStatus_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderSecondaryTimelineUser_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderSecondaryTimelineUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSecondaryTimelineInput = {
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_status?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  retry_count?: InputMaybe<Scalars['Int']['input']>;
  status_code?: InputMaybe<Scalars['String']['input']>;
  status_name?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderStatus {
  Accept = 'ACCEPT',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deliver = 'DELIVER',
  Dispatch = 'DISPATCH',
  FoodReady = 'FOOD_READY',
  Placed = 'PLACED',
  Receive = 'RECEIVE',
  Unsettled = 'UNSETTLED'
}

export type OrderStatusResponse = {
  __typename?: 'OrderStatusResponse';
  id: Scalars['String']['output'];
  order_status: Scalars['String']['output'];
  update_uuid: Scalars['String']['output'];
};

export type OrderTax = {
  __typename?: 'OrderTax';
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  order_id: Scalars['UUID']['output'];
  tax?: Maybe<Tax>;
  tax_amount: Scalars['Float']['output'];
  tax_id?: Maybe<Scalars['UUID']['output']>;
  tax_on_type: TaxOnType;
  tax_rate?: Maybe<TaxRate>;
  tax_rate_id?: Maybe<Scalars['UUID']['output']>;
  tax_rate_name: Scalars['String']['output'];
  tax_rate_value: Scalars['Float']['output'];
  tax_responsible_type: TaxResponsibleType;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type OrderTaxCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderTaxIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTaxOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTaxTax_AmountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTaxTax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTaxTax_On_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTaxTax_Rate_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTaxTax_Rate_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTaxTax_Rate_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTaxTax_Responsible_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTaxUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderTaxInput = {
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  tax?: InputMaybe<TaxInput>;
  tax_amount?: InputMaybe<Scalars['Float']['input']>;
  tax_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_on_type?: InputMaybe<TaxOnType>;
  tax_rate?: InputMaybe<TaxRateInput>;
  tax_rate_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_rate_name?: InputMaybe<Scalars['String']['input']>;
  tax_rate_value?: InputMaybe<Scalars['Float']['input']>;
  tax_responsible_type?: InputMaybe<TaxResponsibleType>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OrderTimeLine = {
  __typename?: 'OrderTimeLine';
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_successful?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  order_id: Scalars['UUID']['output'];
  retry_count?: Maybe<Scalars['Int']['output']>;
  status_code: StatusCode;
  status_name?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


export type OrderTimeLineCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderTimeLineIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTimeLineIs_SuccessfulArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderTimeLineMessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTimeLineOrder_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTimeLineRetry_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OrderTimeLineStatus_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTimeLineStatus_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTimeLineUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OrderTimeLineUser_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTimeLineUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTimeLineUser_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type OrderTimeLineInput = {
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_successful?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['UUID']['input']>;
  retry_count?: InputMaybe<Scalars['Int']['input']>;
  status_code?: InputMaybe<StatusCode>;
  status_name?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderType {
  Banquet = 'BANQUET',
  Catering = 'CATERING',
  Delivery = 'DELIVERY',
  DineIn = 'DINE_IN',
  Other = 'OTHER',
  Party = 'PARTY',
  Takeaway = 'TAKEAWAY'
}

export enum OrderingSlot {
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  LateNight = 'LATE_NIGHT',
  Lunch = 'LUNCH',
  Snacks = 'SNACKS'
}

export type OutletMis = {
  __typename?: 'OutletMIS';
  actual_no_of_bills: Scalars['Float']['output'];
  actual_sales: Scalars['Float']['output'];
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['Date']['output'];
  expected_no_of_bills: Scalars['Float']['output'];
  expected_sales: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type OutletMisActual_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OutletMisActual_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OutletMisBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OutletMisCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OutletMisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type OutletMisDateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type OutletMisExpected_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OutletMisExpected_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type OutletMisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OutletMisLocationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OutletMisNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OutletMisSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type OutletMisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OutletMisInput = {
  actual_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  actual_sales?: InputMaybe<Scalars['Float']['input']>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expected_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  expected_sales?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OutletStatusResponse = {
  __typename?: 'OutletStatusResponse';
  branches: Array<BranchStatusResponse>;
  integrations: Array<IntegrationResponse>;
};

export type OwnerBranch = {
  __typename?: 'OwnerBranch';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OwnerInstance = {
  __typename?: 'OwnerInstance';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PaymentData = {
  amount: Scalars['Float']['input'];
  branch_id?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['String']['input'];
};

export type PaymentMode = {
  __typename?: 'PaymentMode';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['UUID']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  device_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  payment_type: PaymentType;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type PaymentModeBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentModeCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentModeCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type PaymentModeDevice_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentModeIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentModeIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PaymentModeNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentModePayment_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentModeSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentModeUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PaymentModeEntry = {
  __typename?: 'PaymentModeEntry';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type PaymentModeInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<PaymentType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PaymentModeResponse = {
  __typename?: 'PaymentModeResponse';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  payment_type: Scalars['String']['output'];
};

export type PaymentResponse = {
  __typename?: 'PaymentResponse';
  message?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PaymentSuccessResponse = {
  __typename?: 'PaymentSuccessResponse';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum PaymentType {
  Card = 'CARD',
  Cash = 'CASH',
  Credit = 'CREDIT',
  Edc = 'EDC',
  Online = 'ONLINE',
  OnCredit = 'ON_CREDIT',
  Refund = 'REFUND',
  ThirdParty = 'THIRD_PARTY',
  Upi = 'UPI',
  Wallet = 'WALLET'
}

export enum PermType {
  Crud = 'CRUD',
  Operation = 'OPERATION'
}

export type Permission = {
  __typename?: 'Permission';
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  permission_type: Scalars['String']['output'];
  roles: Array<Role>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type PermissionCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type PermissionDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PermissionIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PermissionLevelArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type PermissionNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PermissionPermission_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PermissionUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PermissionInput = {
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission_type?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<RoleInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PermissionResponse = {
  __typename?: 'PermissionResponse';
  id: Scalars['UUID']['output'];
  permission_name: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
};

export type PermissionSyncResponse = {
  __typename?: 'PermissionSyncResponse';
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Ping = {
  __typename?: 'Ping';
  error: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type PivotInput = {
  agg_func: Array<AggFuncInput>;
  columns: Array<Scalars['String']['input']>;
  index: Array<Scalars['String']['input']>;
  values: Array<Scalars['String']['input']>;
};

export type PrinterConfig = {
  __typename?: 'PrinterConfig';
  bill_template: Scalars['String']['output'];
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['UUID']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_tax_inclusive?: Maybe<Scalars['Boolean']['output']>;
  kot_template: Scalars['String']['output'];
  printer_mappings: Array<PrinterMapping>;
  section?: Maybe<Section>;
  section_id?: Maybe<Scalars['UUID']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  upi_id?: Maybe<Scalars['String']['output']>;
};


export type PrinterConfigBill_TemplateArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterConfigBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterConfigCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterConfigCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type PrinterConfigIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterConfigIs_Tax_InclusiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PrinterConfigKot_TemplateArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterConfigSection_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterConfigSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterConfigUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type PrinterConfigUpi_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type PrinterConfigInput = {
  bill_template?: InputMaybe<Scalars['String']['input']>;
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  kot_template?: InputMaybe<Scalars['String']['input']>;
  printer_mappings?: InputMaybe<Array<InputMaybe<PrinterMappingInput>>>;
  section?: InputMaybe<SectionInput>;
  section_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  upi_id?: InputMaybe<Scalars['String']['input']>;
};

export type PrinterConfigResponse = {
  __typename?: 'PrinterConfigResponse';
  bill_template: Scalars['String']['output'];
  branch_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  kot_template: Scalars['String']['output'];
  printer_mappings: Array<Maybe<PrinterMappingResponse>>;
  section_id?: Maybe<Scalars['UUID']['output']>;
};

export type PrinterMapping = {
  __typename?: 'PrinterMapping';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_bill_printer: Scalars['Boolean']['output'];
  is_master?: Maybe<Scalars['Boolean']['output']>;
  kot_copies?: Maybe<Scalars['Int']['output']>;
  print_language?: Maybe<Scalars['String']['output']>;
  printer_config?: Maybe<PrinterConfig>;
  printer_config_id: Scalars['UUID']['output'];
  printer_name: Scalars['String']['output'];
  printer_size: Scalars['Int']['output'];
  printer_type?: Maybe<PrinterType>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type PrinterMappingCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterMappingCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type PrinterMappingIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterMappingIs_Bill_PrinterArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PrinterMappingIs_MasterArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PrinterMappingKot_CopiesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type PrinterMappingPrint_LanguageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterMappingPrinter_Config_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterMappingPrinter_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterMappingPrinter_SizeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type PrinterMappingPrinter_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterMappingSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type PrinterMappingUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PrinterMappingInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_bill_printer?: InputMaybe<Scalars['Boolean']['input']>;
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  kot_copies?: InputMaybe<Scalars['Int']['input']>;
  print_language?: InputMaybe<Scalars['String']['input']>;
  printer_config?: InputMaybe<PrinterConfigInput>;
  printer_config_id?: InputMaybe<Scalars['UUID']['input']>;
  printer_name?: InputMaybe<Scalars['String']['input']>;
  printer_size?: InputMaybe<Scalars['Int']['input']>;
  printer_type?: InputMaybe<PrinterType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PrinterMappingResponse = {
  __typename?: 'PrinterMappingResponse';
  id: Scalars['UUID']['output'];
  is_bill_printer?: Maybe<Scalars['Boolean']['output']>;
  print_language: Scalars['String']['output'];
  printer_config_id: Scalars['UUID']['output'];
  printer_name: Scalars['String']['output'];
  printer_size: Scalars['Int']['output'];
  printer_type: Scalars['String']['output'];
};

export enum PrinterType {
  Bakery = 'BAKERY',
  Bar = 'BAR',
  Beverage = 'BEVERAGE',
  Dessert = 'DESSERT',
  Food = 'FOOD',
  Liquor = 'LIQUOR',
  Merchandise = 'MERCHANDISE',
  NonFood = 'NON_FOOD',
  Tobacco = 'TOBACCO',
  Type_1 = 'TYPE_1',
  Type_2 = 'TYPE_2',
  Wine = 'WINE'
}

export type Product = {
  __typename?: 'Product';
  allergen_types?: Maybe<Scalars['List']['output']>;
  available_on_cod?: Maybe<Scalars['Boolean']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  branches: Array<BranchProduct>;
  calorie_count?: Maybe<Scalars['Float']['output']>;
  cancellable?: Maybe<Scalars['Boolean']['output']>;
  carbohydrate_count?: Maybe<Scalars['Float']['output']>;
  children: Array<Product>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  customization_group_inlines: Array<CustomizationGroupInline>;
  customization_group_products: Array<CustomizationGroupProduct>;
  customization_groups: Array<CustomizationGroup>;
  department?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  fat_count?: Maybe<Scalars['Float']['output']>;
  fibre_count?: Maybe<Scalars['Float']['output']>;
  flavour?: Maybe<Scalars['String']['output']>;
  food_type: FoodType;
  group_kind?: Maybe<Scalars['String']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  gst_classification?: Maybe<GstClassification>;
  id: Scalars['UUID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  images: Array<ProductImage>;
  inter_state_tax?: Maybe<Tax>;
  inter_state_tax_id?: Maybe<Scalars['UUID']['output']>;
  intra_state_tax?: Maybe<Tax>;
  intra_state_tax_id?: Maybe<Scalars['UUID']['output']>;
  is_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_discount_exempt?: Maybe<Scalars['Boolean']['output']>;
  is_mrp_item?: Maybe<Scalars['Boolean']['output']>;
  is_open?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  kitchen?: Maybe<Kitchen>;
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  meat_types?: Maybe<Scalars['List']['output']>;
  menu_products: Array<MenuProduct>;
  menus: Array<Menu>;
  meta_data?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nutrition_info_unit?: Maybe<NutritionInfoUnit>;
  packaging_charge?: Maybe<Charge>;
  packaging_charge_id?: Maybe<Scalars['UUID']['output']>;
  parent?: Maybe<Product>;
  parent_id?: Maybe<Scalars['UUID']['output']>;
  preparation_time_in_min?: Maybe<Scalars['Int']['output']>;
  printer_type?: Maybe<PrinterType>;
  product_classification?: Maybe<Scalars['String']['output']>;
  product_translations: Array<ProductTranslation>;
  product_type: ProductType;
  protein_count?: Maybe<Scalars['Float']['output']>;
  recommended?: Maybe<Scalars['Boolean']['output']>;
  related?: Maybe<Scalars['Boolean']['output']>;
  return_window?: Maybe<Scalars['String']['output']>;
  returnable?: Maybe<Scalars['Boolean']['output']>;
  seller_pickup_return?: Maybe<Scalars['Boolean']['output']>;
  serving_info?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  sub_category_products: Array<SubCategoryProduct>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  subcategories: Array<SubCategory>;
  tags?: Maybe<Scalars['List']['output']>;
  time_to_ship?: Maybe<Scalars['String']['output']>;
  uom_type?: Maybe<UomType>;
  uom_value?: Maybe<Scalars['Float']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ProductAvailable_On_CodArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductBarcodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductCalorie_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductCancellableArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductCarbohydrate_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductCostArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ProductDepartmentArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductFat_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductFibre_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductFlavourArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductFood_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductGroup_KindArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductGroup_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductGst_ClassificationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductIdentifierArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductInter_State_Tax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductIntra_State_Tax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductIs_DisabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductIs_Discount_ExemptArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductIs_Mrp_ItemArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductIs_OpenArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductKindArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductKitchenArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductNutrition_Info_UnitArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductPackaging_Charge_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductParent_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductPreparation_Time_In_MinArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductPrinter_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductProduct_ClassificationArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductProduct_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductProtein_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductRecommendedArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductRelatedArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductReturn_WindowArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductReturnableArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductSeller_Pickup_ReturnArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductServing_InfoArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductSkuArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTime_To_ShipArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductUom_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductUom_ValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductEntry = {
  __typename?: 'ProductEntry';
  amount: Scalars['Float']['output'];
  item_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  aggregator: Scalars['String']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  image_type: ImageType;
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ProductImageAggregatorArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductImageCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductImageCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ProductImageIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductImageImageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductImageImage_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductImageProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductImageSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductImageUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductImageInput = {
  aggregator?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_type?: InputMaybe<ImageType>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductInput = {
  allergen_types?: InputMaybe<Scalars['List']['input']>;
  available_on_cod?: InputMaybe<Scalars['Boolean']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  branches?: InputMaybe<Array<InputMaybe<BranchProductInput>>>;
  calorie_count?: InputMaybe<Scalars['Float']['input']>;
  cancellable?: InputMaybe<Scalars['Boolean']['input']>;
  carbohydrate_count?: InputMaybe<Scalars['Float']['input']>;
  children?: InputMaybe<Array<InputMaybe<ProductInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  customization_group_inlines?: InputMaybe<Array<InputMaybe<CustomizationGroupInlineInput>>>;
  customization_group_products?: InputMaybe<Array<InputMaybe<CustomizationGroupProductInput>>>;
  customization_groups?: InputMaybe<Array<InputMaybe<CustomizationGroupInput>>>;
  department?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  fat_count?: InputMaybe<Scalars['Float']['input']>;
  fibre_count?: InputMaybe<Scalars['Float']['input']>;
  flavour?: InputMaybe<Scalars['String']['input']>;
  food_type?: InputMaybe<FoodType>;
  group_kind?: InputMaybe<Scalars['String']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  gst_classification?: InputMaybe<GstClassification>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<ProductImageInput>>>;
  inter_state_tax?: InputMaybe<TaxInput>;
  inter_state_tax_id?: InputMaybe<Scalars['UUID']['input']>;
  intra_state_tax?: InputMaybe<TaxInput>;
  intra_state_tax_id?: InputMaybe<Scalars['UUID']['input']>;
  is_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_discount_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  is_mrp_item?: InputMaybe<Scalars['Boolean']['input']>;
  is_open?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  kitchen?: InputMaybe<Kitchen>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  meat_types?: InputMaybe<Scalars['List']['input']>;
  menu_products?: InputMaybe<Array<InputMaybe<MenuProductInput>>>;
  menus?: InputMaybe<Array<InputMaybe<MenuInput>>>;
  meta_data?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nutrition_info_unit?: InputMaybe<NutritionInfoUnit>;
  packaging_charge?: InputMaybe<ChargeInput>;
  packaging_charge_id?: InputMaybe<Scalars['UUID']['input']>;
  parent?: InputMaybe<ProductInput>;
  parent_id?: InputMaybe<Scalars['UUID']['input']>;
  preparation_time_in_min?: InputMaybe<Scalars['Int']['input']>;
  printer_type?: InputMaybe<PrinterType>;
  product_classification?: InputMaybe<Scalars['String']['input']>;
  product_translations?: InputMaybe<Array<InputMaybe<ProductTranslationInput>>>;
  product_type?: InputMaybe<ProductType>;
  protein_count?: InputMaybe<Scalars['Float']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  related?: InputMaybe<Scalars['Boolean']['input']>;
  return_window?: InputMaybe<Scalars['String']['input']>;
  returnable?: InputMaybe<Scalars['Boolean']['input']>;
  seller_pickup_return?: InputMaybe<Scalars['Boolean']['input']>;
  serving_info?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sub_category_products?: InputMaybe<Array<InputMaybe<SubCategoryProductInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  subcategories?: InputMaybe<Array<InputMaybe<SubCategoryInput>>>;
  tags?: InputMaybe<Scalars['List']['input']>;
  time_to_ship?: InputMaybe<Scalars['String']['input']>;
  uom_type?: InputMaybe<UomType>;
  uom_value?: InputMaybe<Scalars['Float']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductLogType = {
  __typename?: 'ProductLogType';
  integration_name: Scalars['String']['output'];
  is_successful: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_on: Scalars['String']['output'];
};

export type ProductMis = {
  __typename?: 'ProductMIS';
  actual_no_of_bills: Scalars['Float']['output'];
  actual_sales: Scalars['Float']['output'];
  branch_id: Scalars['UUID']['output'];
  category_name?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['Date']['output'];
  expected_no_of_bills: Scalars['Float']['output'];
  expected_sales: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sub_category_name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ProductMisActual_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductMisActual_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductMisBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductMisCategory_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductMisCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductMisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ProductMisDateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type ProductMisExpected_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductMisExpected_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ProductMisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductMisNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductMisSub_Category_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductMisSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductMisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductMisInput = {
  actual_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  actual_sales?: InputMaybe<Scalars['Float']['input']>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expected_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  expected_sales?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_category_name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductStatusLog = {
  __typename?: 'ProductStatusLog';
  branch_product?: Maybe<BranchProduct>;
  branch_product_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  integration_id: Scalars['UUID']['output'];
  integration_name: Scalars['String']['output'];
  is_successful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ProductStatusLogBranch_Product_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductStatusLogCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ProductStatusLogIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductStatusLogIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductStatusLogIntegration_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductStatusLogIs_SuccessfulArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductStatusLogMessageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductStatusLogStatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductStatusLogUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductStatusLogInput = {
  branch_product?: InputMaybe<BranchProductInput>;
  branch_product_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  integration_name?: InputMaybe<Scalars['String']['input']>;
  is_successful?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductTranslation = {
  __typename?: 'ProductTranslation';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  product_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ProductTranslationCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTranslationCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ProductTranslationDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTranslationIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTranslationLanguageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTranslationNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTranslationProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTranslationSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTranslationUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProductTranslationInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum ProductType {
  Addon = 'ADDON',
  Combo = 'COMBO',
  Product = 'PRODUCT',
  Variant = 'VARIANT'
}

export type Query = {
  __typename?: 'Query';
  add_free_dish: CartResponse;
  add_order_date_time: CartResponse;
  add_to_cart: CartResponse;
  aggregator_integration: Array<Maybe<AggregatorIntegration>>;
  apply_coupon: CartResponse;
  assign_address_to_cart: Scalars['Boolean']['output'];
  authenticate_redemption: TaskResponse;
  banners: BannerResponse;
  branch_add_ons: Array<Maybe<BranchAddOnResponse>>;
  branch_categories: Array<BranchCategoryResponse>;
  branch_product_logs: Array<Maybe<BranchProductLogResponse>>;
  branch_products: Array<BranchProductResponse>;
  bulk_export_menu?: Maybe<Scalars['JSON']['output']>;
  check_authorization: Scalars['JSON']['output'];
  check_order_checksum: Scalars['JSON']['output'];
  clear_customer_cart?: Maybe<Scalars['Boolean']['output']>;
  customer_cart?: Maybe<CartResponse>;
  customer_history: Scalars['JSON']['output'];
  customer_send_otp: SendOtpResponse;
  customer_validate_otp: AuthData;
  generate_link: Scalars['JSON']['output'];
  get_activity_log: ActivityLog;
  get_address: Address;
  get_aggregator_mis: AggregatorMis;
  get_auth: Auth;
  get_authorization: Authorization;
  get_bank_account: BankAccount;
  get_banner: Banner;
  get_branch: Branch;
  get_branch_banner: BranchBanner;
  get_branch_image: BranchImage;
  get_branch_integration: BranchIntegration;
  get_branch_product: BranchProduct;
  get_branch_setting: BranchSetting;
  get_branch_shift: BranchShift;
  get_branch_status_log: BranchStatusLog;
  get_cart: Cart;
  get_category: Category;
  get_category_mis: CategoryMis;
  get_category_schedule: CategorySchedule;
  get_change_log: ChangeLog;
  get_charge: Charge;
  get_charge_branch: ChargeBranch;
  get_closing_shift_slip_data?: Maybe<ClosingShiftSlipData>;
  get_company: Company;
  get_coupon: Coupon;
  get_coupon_branch: CouponBranch;
  get_customer: Customer;
  get_customer_address: CustomerAddress;
  get_customer_loyalty_details: TaskResponse;
  get_customer_rating: CustomerRating;
  get_customization_group: CustomizationGroup;
  get_customization_group_inline: CustomizationGroupInline;
  get_customization_group_product: CustomizationGroupProduct;
  get_delivery_slot: DeliverySlot;
  get_discount: Discount;
  get_discount_branch: DiscountBranch;
  get_discount_category: DiscountCategory;
  get_discount_product_x: DiscountProductX;
  get_discount_product_y: DiscountProductY;
  get_employee: Employee;
  get_food_type_mis: FoodTypeMis;
  get_free_dish: FreeDish;
  get_hourly_mis: HourlyMis;
  get_inline_charge: InlineCharge;
  get_inline_item: InlineItem;
  get_instance: Instance;
  get_instance_goal: InstanceGoal;
  get_integration: Integration;
  get_integration_action: IntegrationAction;
  get_integration_setting: IntegrationSetting;
  get_keys: GetKeysResponse;
  get_latest_branch_shifts: Scalars['JSON']['output'];
  get_menu: Menu;
  get_menu_branch: MenuBranch;
  get_menu_category: MenuCategory;
  get_menu_from_branch_name: ExtendedMenuResponse;
  get_menu_from_id: MenuResponse;
  get_menu_from_menu_id: MenuResponse;
  get_menu_product: MenuProduct;
  get_menu_sync_log: MenuSyncLog;
  get_menu_tax_rate: MenuTaxRate;
  get_mis_report: Scalars['JSON']['output'];
  get_mis_report_url: Scalars['String']['output'];
  get_order: Order;
  get_order_comment: OrderComment;
  get_order_complaint: OrderComplaint;
  get_order_credit_users: Scalars['JSON']['output'];
  get_order_customer_detail: OrderCustomerDetail;
  get_order_discount: OrderDiscount;
  get_order_inline_item: OrderInlineItem;
  get_order_json: Scalars['JSON']['output'];
  get_order_operation_log: OrderOperationLog;
  get_order_payment: OrderPayment;
  get_order_rider: OrderRider;
  get_order_secondary_timeline: OrderSecondaryTimeline;
  get_order_tax: OrderTax;
  get_order_time_line: OrderTimeLine;
  get_outlet_mis: OutletMis;
  get_owner_branches: Array<OwnerBranch>;
  get_owner_instances: Array<OwnerInstance>;
  get_payment_mode: PaymentMode;
  get_permission: Permission;
  get_printer_config: PrinterConfig;
  get_printer_mapping: PrinterMapping;
  get_product: Product;
  get_product_from_id: Scalars['JSON']['output'];
  get_product_image: ProductImage;
  get_product_mis: ProductMis;
  get_product_status_log: ProductStatusLog;
  get_product_translation: ProductTranslation;
  get_register: Register;
  get_register_shift: RegisterShift;
  get_report_template: ReportTemplate;
  get_role: Role;
  get_role_permission: RolePermission;
  get_schedule: Schedule;
  get_schedule_from_instance: Schedule;
  get_secondary_status: SecondaryStatus;
  get_section: Section;
  get_setting: Setting;
  get_staff: Staff;
  get_staff_company: StaffCompany;
  get_status: Status;
  get_sub_category: SubCategory;
  get_sub_category_mis: SubCategoryMis;
  get_sub_category_product: SubCategoryProduct;
  get_sub_company: SubCompany;
  get_sub_company_integration: SubCompanyIntegration;
  get_sub_company_integration_branch: SubCompanyIntegrationBranch;
  get_sub_section: SubSection;
  get_tag: Tag;
  get_task_status: Task_Status_Response;
  get_tasks_statuses: Get_Tasks_Statuses_Response;
  get_tax: Tax;
  get_tax_rate: TaxRate;
  get_ticket: Ticket;
  get_ticket_analysis: TicketAnalysis;
  get_ticket_history: TicketHistory;
  get_time_slot: TimeSlot;
  get_user: User;
  get_user_branch: UserBranch;
  get_user_credit_orders: Scalars['JSON']['output'];
  get_user_json: UserResponse;
  get_web_app_coupon: WebAppCoupon;
  get_website: Website;
  get_website_instance: WebsiteInstance;
  get_website_instance_brand: WebsiteInstanceBrand;
  get_website_instance_from_location: WebsiteInstanceResponse;
  get_website_instance_from_name: WebsiteInstanceResponse;
  get_website_offers: WebsiteOffersResponse;
  handle_authorization: Scalars['JSON']['output'];
  index_mapping: Scalars['JSON']['output'];
  index_report: Scalars['JSON']['output'];
  index_report_url: Scalars['JSON']['output'];
  initiate_order_comment_notification: Scalars['Boolean']['output'];
  initiate_payment_integration?: Maybe<Scalars['JSON']['output']>;
  kds_polling: Array<Maybe<Scalars['JSON']['output']>>;
  list_activity_log: Array<Maybe<ActivityLog>>;
  list_address: Array<Maybe<Address>>;
  list_aggregator_mis: Array<Maybe<AggregatorMis>>;
  list_auth: Array<Maybe<Auth>>;
  list_authorization: Array<Maybe<Authorization>>;
  list_bank_account: Array<Maybe<BankAccount>>;
  list_banner: Array<Maybe<Banner>>;
  list_branch: Array<Maybe<Branch>>;
  list_branch_banner: Array<Maybe<BranchBanner>>;
  list_branch_image: Array<Maybe<BranchImage>>;
  list_branch_integration: Array<Maybe<BranchIntegration>>;
  list_branch_product: Array<Maybe<BranchProduct>>;
  list_branch_setting: Array<Maybe<BranchSetting>>;
  list_branch_shift: Array<Maybe<BranchShift>>;
  list_branch_status_log: Array<Maybe<BranchStatusLog>>;
  list_cart: Array<Maybe<Cart>>;
  list_category: Array<Maybe<Category>>;
  list_category_mis: Array<Maybe<CategoryMis>>;
  list_category_schedule: Array<Maybe<CategorySchedule>>;
  list_change_log: Array<Maybe<ChangeLog>>;
  list_charge: Array<Maybe<Charge>>;
  list_charge_branch: Array<Maybe<ChargeBranch>>;
  list_company: Array<Maybe<Company>>;
  list_coupon: Array<Maybe<Coupon>>;
  list_coupon_branch: Array<Maybe<CouponBranch>>;
  list_customer: Array<Maybe<Customer>>;
  list_customer_address: Array<Maybe<CustomerAddress>>;
  list_customer_order: Array<Maybe<Scalars['JSON']['output']>>;
  list_customer_rating: Array<Maybe<CustomerRating>>;
  list_customization_group: Array<Maybe<CustomizationGroup>>;
  list_customization_group_inline: Array<Maybe<CustomizationGroupInline>>;
  list_customization_group_product: Array<Maybe<CustomizationGroupProduct>>;
  list_delivery_slot: Array<Maybe<DeliverySlot>>;
  list_discount: Array<Maybe<Discount>>;
  list_discount_branch: Array<Maybe<DiscountBranch>>;
  list_discount_category: Array<Maybe<DiscountCategory>>;
  list_discount_product_x: Array<Maybe<DiscountProductX>>;
  list_discount_product_y: Array<Maybe<DiscountProductY>>;
  list_employee: Array<Maybe<Employee>>;
  list_food_type_mis: Array<Maybe<FoodTypeMis>>;
  list_free_dish: Array<Maybe<FreeDish>>;
  list_hourly_mis: Array<Maybe<HourlyMis>>;
  list_inline_charge: Array<Maybe<InlineCharge>>;
  list_inline_item: Array<Maybe<InlineItem>>;
  list_instance: Array<Maybe<Instance>>;
  list_instance_goal: Array<Maybe<InstanceGoal>>;
  list_integration: Array<Maybe<Integration>>;
  list_integration_action: Array<Maybe<IntegrationAction>>;
  list_integration_setting: Array<Maybe<IntegrationSetting>>;
  list_menu: Array<Maybe<Menu>>;
  list_menu_branch: Array<Maybe<MenuBranch>>;
  list_menu_category: Array<Maybe<MenuCategory>>;
  list_menu_product: Array<Maybe<MenuProduct>>;
  list_menu_sync_log: Array<Maybe<MenuSyncLog>>;
  list_menu_tax_rate: Array<Maybe<MenuTaxRate>>;
  list_order: Array<Maybe<Order>>;
  list_order_by_ids: Array<Scalars['JSON']['output']>;
  list_order_comment: Array<Maybe<OrderComment>>;
  list_order_complaint: Array<Maybe<OrderComplaint>>;
  list_order_customer_detail: Array<Maybe<OrderCustomerDetail>>;
  list_order_discount: Array<Maybe<OrderDiscount>>;
  list_order_inline_item: Array<Maybe<OrderInlineItem>>;
  list_order_json: Array<Scalars['JSON']['output']>;
  list_order_operation_log: Array<Maybe<OrderOperationLog>>;
  list_order_operation_log_json: Scalars['JSON']['output'];
  list_order_payment: Array<Maybe<OrderPayment>>;
  list_order_rider: Array<Maybe<OrderRider>>;
  list_order_secondary_timeline: Array<Maybe<OrderSecondaryTimeline>>;
  list_order_tax: Array<Maybe<OrderTax>>;
  list_order_time_line: Array<Maybe<OrderTimeLine>>;
  list_outlet_mis: Array<Maybe<OutletMis>>;
  list_payment_mode: Array<Maybe<PaymentMode>>;
  list_permission: Array<Maybe<Permission>>;
  list_printer_config: Array<Maybe<PrinterConfig>>;
  list_printer_mapping: Array<Maybe<PrinterMapping>>;
  list_product: Array<Maybe<Product>>;
  list_product_image: Array<Maybe<ProductImage>>;
  list_product_mis: Array<Maybe<ProductMis>>;
  list_product_status_log: Array<Maybe<ProductStatusLog>>;
  list_product_translation: Array<Maybe<ProductTranslation>>;
  list_register: Array<Maybe<Register>>;
  list_register_shift: Array<Maybe<RegisterShift>>;
  list_report_template: Array<Maybe<ReportTemplate>>;
  list_role: Array<Maybe<Role>>;
  list_role_permission: Array<Maybe<RolePermission>>;
  list_schedule: Array<Maybe<Schedule>>;
  list_secondary_status: Array<Maybe<SecondaryStatus>>;
  list_section: Array<Maybe<Section>>;
  list_setting: Array<Maybe<Setting>>;
  list_settings_by_branch_id: Array<Maybe<BranchSettingResponse>>;
  list_staff: Array<Maybe<Staff>>;
  list_staff_company: Array<Maybe<StaffCompany>>;
  list_status: Array<Maybe<Status>>;
  list_sub_category: Array<Maybe<SubCategory>>;
  list_sub_category_mis: Array<Maybe<SubCategoryMis>>;
  list_sub_category_product: Array<Maybe<SubCategoryProduct>>;
  list_sub_company: Array<Maybe<SubCompany>>;
  list_sub_company_integration: Array<Maybe<SubCompanyIntegration>>;
  list_sub_company_integration_branch: Array<Maybe<SubCompanyIntegrationBranch>>;
  list_sub_section: Array<Maybe<SubSection>>;
  list_tag: Array<Maybe<Tag>>;
  list_tax: Array<Maybe<Tax>>;
  list_tax_rate: Array<Maybe<TaxRate>>;
  list_ticket: Array<Maybe<Ticket>>;
  list_ticket_analysis: Array<Maybe<TicketAnalysis>>;
  list_ticket_history: Array<Maybe<TicketHistory>>;
  list_time_slot: Array<Maybe<TimeSlot>>;
  list_user: Array<Maybe<User>>;
  list_user_branch: Array<Maybe<UserBranch>>;
  list_web_app_coupon: Array<Maybe<WebAppCoupon>>;
  list_website: Array<Maybe<Website>>;
  list_website_instance: Array<Maybe<WebsiteInstance>>;
  list_website_instance_brand: Array<Maybe<WebsiteInstanceBrand>>;
  login: AuthData;
  make_online_payment: PaymentResponse;
  menu_integration: Array<MenuBranchResponse>;
  online_order_polling: Array<Maybe<Scalars['JSON']['output']>>;
  order_polling: Array<Maybe<Scalars['JSON']['output']>>;
  outlet_status_integration: OutletStatusResponse;
  owner_daily_billing_insights: DailyBillingInsights;
  owner_monthly_goals_insights: ConsolidatedMonthlyGoalInsights;
  owner_monthly_source_comparison_insights: ConsolidatedSourceComparisonInsights;
  owner_order_list: Array<Scalars['JSON']['output']>;
  owner_payment_mode_insights: ConsolidatedPaymentModeInsights;
  owner_sales_insights: ConsolidatedSalesInsights;
  owner_source_distribution_insights: ConsolidatedSourceDistributionInsights;
  owner_top_categories_insights: ConsolidatedTopCategoriesInsights;
  owner_top_products_insights: ConsolidatedTopProductsInsights;
  owner_weekly_sales_insights: ConsolidatedWeeklySalesInsights;
  packaging_report: Scalars['JSON']['output'];
  phone_pe_s2s_callback: PaymentSuccessResponse;
  ping: Ping;
  place_customer_order: Scalars['Boolean']['output'];
  production_report: Scalars['JSON']['output'];
  redeem_coupon: TaskResponse;
  redeem_points: TaskResponse;
  remove_from_cart: CartResponse;
  send_ebill_whatsapp: Scalars['JSON']['output'];
  send_employee_coupon_codes: Scalars['JSON']['output'];
  sync_all: Scalars['JSON']['output'];
  sync_all_link: Scalars['JSON']['output'];
  sync_all_menu: Scalars['JSON']['output'];
  sync_menu_integration?: Maybe<Scalars['JSON']['output']>;
  task_result: Scalars['JSON']['output'];
  test_notification?: Maybe<Scalars['JSON']['output']>;
  update_item_quantity: CartResponse;
  verify_otp: Scalars['JSON']['output'];
  verify_passcode: Scalars['JSON']['output'];
};


export type QueryAdd_Free_DishArgs = {
  free_dish_id: Scalars['String']['input'];
};


export type QueryAdd_Order_Date_TimeArgs = {
  order_date: Scalars['Datetime']['input'];
  order_time: Scalars['Time']['input'];
};


export type QueryAdd_To_CartArgs = {
  branch_id: Scalars['String']['input'];
  children?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_type: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  variant_level_1_id?: InputMaybe<Scalars['String']['input']>;
  variant_level_2_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApply_CouponArgs = {
  coupon_id: Scalars['String']['input'];
};


export type QueryAssign_Address_To_CartArgs = {
  address_id: Scalars['String']['input'];
};


export type QueryAuthenticate_RedemptionArgs = {
  branch_id: Scalars['String']['input'];
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  customer_mobile: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
  points?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBranch_Add_OnsArgs = {
  branch_id: Scalars['String']['input'];
};


export type QueryBranch_CategoriesArgs = {
  branch_id: Scalars['String']['input'];
};


export type QueryBranch_Product_LogsArgs = {
  branch_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
};


export type QueryBranch_ProductsArgs = {
  branch_id: Scalars['String']['input'];
  category_id: Scalars['String']['input'];
};


export type QueryBulk_Export_MenuArgs = {
  menu_id: Scalars['String']['input'];
};


export type QueryCheck_AuthorizationArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  entity_id: Scalars['String']['input'];
  entity_name: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
  update_uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheck_Order_ChecksumArgs = {
  order_id: Scalars['String']['input'];
  update_uuid: Scalars['String']['input'];
};


export type QueryCustomer_CartArgs = {
  instance_id: Scalars['String']['input'];
  order_type: Scalars['String']['input'];
};


export type QueryCustomer_HistoryArgs = {
  customer_id: Scalars['UUID']['input'];
};


export type QueryCustomer_Send_OtpArgs = {
  phone: Scalars['String']['input'];
};


export type QueryCustomer_Validate_OtpArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  otp: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QueryGenerate_LinkArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  entity_id: Scalars['String']['input'];
  entity_name: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
};


export type QueryGet_Activity_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_AddressArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Aggregator_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_AuthArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_AuthorizationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Bank_AccountArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_BannerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Branch_BannerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Branch_ImageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Branch_IntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Branch_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Branch_SettingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Branch_ShiftArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Branch_Status_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_CartArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Category_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Category_ScheduleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Change_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_ChargeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Charge_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Closing_Shift_Slip_DataArgs = {
  branch_id: Scalars['String']['input'];
};


export type QueryGet_CompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_CouponArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Coupon_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_CustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Customer_AddressArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Customer_Loyalty_DetailsArgs = {
  branch_id: Scalars['String']['input'];
  customer_mobile: Scalars['String']['input'];
};


export type QueryGet_Customer_RatingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Customization_GroupArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Customization_Group_InlineArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Customization_Group_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Delivery_SlotArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_DiscountArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Discount_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Discount_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Discount_Product_XArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Discount_Product_YArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_EmployeeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Food_Type_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Free_DishArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Hourly_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Inline_ChargeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Inline_ItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_InstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Instance_GoalArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_IntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Integration_ActionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Integration_SettingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_MenuArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Menu_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Menu_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Menu_From_Branch_NameArgs = {
  branch_name: Scalars['String']['input'];
  instance: Scalars['String']['input'];
  order_type: Scalars['String']['input'];
};


export type QueryGet_Menu_From_IdArgs = {
  branch_id: Scalars['String']['input'];
  menu_id: Scalars['String']['input'];
};


export type QueryGet_Menu_From_Menu_IdArgs = {
  menu_id: Scalars['String']['input'];
};


export type QueryGet_Menu_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Menu_Sync_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Menu_Tax_RateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Mis_ReportArgs = {
  branch_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryGet_Mis_Report_UrlArgs = {
  branch_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryGet_OrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_CommentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_ComplaintArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_Customer_DetailArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_DiscountArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_Inline_ItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_JsonArgs = {
  id: Scalars['String']['input'];
};


export type QueryGet_Order_Operation_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_PaymentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_RiderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_Secondary_TimelineArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_TaxArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Order_Time_LineArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Outlet_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Payment_ModeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_PermissionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Printer_ConfigArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Printer_MappingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Product_From_IdArgs = {
  menu_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
};


export type QueryGet_Product_ImageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Product_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Product_Status_LogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Product_TranslationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_RegisterArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Register_ShiftArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Report_TemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_RoleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Role_PermissionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_ScheduleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Schedule_From_InstanceArgs = {
  instance: Scalars['String']['input'];
};


export type QueryGet_Secondary_StatusArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_SectionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_SettingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_StaffArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Staff_CompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_StatusArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Sub_CategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Sub_Category_MisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Sub_Category_ProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Sub_CompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Sub_Company_IntegrationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Sub_Company_Integration_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Sub_SectionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_TagArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Task_StatusArgs = {
  task_id: Scalars['String']['input'];
};


export type QueryGet_Tasks_StatusesArgs = {
  task_ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGet_TaxArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Tax_RateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_TicketArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Ticket_AnalysisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Ticket_HistoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Time_SlotArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_UserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_User_BranchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_User_Credit_OrdersArgs = {
  customer_id: Scalars['ID']['input'];
};


export type QueryGet_Web_App_CouponArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_WebsiteArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Website_InstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Website_Instance_BrandArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGet_Website_Instance_From_LocationArgs = {
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
};


export type QueryGet_Website_Instance_From_NameArgs = {
  location_name: Scalars['String']['input'];
};


export type QueryGet_Website_OffersArgs = {
  location_name: Scalars['String']['input'];
};


export type QueryHandle_AuthorizationArgs = {
  authorization_data: AuthorizationInput;
};


export type QueryIndex_MappingArgs = {
  index: Scalars['String']['input'];
};


export type QueryIndex_ReportArgs = {
  index: Scalars['String']['input'];
  report_input: ReportInput;
};


export type QueryIndex_Report_UrlArgs = {
  index: Scalars['String']['input'];
  report_input: ReportInput;
};


export type QueryInitiate_Order_Comment_NotificationArgs = {
  comment: Scalars['String']['input'];
  order_id: Scalars['String']['input'];
};


export type QueryInitiate_Payment_IntegrationArgs = {
  paymentInfo?: InputMaybe<PaymentData>;
};


export type QueryKds_PollingArgs = {
  initial: Scalars['Boolean']['input'];
  last_updated_on?: InputMaybe<Scalars['String']['input']>;
};


export type QueryList_Activity_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_AddressArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Aggregator_MisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_AuthArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_AuthorizationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Bank_AccountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_BannerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_BranchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Branch_BannerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Branch_ImageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Branch_IntegrationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Branch_ProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Branch_SettingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Branch_ShiftArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Branch_Status_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_CartArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_CategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Category_MisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Category_ScheduleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Change_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_ChargeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Charge_BranchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_CompanyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_CouponArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Coupon_BranchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_CustomerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Customer_AddressArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Customer_OrderArgs = {
  customer_id: Scalars['String']['input'];
};


export type QueryList_Customer_RatingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Customization_GroupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Customization_Group_InlineArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Customization_Group_ProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Delivery_SlotArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_DiscountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Discount_BranchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Discount_CategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Discount_Product_XArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Discount_Product_YArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_EmployeeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Food_Type_MisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Free_DishArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Hourly_MisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Inline_ChargeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Inline_ItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_InstanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Instance_GoalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_IntegrationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Integration_ActionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Integration_SettingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_MenuArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Menu_BranchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Menu_CategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Menu_ProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Menu_Sync_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Menu_Tax_RateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_OrderArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_By_IdsArgs = {
  order_ids: Array<Scalars['String']['input']>;
};


export type QueryList_Order_CommentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_ComplaintArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_Customer_DetailArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_DiscountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_Inline_ItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_JsonArgs = {
  aggregator_order_id?: InputMaybe<Scalars['String']['input']>;
  branch_id?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<Scalars['Int']['input']>;
  is_advance?: InputMaybe<Scalars['Boolean']['input']>;
  kot_number?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order_status?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
};


export type QueryList_Order_Operation_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_Operation_Log_JsonArgs = {
  order_id: Scalars['String']['input'];
};


export type QueryList_Order_PaymentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_RiderArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_Secondary_TimelineArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_TaxArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Order_Time_LineArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Outlet_MisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Payment_ModeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_PermissionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Printer_ConfigArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Printer_MappingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_ProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Product_ImageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Product_MisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Product_Status_LogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Product_TranslationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_RegisterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Register_ShiftArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Report_TemplateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_RoleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Role_PermissionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_ScheduleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Secondary_StatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_SectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_SettingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Settings_By_Branch_IdArgs = {
  branch_id: Scalars['ID']['input'];
};


export type QueryList_StaffArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Staff_CompanyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_StatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Sub_CategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Sub_Category_MisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Sub_Category_ProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Sub_CompanyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Sub_Company_IntegrationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Sub_Company_Integration_BranchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Sub_SectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_TagArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_TaxArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Tax_RateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_TicketArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Ticket_AnalysisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Ticket_HistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Time_SlotArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_UserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_User_BranchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Web_App_CouponArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_WebsiteArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Website_InstanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Website_Instance_BrandArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type QueryOnline_Order_PollingArgs = {
  initial: Scalars['Boolean']['input'];
  last_updated_on?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrder_PollingArgs = {
  initial: Scalars['Boolean']['input'];
  last_updated_on?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwner_Daily_Billing_InsightsArgs = {
  instance_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwner_Monthly_Goals_InsightsArgs = {
  instance_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwner_Monthly_Source_Comparison_InsightsArgs = {
  instance_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwner_Order_ListArgs = {
  from_date: Scalars['String']['input'];
  instance_id?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  to_date: Scalars['String']['input'];
};


export type QueryOwner_Payment_Mode_InsightsArgs = {
  from_date: Scalars['String']['input'];
  instance_id?: InputMaybe<Scalars['String']['input']>;
  to_date: Scalars['String']['input'];
};


export type QueryOwner_Sales_InsightsArgs = {
  instance_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwner_Source_Distribution_InsightsArgs = {
  from_date: Scalars['String']['input'];
  instance_id?: InputMaybe<Scalars['String']['input']>;
  to_date: Scalars['String']['input'];
};


export type QueryOwner_Top_Categories_InsightsArgs = {
  from_date: Scalars['String']['input'];
  instance_id?: InputMaybe<Scalars['String']['input']>;
  to_date: Scalars['String']['input'];
};


export type QueryOwner_Top_Products_InsightsArgs = {
  from_date: Scalars['String']['input'];
  instance_id?: InputMaybe<Scalars['String']['input']>;
  to_date: Scalars['String']['input'];
};


export type QueryOwner_Weekly_Sales_InsightsArgs = {
  instance_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPackaging_ReportArgs = {
  branch_id: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  order_end_date?: InputMaybe<Scalars['String']['input']>;
  order_start_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  time_slot?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlace_Customer_OrderArgs = {
  sectionId?: InputMaybe<Scalars['String']['input']>;
  subSectionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProduction_ReportArgs = {
  branch_id: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  order_end_date?: InputMaybe<Scalars['String']['input']>;
  order_start_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  time_slot?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRedeem_CouponArgs = {
  branch_id: Scalars['String']['input'];
  coupon_code: Scalars['String']['input'];
  customer_mobile: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


export type QueryRedeem_PointsArgs = {
  branch_id: Scalars['String']['input'];
  customer_mobile: Scalars['String']['input'];
  order_id?: InputMaybe<Scalars['String']['input']>;
  otp: Scalars['String']['input'];
  points: Scalars['String']['input'];
};


export type QueryRemove_From_CartArgs = {
  item_id: Scalars['String']['input'];
};


export type QuerySend_Ebill_WhatsappArgs = {
  order_id: Scalars['String']['input'];
};


export type QuerySend_Employee_Coupon_CodesArgs = {
  phone_number: Scalars['String']['input'];
};


export type QuerySync_AllArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySync_All_LinkArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySync_All_MenuArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySync_Menu_IntegrationArgs = {
  rows: Array<MenuSyncInput>;
};


export type QueryTask_ResultArgs = {
  task_id: Scalars['String']['input'];
};


export type QueryTest_NotificationArgs = {
  order_id: Scalars['String']['input'];
};


export type QueryUpdate_Item_QuantityArgs = {
  item_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};


export type QueryVerify_OtpArgs = {
  otp: Scalars['String']['input'];
};


export type QueryVerify_PasscodeArgs = {
  authorization_data: Scalars['JSON']['input'];
  passcode: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type Register = {
  __typename?: 'Register';
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  last_closing?: Maybe<Scalars['Datetime']['output']>;
  last_opening?: Maybe<Scalars['Datetime']['output']>;
  name: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type RegisterBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type RegisterIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterLast_ClosingArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type RegisterLast_OpeningArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type RegisterNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RegisterInput = {
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  last_closing?: InputMaybe<Scalars['Datetime']['input']>;
  last_opening?: InputMaybe<Scalars['Datetime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RegisterShift = {
  __typename?: 'RegisterShift';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  register_id: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type RegisterShiftCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterShiftCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type RegisterShiftIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterShiftRegister_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterShiftStatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterShiftSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RegisterShiftUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RegisterShiftInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  register_id?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum ReportDeliveryTime {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Midnight = 'MIDNIGHT',
  Morning = 'MORNING'
}

export type ReportFilters = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ReportFrequencyType {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ReportInput = {
  branches: Array<BranchReportInput>;
  filters?: InputMaybe<Array<InputMaybe<ReportFilters>>>;
  from_date: Scalars['String']['input'];
  pivot: PivotInput;
  to_date: Scalars['String']['input'];
};

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  branches: Scalars['JSON']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  delivery_month_day?: Maybe<Scalars['Float']['output']>;
  delivery_time: DeliveryTime;
  delivery_week_day?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  is_disabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  pivot?: Maybe<Scalars['JSON']['output']>;
  report_frequency_type: ReportFrequencyType;
  report_type: ReportType;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ReportTemplateCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ReportTemplateDelivery_Month_DayArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ReportTemplateDelivery_TimeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateDelivery_Week_DayArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type ReportTemplateDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateEmailsArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateIs_DisabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ReportTemplateNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateReport_Frequency_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateReport_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ReportTemplateInput = {
  branches?: InputMaybe<Scalars['JSON']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  delivery_month_day?: InputMaybe<Scalars['Float']['input']>;
  delivery_time?: InputMaybe<DeliveryTime>;
  delivery_week_day?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pivot?: InputMaybe<Scalars['JSON']['input']>;
  report_frequency_type?: InputMaybe<ReportFrequencyType>;
  report_type?: InputMaybe<ReportType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum ReportType {
  Activity = 'ACTIVITY',
  Item = 'ITEM',
  Order = 'ORDER'
}

export type Role = {
  __typename?: 'Role';
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<RolePermission>;
  role_permissions: Array<RolePermission>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  users: Array<User>;
};


export type RoleCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RoleCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RoleCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type RoleDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RoleIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RoleNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RoleSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RoleUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RoleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<RolePermissionInput>>>;
  role_permissions?: InputMaybe<Array<InputMaybe<RolePermissionInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  users?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  create: Scalars['Boolean']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  delete: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  permission?: Maybe<Permission>;
  permission_id: Scalars['UUID']['output'];
  read: Scalars['Boolean']['output'];
  role?: Maybe<Role>;
  role_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  update: Scalars['Boolean']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type RolePermissionCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RolePermissionCreateArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RolePermissionCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type RolePermissionDeleteArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RolePermissionIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RolePermissionPermission_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RolePermissionReadArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RolePermissionRole_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RolePermissionSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type RolePermissionUpdateArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RolePermissionUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RolePermissionInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  permission?: InputMaybe<PermissionInput>;
  permission_id?: InputMaybe<Scalars['UUID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<RoleInput>;
  role_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RolePermissionSyncResponse = {
  __typename?: 'RolePermissionSyncResponse';
  create: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  permission?: Maybe<PermissionSyncResponse>;
  permission_id?: Maybe<Scalars['UUID']['output']>;
  permission_name: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export type RoleResponse = {
  __typename?: 'RoleResponse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<PermissionResponse>>;
};

export type RoleSyncResponse = {
  __typename?: 'RoleSyncResponse';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role_permissions: Array<Maybe<RolePermissionSyncResponse>>;
};

export type SalesInsights = {
  __typename?: 'SalesInsights';
  discounts: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  netSales: Scalars['Float']['output'];
  orders: Scalars['Int']['output'];
  sales: Scalars['Float']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  time_slots: Array<TimeSlot>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type ScheduleCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ScheduleCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ScheduleCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type ScheduleDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ScheduleIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ScheduleNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ScheduleSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type ScheduleUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ScheduleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  time_slots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SecondaryStatus = {
  __typename?: 'SecondaryStatus';
  code: Scalars['String']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SecondaryStatusCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SecondaryStatusCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SecondaryStatusIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SecondaryStatusNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SecondaryStatusUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SecondaryStatusInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Section = {
  __typename?: 'Section';
  add_customer?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  menus: Array<MenuBranch>;
  name: Scalars['String']['output'];
  section_type: SectionType;
  service_type: ServiceType;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  sub_sections: Array<SubSection>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SectionAdd_CustomerArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SectionIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SectionNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionSection_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionService_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SectionUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SectionInput = {
  add_customer?: InputMaybe<Scalars['String']['input']>;
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  menus?: InputMaybe<Array<InputMaybe<MenuBranchInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  section_type?: InputMaybe<SectionType>;
  service_type?: InputMaybe<ServiceType>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_sections?: InputMaybe<Array<InputMaybe<SubSectionInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SectionResponse = {
  __typename?: 'SectionResponse';
  branch_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  section_type: Scalars['String']['output'];
  sub_sections?: Maybe<Array<Maybe<SubSectionResponse>>>;
};

export enum SectionType {
  Banquet = 'BANQUET',
  Catering = 'CATERING',
  Delivery = 'DELIVERY',
  DineIn = 'DINE_IN',
  Other = 'OTHER',
  Party = 'PARTY',
  Takeaway = 'TAKEAWAY'
}

export type SendOtpResponse = {
  __typename?: 'SendOtpResponse';
  customer?: Maybe<Scalars['String']['output']>;
  otp: Scalars['String']['output'];
};

export enum ServiceType {
  Basic = 'BASIC',
  Default = 'DEFAULT',
  Delivery = 'DELIVERY',
  FineDine = 'FINE_DINE',
  QuickService = 'QUICK_SERVICE',
  SelfService = 'SELF_SERVICE'
}

export type Setting = {
  __typename?: 'Setting';
  branch_settings: Array<BranchSetting>;
  choices: Scalars['List']['output'];
  column_type: ColumnType;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  setting_app_type: SettingAppType;
  setting_type: SettingType;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SettingColumn_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SettingCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SettingDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SettingIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SettingNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SettingSetting_App_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SettingSetting_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SettingUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum SettingAppType {
  Admin = 'ADMIN',
  Billing = 'BILLING',
  Global = 'GLOBAL',
  Link = 'LINK',
  Mobile = 'MOBILE'
}

export type SettingInput = {
  branch_settings?: InputMaybe<Array<InputMaybe<BranchSettingInput>>>;
  choices?: InputMaybe<Scalars['List']['input']>;
  column_type?: InputMaybe<ColumnType>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  setting_app_type?: InputMaybe<SettingAppType>;
  setting_type?: InputMaybe<SettingType>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SettingSyncResponse = {
  __typename?: 'SettingSyncResponse';
  branch_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instance_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  setting_app_type?: Maybe<Scalars['String']['output']>;
  setting_type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export enum SettingType {
  AutoCoverPopup = 'AUTO_COVER_POPUP',
  CustomerInfoPopupOnInitialLoad = 'CUSTOMER_INFO_POPUP_ON_INITIAL_LOAD',
  CustomerInfoPopupOnSettle = 'CUSTOMER_INFO_POPUP_ON_SETTLE',
  DefaultPrintLanguage = 'DEFAULT_PRINT_LANGUAGE',
  PrintOnlyTranslation = 'PRINT_ONLY_TRANSLATION',
  ShowTaxInclusivePrice = 'SHOW_TAX_INCLUSIVE_PRICE'
}

export type ShiftUserInput = {
  user_email: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
  user_name: Scalars['String']['input'];
};

export type SourceEntry = {
  __typename?: 'SourceEntry';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Staff = {
  __typename?: 'Staff';
  active: Scalars['Boolean']['output'];
  app_version?: Maybe<Scalars['String']['output']>;
  companies: Array<Company>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  jwt_invalidate?: Maybe<Scalars['Int']['output']>;
  last_app_open?: Maybe<Scalars['Datetime']['output']>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otp?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  profile_picture?: Maybe<Scalars['String']['output']>;
  profile_picture_encoding?: Maybe<Scalars['JSON']['output']>;
  role_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type StaffActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StaffApp_VersionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type StaffEmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffJwt_InvalidateArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type StaffLast_App_OpenArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type StaffMobile_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffOtpArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffPasscodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffPasswordArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffProfile_PictureArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffRole_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffTypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type StaffCompany = {
  __typename?: 'StaffCompany';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  staff_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type StaffCompanyCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffCompanyCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type StaffCompanyIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffCompanyStaff_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffCompanySub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StaffCompanyUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type StaffCompanyInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  staff_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type StaffInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<CompanyInput>>>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  jwt_invalidate?: InputMaybe<Scalars['Int']['input']>;
  last_app_open?: InputMaybe<Scalars['Datetime']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profile_picture?: InputMaybe<Scalars['String']['input']>;
  profile_picture_encoding?: InputMaybe<Scalars['JSON']['input']>;
  role_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Status = {
  __typename?: 'Status';
  code: Code;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type StatusCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StatusCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type StatusIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StatusNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type StatusUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum StatusCode {
  Accept = 'ACCEPT',
  Cancel = 'CANCEL',
  Deliver = 'DELIVER',
  Dispatch = 'DISPATCH',
  FoodReady = 'FOOD_READY',
  Receive = 'RECEIVE',
  RiderArrived = 'RIDER_ARRIVED',
  RiderAssigned = 'RIDER_ASSIGNED',
  Settle = 'SETTLE',
  Unsettle = 'UNSETTLE'
}

export type StatusInput = {
  code?: InputMaybe<Code>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCategory = {
  __typename?: 'SubCategory';
  category?: Maybe<Category>;
  category_id: Scalars['UUID']['output'];
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  products: Array<Product>;
  sub_category_products: Array<SubCategoryProduct>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SubCategoryCategory_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SubCategoryDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryIdentifierArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryImageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SubCategoryNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategorySub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCategoryInput = {
  category?: InputMaybe<CategoryInput>;
  category_id?: InputMaybe<Scalars['UUID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<ProductInput>>>;
  sub_category_products?: InputMaybe<Array<InputMaybe<SubCategoryProductInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCategoryMis = {
  __typename?: 'SubCategoryMIS';
  actual_no_of_bills: Scalars['Float']['output'];
  actual_sales: Scalars['Float']['output'];
  branch_id: Scalars['UUID']['output'];
  category_name?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  date: Scalars['Date']['output'];
  expected_no_of_bills: Scalars['Float']['output'];
  expected_sales: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SubCategoryMisActual_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SubCategoryMisActual_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SubCategoryMisBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryMisCategory_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryMisCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryMisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SubCategoryMisDateArgs = {
  greaterEqual?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  lesserEqual?: InputMaybe<Scalars['Date']['input']>;
  lesserThan?: InputMaybe<Scalars['Date']['input']>;
};


export type SubCategoryMisExpected_No_Of_BillsArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SubCategoryMisExpected_SalesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SubCategoryMisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryMisNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryMisSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryMisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCategoryMisInput = {
  actual_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  actual_sales?: InputMaybe<Scalars['Float']['input']>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expected_no_of_bills?: InputMaybe<Scalars['Float']['input']>;
  expected_sales?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCategoryProduct = {
  __typename?: 'SubCategoryProduct';
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  product_id: Scalars['UUID']['output'];
  subcategory?: Maybe<SubCategory>;
  subcategory_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SubCategoryProductCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SubCategoryProductIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryProductProduct_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryProductSubcategory_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCategoryProductUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCategoryProductInput = {
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  product?: InputMaybe<ProductInput>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  subcategory?: InputMaybe<SubCategoryInput>;
  subcategory_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCategoryType = {
  __typename?: 'SubCategoryType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SubCompany = {
  __typename?: 'SubCompany';
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['UUID']['output']>;
  bank_account?: Maybe<BankAccount>;
  bank_account_id?: Maybe<Scalars['UUID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  currency: Scalars['String']['output'];
  decimal_places: Scalars['Int']['output'];
  fssai_license_no?: Maybe<Scalars['String']['output']>;
  gstin?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_ondc_enabled?: Maybe<Scalars['Boolean']['output']>;
  long_desc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ondc_seller_id?: Maybe<Scalars['String']['output']>;
  pan?: Maybe<Scalars['String']['output']>;
  phone_code: Scalars['String']['output'];
  short_desc?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  time_zone_string: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SubCompanyAddress_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyBank_Account_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyContact_EmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyContact_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyContact_PhoneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SubCompanyCurrencyArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyDecimal_PlacesArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SubCompanyFssai_License_NoArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyGstinArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubCompanyIs_Ondc_EnabledArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubCompanyLong_DescArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyOndc_Seller_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyPanArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyPhone_CodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyShort_DescArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanySymbolArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyTime_ZoneArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyTime_Zone_StringArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCompanyInput = {
  address?: InputMaybe<AddressInput>;
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  bank_account?: InputMaybe<BankAccountInput>;
  bank_account_id?: InputMaybe<Scalars['UUID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  decimal_places?: InputMaybe<Scalars['Int']['input']>;
  fssai_license_no?: InputMaybe<Scalars['String']['input']>;
  gstin?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_ondc_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  long_desc?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ondc_seller_id?: InputMaybe<Scalars['String']['input']>;
  pan?: InputMaybe<Scalars['String']['input']>;
  phone_code?: InputMaybe<Scalars['String']['input']>;
  short_desc?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  time_zone_string?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCompanyIntegration = {
  __typename?: 'SubCompanyIntegration';
  authentication?: Maybe<Scalars['JSON']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  integration?: Maybe<Integration>;
  integration_id: Scalars['UUID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  static_token?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  sub_company_integration_branches: Array<SubCompanyIntegrationBranch>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SubCompanyIntegrationCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SubCompanyIntegrationIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubCompanyIntegrationStatic_TokenArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCompanyIntegrationBranch = {
  __typename?: 'SubCompanyIntegrationBranch';
  authentication?: Maybe<Scalars['JSON']['output']>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  sub_company_integration?: Maybe<SubCompanyIntegration>;
  sub_company_integration_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SubCompanyIntegrationBranchBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationBranchCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationBranchCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SubCompanyIntegrationBranchExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationBranchIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationBranchIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubCompanyIntegrationBranchSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationBranchSub_Company_Integration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubCompanyIntegrationBranchUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCompanyIntegrationBranchInput = {
  authentication?: InputMaybe<Scalars['JSON']['input']>;
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company_integration?: InputMaybe<SubCompanyIntegrationInput>;
  sub_company_integration_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCompanyIntegrationInput = {
  authentication?: InputMaybe<Scalars['JSON']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration?: InputMaybe<IntegrationInput>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  static_token?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company_integration_branches?: InputMaybe<Array<InputMaybe<SubCompanyIntegrationBranchInput>>>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubCompanyResponse = {
  __typename?: 'SubCompanyResponse';
  currency?: Maybe<Scalars['String']['output']>;
  decimal_places?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  time_zone_string?: Maybe<Scalars['String']['output']>;
};

export type SubSection = {
  __typename?: 'SubSection';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  section?: Maybe<Section>;
  section_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type SubSectionCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubSectionCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type SubSectionIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubSectionListing_SequenceArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type SubSectionNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubSectionSection_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubSectionSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type SubSectionUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubSectionInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  listing_sequence?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<SectionInput>;
  section_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SubSectionResponse = {
  __typename?: 'SubSectionResponse';
  id: Scalars['UUID']['output'];
  listing_sequence?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  section_id: Scalars['UUID']['output'];
};

export type SyncAllResponse = {
  __typename?: 'SyncAllResponse';
  branch_shifts: Scalars['JSON']['output'];
  branches: Array<BranchSyncResponse>;
  charges: Array<Maybe<ChargeBranchSyncResponse>>;
  company: CompanyResponse;
  delivery_slots: Array<DeliverySlotResponse>;
  discounts: Array<Maybe<DiscountBranchResponse>>;
  integrations: Array<IntegrationResponse>;
  payment_modes: Array<PaymentModeResponse>;
  printer_configs: Array<PrinterConfigResponse>;
  response: Scalars['String']['output'];
  roles: Array<RoleSyncResponse>;
  sections: Array<Maybe<SectionResponse>>;
  settings: Array<SettingSyncResponse>;
  sub_company: SubCompanyResponse;
  users: Array<UserSyncResponse>;
};

export type Tag = {
  __typename?: 'Tag';
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  tag_type: TagType;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type TagCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TagDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TagIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TagNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TagTag_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TagUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TagInput = {
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tag_type?: InputMaybe<TagType>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum TagType {
  Allergen = 'ALLERGEN',
  Flavour = 'FLAVOUR',
  Kind = 'KIND',
  Meat = 'MEAT',
  ServingInfo = 'SERVING_INFO',
  Tag = 'TAG'
}

export type TaskResponse = {
  __typename?: 'TaskResponse';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  task_id?: Maybe<Scalars['String']['output']>;
};

export enum TaskStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type Tax = {
  __typename?: 'Tax';
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  rates: Array<TaxRate>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type TaxCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TaxIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TaxIs_DefaultArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TaxNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxRateArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type TaxSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TaxInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rates?: InputMaybe<Array<InputMaybe<TaxRateInput>>>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum TaxOnType {
  Delivery = 'DELIVERY',
  Item = 'ITEM',
  Other = 'OTHER',
  Packaging = 'PACKAGING',
  Service = 'SERVICE'
}

export type TaxRate = {
  __typename?: 'TaxRate';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_menu_specific: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  tax?: Maybe<Tax>;
  tax_id: Scalars['UUID']['output'];
  tax_type: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  value: Scalars['Float']['output'];
};


export type TaxRateCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxRateCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TaxRateIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxRateIs_Menu_SpecificArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TaxRateNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxRateSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxRateTax_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxRateTax_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TaxRateUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TaxRateValueArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type TaxRateInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_menu_specific?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  tax?: InputMaybe<TaxInput>;
  tax_id?: InputMaybe<Scalars['UUID']['input']>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum TaxResponsibleType {
  Aggregator = 'AGGREGATOR',
  Merchant = 'MERCHANT'
}

export type Ticket = {
  __typename?: 'Ticket';
  action_name?: Maybe<ActionName>;
  actual_completion_date?: Maybe<Scalars['Datetime']['output']>;
  actual_start_date?: Maybe<Scalars['Datetime']['output']>;
  analysis?: Maybe<TicketAnalysis>;
  application_type?: Maybe<ApplicationType>;
  assigned_to?: Maybe<Staff>;
  assigned_to_id?: Maybe<Scalars['UUID']['output']>;
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['UUID']['output']>;
  bug_type?: Maybe<BugType>;
  client?: Maybe<SubCompany>;
  client_id: Scalars['UUID']['output'];
  completion_date?: Maybe<Scalars['Datetime']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  deployment_date?: Maybe<Scalars['Datetime']['output']>;
  deployment_verified_by?: Maybe<Staff>;
  deployment_verified_by_id?: Maybe<Scalars['UUID']['output']>;
  description: Scalars['String']['output'];
  history: Array<TicketHistory>;
  id: Scalars['UUID']['output'];
  integration?: Maybe<Integration>;
  integration_id?: Maybe<Scalars['UUID']['output']>;
  reported_by?: Maybe<Staff>;
  reported_by_id: Scalars['UUID']['output'];
  resolution?: Maybe<Scalars['String']['output']>;
  root_cause?: Maybe<Scalars['String']['output']>;
  screenshot?: Maybe<Scalars['List']['output']>;
  start_date: Scalars['Datetime']['output'];
  ticket_no: Scalars['Int']['output'];
  ticket_status: TicketStatus;
  ticket_type: TicketType;
  title: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type TicketAction_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketActual_Completion_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketActual_Start_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketApplication_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketAssigned_To_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketBug_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketClient_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketCompletion_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketDeployment_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketDeployment_Verified_By_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketIntegration_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketReported_By_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketResolutionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketRoot_CauseArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketStart_DateArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketTicket_NoArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type TicketTicket_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketTicket_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketTitleArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TicketAnalysis = {
  __typename?: 'TicketAnalysis';
  actual_time?: Maybe<Scalars['Int']['output']>;
  allotted_time?: Maybe<Scalars['Int']['output']>;
  client_feedback?: Maybe<Scalars['String']['output']>;
  client_rating?: Maybe<Scalars['Int']['output']>;
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_repeat_bug: Scalars['Boolean']['output'];
  test_failed_count?: Maybe<Scalars['Int']['output']>;
  ticket?: Maybe<Ticket>;
  ticket_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type TicketAnalysisActual_TimeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type TicketAnalysisAllotted_TimeArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type TicketAnalysisClient_FeedbackArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketAnalysisClient_RatingArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type TicketAnalysisCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketAnalysisIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketAnalysisIs_Repeat_BugArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TicketAnalysisTest_Failed_CountArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type TicketAnalysisTicket_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketAnalysisUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TicketAnalysisInput = {
  actual_time?: InputMaybe<Scalars['Int']['input']>;
  allotted_time?: InputMaybe<Scalars['Int']['input']>;
  client_feedback?: InputMaybe<Scalars['String']['input']>;
  client_rating?: InputMaybe<Scalars['Int']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_repeat_bug?: InputMaybe<Scalars['Boolean']['input']>;
  test_failed_count?: InputMaybe<Scalars['Int']['input']>;
  ticket?: InputMaybe<TicketInput>;
  ticket_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TicketHistory = {
  __typename?: 'TicketHistory';
  comment?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Staff>;
  created_by_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  ticket?: Maybe<Ticket>;
  ticket_id: Scalars['UUID']['output'];
  ticket_status: TicketStatus;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type TicketHistoryCommentArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketHistoryCreated_By_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketHistoryCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TicketHistoryIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketHistoryTicket_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketHistoryTicket_StatusArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TicketHistoryUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TicketHistoryInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<StaffInput>;
  created_by_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  ticket?: InputMaybe<TicketInput>;
  ticket_id?: InputMaybe<Scalars['UUID']['input']>;
  ticket_status?: InputMaybe<TicketStatus>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TicketInput = {
  action_name?: InputMaybe<ActionName>;
  actual_completion_date?: InputMaybe<Scalars['Datetime']['input']>;
  actual_start_date?: InputMaybe<Scalars['Datetime']['input']>;
  analysis?: InputMaybe<TicketAnalysisInput>;
  application_type?: InputMaybe<ApplicationType>;
  assigned_to?: InputMaybe<StaffInput>;
  assigned_to_id?: InputMaybe<Scalars['UUID']['input']>;
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  bug_type?: InputMaybe<BugType>;
  client?: InputMaybe<SubCompanyInput>;
  client_id?: InputMaybe<Scalars['UUID']['input']>;
  completion_date?: InputMaybe<Scalars['Datetime']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  deployment_date?: InputMaybe<Scalars['Datetime']['input']>;
  deployment_verified_by?: InputMaybe<StaffInput>;
  deployment_verified_by_id?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Array<InputMaybe<TicketHistoryInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  integration?: InputMaybe<IntegrationInput>;
  integration_id?: InputMaybe<Scalars['UUID']['input']>;
  reported_by?: InputMaybe<StaffInput>;
  reported_by_id?: InputMaybe<Scalars['UUID']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  root_cause?: InputMaybe<Scalars['String']['input']>;
  screenshot?: InputMaybe<Scalars['List']['input']>;
  start_date?: InputMaybe<Scalars['Datetime']['input']>;
  ticket_no?: InputMaybe<Scalars['Int']['input']>;
  ticket_status?: InputMaybe<TicketStatus>;
  ticket_type?: InputMaybe<TicketType>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum TicketStatus {
  Closed = 'CLOSED',
  Deployed = 'DEPLOYED',
  InProgress = 'IN_PROGRESS',
  InTesting = 'IN_TESTING',
  Pending = 'PENDING',
  TestFailed = 'TEST_FAILED',
  TestPassed = 'TEST_PASSED'
}

export enum TicketType {
  Bug = 'BUG',
  ClientRequest = 'CLIENT_REQUEST',
  Enhancement = 'ENHANCEMENT',
  Feature = 'FEATURE',
  Roadmap = 'ROADMAP'
}

export type TimeSlot = {
  __typename?: 'TimeSlot';
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  day: Scalars['Int']['output'];
  end_time: Scalars['Time']['output'];
  id: Scalars['UUID']['output'];
  schedule?: Maybe<Schedule>;
  schedule_id: Scalars['UUID']['output'];
  start_time: Scalars['Time']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type TimeSlotCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TimeSlotCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type TimeSlotDayArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type TimeSlotEnd_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type TimeSlotIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TimeSlotSchedule_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TimeSlotStart_TimeArgs = {
  greaterEqual?: InputMaybe<Scalars['Time']['input']>;
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  lesserEqual?: InputMaybe<Scalars['Time']['input']>;
  lesserThan?: InputMaybe<Scalars['Time']['input']>;
};


export type TimeSlotSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type TimeSlotUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TimeSlotInput = {
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  end_time?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
  schedule_id?: InputMaybe<Scalars['UUID']['input']>;
  start_time?: InputMaybe<Scalars['Time']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum UomType {
  Dozen = 'DOZEN',
  Gram = 'GRAM',
  Kilogram = 'KILOGRAM',
  Litre = 'LITRE',
  Millilitre = 'MILLILITRE',
  Tonne = 'TONNE',
  Unit = 'UNIT'
}

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  app_version?: Maybe<Scalars['String']['output']>;
  branches: Array<Branch>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  fcm_token?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  instance?: Maybe<Instance>;
  instance_id: Scalars['UUID']['output'];
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  is_outlet_login?: Maybe<Scalars['Boolean']['output']>;
  jwt_invalidate?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_app_open?: Maybe<Scalars['Datetime']['output']>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otp?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  profile_picture?: Maybe<Scalars['String']['output']>;
  profile_picture_encoding?: Maybe<Scalars['JSON']['output']>;
  receive_authorization_request?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Role>;
  role_id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
};


export type UserActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserApp_VersionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type UserDevice_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserEmailArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserExternal_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserFcm_TokenArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserIs_AdminArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserIs_Outlet_LoginArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserJwt_InvalidateArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type UserLanguageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserLast_App_OpenArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type UserMobile_NumberArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserOtpArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserPasscodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserPasswordArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserProfile_PictureArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserReceive_Authorization_RequestArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserRole_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UserBranch = {
  __typename?: 'UserBranch';
  branch?: Maybe<Branch>;
  branch_id: Scalars['UUID']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  user_id: Scalars['UUID']['output'];
};


export type UserBranchBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserBranchCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserBranchCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type UserBranchIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserBranchSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type UserBranchUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type UserBranchUser_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserBranchInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  branches?: InputMaybe<Array<InputMaybe<BranchInput>>>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instance?: InputMaybe<InstanceInput>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_outlet_login?: InputMaybe<Scalars['Boolean']['input']>;
  jwt_invalidate?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_app_open?: InputMaybe<Scalars['Datetime']['input']>;
  mobile_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profile_picture?: InputMaybe<Scalars['String']['input']>;
  profile_picture_encoding?: InputMaybe<Scalars['JSON']['input']>;
  receive_authorization_request?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<RoleInput>;
  role_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  company_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instance_id: Scalars['String']['output'];
  jwt_token?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mobile_number: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: RoleResponse;
  sub_company_id: Scalars['String']['output'];
};

export type UserSyncResponse = {
  __typename?: 'UserSyncResponse';
  branches: Array<Maybe<BranchSyncResponse>>;
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  instance_id: Scalars['UUID']['output'];
  jwt_token?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  language?: Maybe<Scalars['String']['output']>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  passcode?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserSyncRole>;
  role_id: Scalars['UUID']['output'];
};

export type UserSyncRole = {
  __typename?: 'UserSyncRole';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<PermissionSyncResponse>>;
};

export type VariantType = {
  __typename?: 'VariantType';
  id: Scalars['String']['output'];
  is_enabled: Scalars['Boolean']['output'];
  menu_id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  product?: Maybe<CustomProductType>;
  product_id: Scalars['String']['output'];
};

export type WebAppCoupon = {
  __typename?: 'WebAppCoupon';
  code: Scalars['String']['output'];
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  discount?: Maybe<Discount>;
  discount_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  is_active: Scalars['Boolean']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  website_instance?: Maybe<WebsiteInstance>;
  website_instance_id: Scalars['UUID']['output'];
};


export type WebAppCouponCodeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebAppCouponCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebAppCouponCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebAppCouponDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebAppCouponDiscount_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebAppCouponIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebAppCouponIs_ActiveArgs = {
  bool?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WebAppCouponSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebAppCouponUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebAppCouponWebsite_Instance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type WebAppCouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<DiscountInput>;
  discount_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  website_instance?: InputMaybe<WebsiteInstanceInput>;
  website_instance_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type Website = {
  __typename?: 'Website';
  banners: Array<Banner>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  fb_pixel?: Maybe<Scalars['String']['output']>;
  g_tag?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  map_key?: Maybe<Scalars['String']['output']>;
  map_type?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  razorpay_acc_id?: Maybe<Scalars['String']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  url: Scalars['String']['output'];
  website_instances: Array<WebsiteInstance>;
};


export type WebsiteCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebsiteDescriptionArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteDomainArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteFb_PixelArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteG_TagArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteImageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteMap_KeyArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteMap_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteNameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteRazorpay_Acc_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebsiteUrlArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type WebsiteInput = {
  banners?: InputMaybe<Array<InputMaybe<BannerInput>>>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  fb_pixel?: InputMaybe<Scalars['String']['input']>;
  g_tag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  map_key?: InputMaybe<Scalars['String']['input']>;
  map_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  razorpay_acc_id?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  website_instances?: InputMaybe<Array<InputMaybe<WebsiteInstanceInput>>>;
};

export type WebsiteInstance = {
  __typename?: 'WebsiteInstance';
  banners: Array<Banner>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  delivery_radius: Scalars['Float']['output'];
  free_dishes: Array<FreeDish>;
  geom: Geom;
  id: Scalars['UUID']['output'];
  instance?: Maybe<Instance>;
  instance_id: Scalars['UUID']['output'];
  location_name?: Maybe<Scalars['String']['output']>;
  merchant_id?: Maybe<Scalars['String']['output']>;
  ordering_type: Scalars['String']['output'];
  razorpay_acc_id?: Maybe<Scalars['String']['output']>;
  salt_index?: Maybe<Scalars['String']['output']>;
  salt_key?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Schedule>;
  schedule_id?: Maybe<Scalars['UUID']['output']>;
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  web_app_coupons: Array<WebAppCoupon>;
  website?: Maybe<Website>;
  website_id: Scalars['UUID']['output'];
  website_instance_brands: Array<WebsiteInstanceBrand>;
};


export type WebsiteInstanceCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebsiteInstanceDelivery_RadiusArgs = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterEqual?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lesserEqual?: InputMaybe<Scalars['Float']['input']>;
  lesserThan?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type WebsiteInstanceIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceInstance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceLocation_NameArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceMerchant_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceOrdering_TypeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceRazorpay_Acc_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceSalt_IndexArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceSalt_KeyArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceSchedule_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebsiteInstanceWebsite_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type WebsiteInstanceBrand = {
  __typename?: 'WebsiteInstanceBrand';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['UUID']['output']>;
  company?: Maybe<Company>;
  company_id: Scalars['UUID']['output'];
  cover_image: Scalars['String']['output'];
  cover_image_large?: Maybe<Scalars['String']['output']>;
  cover_text: Scalars['String']['output'];
  cover_text_large: Scalars['String']['output'];
  created_on?: Maybe<Scalars['Datetime']['output']>;
  delivery_menu_id?: Maybe<Scalars['UUID']['output']>;
  dine_menu_id?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  offer_text: Scalars['String']['output'];
  sub_company?: Maybe<SubCompany>;
  sub_company_id: Scalars['UUID']['output'];
  takeaway_menu_id?: Maybe<Scalars['UUID']['output']>;
  updated_on?: Maybe<Scalars['Datetime']['output']>;
  website_instance?: Maybe<WebsiteInstance>;
  website_instance_id: Scalars['UUID']['output'];
};


export type WebsiteInstanceBrandBranch_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandCompany_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandCover_ImageArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandCover_Image_LargeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandCover_TextArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandCover_Text_LargeArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandCreated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebsiteInstanceBrandDelivery_Menu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandDine_Menu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandIdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandOffer_TextArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandSub_Company_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandTakeaway_Menu_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};


export type WebsiteInstanceBrandUpdated_OnArgs = {
  greaterEqual?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  lesserEqual?: InputMaybe<Scalars['Datetime']['input']>;
  lesserThan?: InputMaybe<Scalars['Datetime']['input']>;
};


export type WebsiteInstanceBrandWebsite_Instance_IdArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equal?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type WebsiteInstanceBrandInput = {
  branch?: InputMaybe<BranchInput>;
  branch_id?: InputMaybe<Scalars['UUID']['input']>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  cover_image?: InputMaybe<Scalars['String']['input']>;
  cover_image_large?: InputMaybe<Scalars['String']['input']>;
  cover_text?: InputMaybe<Scalars['String']['input']>;
  cover_text_large?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  delivery_menu_id?: InputMaybe<Scalars['UUID']['input']>;
  dine_menu_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  offer_text?: InputMaybe<Scalars['String']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  takeaway_menu_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  website_instance?: InputMaybe<WebsiteInstanceInput>;
  website_instance_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type WebsiteInstanceBrandType = {
  __typename?: 'WebsiteInstanceBrandType';
  cover_image: Scalars['String']['output'];
  cover_image_large: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offer_text: Scalars['String']['output'];
};

export type WebsiteInstanceBrands = {
  __typename?: 'WebsiteInstanceBrands';
  branch_id: Scalars['String']['output'];
  branch_location: Scalars['String']['output'];
  branch_name: Scalars['String']['output'];
  branch_phone?: Maybe<Scalars['String']['output']>;
  cover_image: Scalars['String']['output'];
  cover_image_large: Scalars['String']['output'];
  cover_text: Scalars['String']['output'];
  cover_text_large: Scalars['String']['output'];
  delivery_menu_id: Scalars['String']['output'];
  dine_menu_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  offer_image: Scalars['String']['output'];
  takeaway_menu_id: Scalars['String']['output'];
};

export type WebsiteInstanceInput = {
  banners?: InputMaybe<Array<InputMaybe<BannerInput>>>;
  company?: InputMaybe<CompanyInput>;
  company_id?: InputMaybe<Scalars['UUID']['input']>;
  created_on?: InputMaybe<Scalars['Datetime']['input']>;
  delivery_radius?: InputMaybe<Scalars['Float']['input']>;
  free_dishes?: InputMaybe<Array<InputMaybe<FreeDishInput>>>;
  geom?: InputMaybe<GeomInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  instance?: InputMaybe<InstanceInput>;
  instance_id?: InputMaybe<Scalars['UUID']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  merchant_id?: InputMaybe<Scalars['String']['input']>;
  ordering_type?: InputMaybe<Scalars['String']['input']>;
  razorpay_acc_id?: InputMaybe<Scalars['String']['input']>;
  salt_index?: InputMaybe<Scalars['String']['input']>;
  salt_key?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
  schedule_id?: InputMaybe<Scalars['UUID']['input']>;
  sub_company?: InputMaybe<SubCompanyInput>;
  sub_company_id?: InputMaybe<Scalars['UUID']['input']>;
  updated_on?: InputMaybe<Scalars['Datetime']['input']>;
  web_app_coupons?: InputMaybe<Array<InputMaybe<WebAppCouponInput>>>;
  website?: InputMaybe<WebsiteInput>;
  website_id?: InputMaybe<Scalars['UUID']['input']>;
  website_instance_brands?: InputMaybe<Array<InputMaybe<WebsiteInstanceBrandInput>>>;
};

export type WebsiteInstanceResponse = {
  __typename?: 'WebsiteInstanceResponse';
  free_dishes?: Maybe<Array<Maybe<FreeDishes>>>;
  id: Scalars['String']['output'];
  instance_id: Scalars['String']['output'];
  latitude: Scalars['String']['output'];
  location_name: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  ordering_type: Scalars['String']['output'];
  urls: Array<Maybe<Scalars['String']['output']>>;
  website_instance_brands: Array<WebsiteInstanceBrands>;
};

export type WebsiteOffersResponse = {
  __typename?: 'WebsiteOffersResponse';
  free_dishes?: Maybe<Array<Maybe<FreeDishes>>>;
  web_app_coupons?: Maybe<Array<Maybe<WebAppCoupon>>>;
};

export type WeeklySalesInsights = {
  __typename?: 'WeeklySalesInsights';
  friday: Scalars['Float']['output'];
  monday: Scalars['Float']['output'];
  saturday: Scalars['Float']['output'];
  sunday: Scalars['Float']['output'];
  thursday: Scalars['Float']['output'];
  tuesday: Scalars['Float']['output'];
  wednesday: Scalars['Float']['output'];
};

export type Get_Tasks_Statuses_Response = {
  __typename?: 'get_tasks_statuses_response';
  data?: Maybe<Scalars['JSON']['output']>;
};

export type Task_Status_Response = {
  __typename?: 'task_status_response';
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};
